
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("3osen", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18bbd4dc7d8b1f4333c1c99573687157>>
 * @codegenCommand yarn build tokens
 */ const $e1e2fd2f7618d085$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.button.hovered': '--ds-button-hovered',
    'motion.button.pressed': '--ds-button-pressed',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.listitem.hovered': '--ds-listitem-hovered',
    'motion.listitem.pressed': '--ds-listitem-pressed',
    'motion.listitem.selected': '--ds-listitem-selected',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.panel.enter': '--ds-panel-enter',
    'motion.panel.exit': '--ds-panel-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.code.added.highlight': '--ds-background-code-added-highlight',
    'color.background.code.added.line': '--ds-background-code-added-line',
    'color.background.code.default': '--ds-background-code-default',
    'color.background.code.gutter': '--ds-background-code-gutter',
    'color.background.code.highlight': '--ds-background-code-highlight',
    'color.background.code.removed.highlight': '--ds-background-code-removed-highlight',
    'color.background.code.removed.line': '--ds-background-code-removed-line',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.code': '--ds-border-code',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.code.accent.1': '--ds-text-code-accent-1',
    'color.text.code.accent.2': '--ds-text-code-accent-2',
    'color.text.code.comments': '--ds-text-code-comments',
    'color.text.code.default': '--ds-text-code-default',
    'color.text.code.functions': '--ds-text-code-functions',
    'color.text.code.gutter': '--ds-text-code-gutter',
    'color.text.code.keywords': '--ds-text-code-keywords',
    'color.text.code.numbers': '--ds-text-code-numbers',
    'color.text.code.operators': '--ds-text-code-operators',
    'color.text.code.strings': '--ds-text-code-strings',
    'color.text.code.tags': '--ds-text-code-tags',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.container.hovered': '--ds-surface-container-hovered',
    'elevation.surface.container.pressed': '--ds-surface-container-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $e1e2fd2f7618d085$export$2e2bcd8739ae039 = $e1e2fd2f7618d085$var$tokens;
module.exports["default"] = $e1e2fd2f7618d085$export$2e2bcd8739ae039;

});

parcelRegister("jTt8P", function(module, exports) {
function $18a06150eaa63be0$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $18a06150eaa63be0$export$df3f009e3d155b20(adf, visitors) {
    if (!$18a06150eaa63be0$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $18a06150eaa63be0$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $18a06150eaa63be0$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $18a06150eaa63be0$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}
module.exports["traverse"] = $18a06150eaa63be0$export$df3f009e3d155b20;

});

parcelRegister("3xuv0", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $jDAs4 = parcelRequire("jDAs4");

var $kHCzj = parcelRequire("kHCzj");

var $chuMh = parcelRequire("chuMh");

var $hwsSH = parcelRequire("hwsSH");

var $3uRAA = parcelRequire("3uRAA");

var $f3bB0 = parcelRequire("f3bB0");

var $2fsTz = parcelRequire("2fsTz");

var $jKue6 = parcelRequire("jKue6");

var $39Puj = parcelRequire("39Puj");


var $4XbfY = parcelRequire("4XbfY");

const $823191aec7218c4e$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $823191aec7218c4e$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $823191aec7218c4e$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $823191aec7218c4e$var$defaultAllowOverrideBehaviour;
        default:
            return $823191aec7218c4e$var$defaultDoNotAllowOverrideBehaviour;
    }
};



var $islpn = parcelRequire("islpn");


var $jTt8P = parcelRequire("jTt8P");

function $66bbf8ce2485ed62$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $66bbf8ce2485ed62$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}


const $c16e35fabc142550$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $c16e35fabc142550$export$48b382180baf8e88(json, options = {}) {
    const { keepNestedTables: keepNestedTables = false } = options;
    const sanitizedJSON = (0, $jTt8P.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $66bbf8ce2485ed62$export$8cae9126fc577085)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($c16e35fabc142550$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $islpn.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: (node)=>{
            if ($c16e35fabc142550$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $islpn.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        panel_c1: (node)=>({
                ...node,
                type: 'panel'
            }),
        emoji: (0, $66bbf8ce2485ed62$export$8cae9126fc577085),
        mention: (0, $66bbf8ce2485ed62$export$8cae9126fc577085),
        date: (0, $66bbf8ce2485ed62$export$8cae9126fc577085),
        hardBreak: (0, $66bbf8ce2485ed62$export$9bf001d8ef76e497),
        inlineCard: (0, $66bbf8ce2485ed62$export$8cae9126fc577085)
    });
    return sanitizedJSON;
}


var $c8e6f62fa1fff61a$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $c8e6f62fa1fff61a$var$isType = (type)=>(node)=>node.type.name === type;
// Create a Set of node types that should have empty attrs removed
const $c8e6f62fa1fff61a$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
const $c8e6f62fa1fff61a$var$isCodeBlock = $c8e6f62fa1fff61a$var$isType('codeBlock');
const $c8e6f62fa1fff61a$var$isMediaNode = $c8e6f62fa1fff61a$var$isType('media');
const $c8e6f62fa1fff61a$var$isMediaInline = $c8e6f62fa1fff61a$var$isType('mediaInline');
const $c8e6f62fa1fff61a$var$isMediaSingleNode = $c8e6f62fa1fff61a$var$isType('mediaSingle');
const $c8e6f62fa1fff61a$var$isMentionNode = $c8e6f62fa1fff61a$var$isType('mention');
const $c8e6f62fa1fff61a$var$isParagraph = $c8e6f62fa1fff61a$var$isType('paragraph');
const $c8e6f62fa1fff61a$var$isHeading = $c8e6f62fa1fff61a$var$isType('heading');
const $c8e6f62fa1fff61a$var$isTable = $c8e6f62fa1fff61a$var$isType('table');
const $c8e6f62fa1fff61a$var$isTableCell = $c8e6f62fa1fff61a$var$isType('tableCell');
const $c8e6f62fa1fff61a$var$isTableHeader = $c8e6f62fa1fff61a$var$isType('tableHeader');
const $c8e6f62fa1fff61a$var$isLinkMark = $c8e6f62fa1fff61a$var$isType('link');
const $c8e6f62fa1fff61a$var$isUnsupportedMark = $c8e6f62fa1fff61a$var$isType('unsupportedMark');
const $c8e6f62fa1fff61a$var$isUnsupportedNodeAttributeMark = $c8e6f62fa1fff61a$var$isType('unsupportedNodeAttribute');
const $c8e6f62fa1fff61a$var$isExpand = $c8e6f62fa1fff61a$var$isType('expand');
const $c8e6f62fa1fff61a$var$isNestedExpand = $c8e6f62fa1fff61a$var$isType('nestedExpand');
const $c8e6f62fa1fff61a$var$isUnsupportedNode = (node)=>$c8e6f62fa1fff61a$var$isType('unsupportedBlock')(node) || $c8e6f62fa1fff61a$var$isType('unsupportedInline')(node);
const $c8e6f62fa1fff61a$var$isDataConsumer = $c8e6f62fa1fff61a$var$isType('dataConsumer');
const $c8e6f62fa1fff61a$var$isFragmentMark = $c8e6f62fa1fff61a$var$isType('fragment');
const $c8e6f62fa1fff61a$var$isHardBreak = $c8e6f62fa1fff61a$var$isType('hardBreak');
const $c8e6f62fa1fff61a$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $c8e6f62fa1fff61a$var$emptyDoc = $c8e6f62fa1fff61a$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c8e6f62fa1fff61a$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $c8e6f62fa1fff61a$var$filterNull(current);
    }
    return output;
};
const $c8e6f62fa1fff61a$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $823191aec7218c4e$export$28e4e3c024cce988)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $c8e6f62fa1fff61a$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
const $c8e6f62fa1fff61a$export$54fd2c36b5cc6731 = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($c8e6f62fa1fff61a$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($c8e6f62fa1fff61a$var$isMediaNode(node)) obj.attrs = (0, $2fsTz.toJSON)(node).attrs;
    else if ($c8e6f62fa1fff61a$var$isMediaSingleNode(node)) obj.attrs = (0, $f3bB0.toJSON)(node).attrs;
    else if ($c8e6f62fa1fff61a$var$isMediaInline(node)) obj.attrs = (0, $2fsTz.toJSON)(node).attrs;
    else if ($c8e6f62fa1fff61a$var$isMentionNode(node)) obj.attrs = (0, $jKue6.toJSON)(node).attrs;
    else if ($c8e6f62fa1fff61a$var$isCodeBlock(node)) obj.attrs = (0, $jDAs4.toJSON)(node).attrs;
    else if ($c8e6f62fa1fff61a$var$isTable(node)) obj.attrs = (0, $39Puj.tableToJSON)(node).attrs;
    else if ($c8e6f62fa1fff61a$var$isTableCell(node)) obj.attrs = (0, $39Puj.toJSONTableCell)(node).attrs;
    else if ($c8e6f62fa1fff61a$var$isTableHeader(node)) obj.attrs = (0, $39Puj.toJSONTableHeader)(node).attrs;
    else if ($c8e6f62fa1fff61a$var$isExpand(node) || $c8e6f62fa1fff61a$var$isNestedExpand(node)) obj.attrs = (0, $chuMh.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $c8e6f62fa1fff61a$var$filterNull(obj.attrs);
    if ($c8e6f62fa1fff61a$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    if ($c8e6f62fa1fff61a$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $c8e6f62fa1fff61a$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($c8e6f62fa1fff61a$export$54fd2c36b5cc6731(child, mentionMap));
    });
    if ($c8e6f62fa1fff61a$var$isParagraph(node) || $c8e6f62fa1fff61a$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($c8e6f62fa1fff61a$var$isUnsupportedMark(mark)) return $c8e6f62fa1fff61a$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($c8e6f62fa1fff61a$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($c8e6f62fa1fff61a$var$isLinkMark(mark)) return (0, $3uRAA.toJSON)(mark);
            else if ($c8e6f62fa1fff61a$var$isDataConsumer(mark)) {
                const serialised = (0, $kHCzj.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($c8e6f62fa1fff61a$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $hwsSH.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($c8e6f62fa1fff61a$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$c8e6f62fa1fff61a$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
class $c8e6f62fa1fff61a$export$98cb1d9308d0944d {
    encode(node, options = {}) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $c16e35fabc142550$export$48b382180baf8e88)($c8e6f62fa1fff61a$export$54fd2c36b5cc6731(child, this.mentionMap), options));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(content, $c8e6f62fa1fff61a$var$emptyDoc.content)) return $c8e6f62fa1fff61a$var$createDocFromContent([]);
        return $c8e6f62fa1fff61a$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $4XbfY.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($c8e6f62fa1fff61a$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
   * This method is used to encode a single node
   */ encodeNode(node) {
        return (0, $c16e35fabc142550$export$48b382180baf8e88)($c8e6f62fa1fff61a$export$54fd2c36b5cc6731(node, this.mentionMap));
    }
    /**
   * Creates a new JSONTransformer instance.
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ constructor(schema = (0, $4XbfY.defaultSchema), mentionMap){
        this.schema = void 0;
        this.mentionMap = void 0;
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
}
module.exports["toJSON"] = $c8e6f62fa1fff61a$export$54fd2c36b5cc6731;
module.exports["JSONTransformer"] = $c8e6f62fa1fff61a$export$98cb1d9308d0944d;

});

parcelRegister("jDAs4", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $cb1643b6288b18a5$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $cb1643b6288b18a5$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $cb1643b6288b18a5$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $cb1643b6288b18a5$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $cb1643b6288b18a5$var$LANGUAGE_CLASS_REGEX = /(?:^|\s)language-([^\s]+)/u;
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $cb1643b6288b18a5$var$TRAILING_NEWLINE_REGEX = /\n$/u;
const $cb1643b6288b18a5$var$extractLanguageFromClass = (className)=>{
    const result = $cb1643b6288b18a5$var$LANGUAGE_CLASS_REGEX.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $cb1643b6288b18a5$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace($cb1643b6288b18a5$var$TRAILING_NEWLINE_REGEX, '');
    return dom;
};
function $cb1643b6288b18a5$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $cb1643b6288b18a5$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $cb1643b6288b18a5$export$7bb0d5c671655cc4 = (0, $472n0.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $cb1643b6288b18a5$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $cb1643b6288b18a5$var$getLanguageFromEditorStyle(dom.parentElement) || $cb1643b6288b18a5$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $cb1643b6288b18a5$var$removeLastNewLine(dom);
                const wrapAttr = dom.getAttribute('data-wrap');
                const isCopiedFromEditor = Boolean(dom.closest('[data-pm-slice]') || dom.hasAttribute('data-pm-slice'));
                // Default external HTML paste to wrapped when data-wrap is absent, but preserve
                // unwrapped editor-origin paste when copied content has data-pm-slice.
                const wrap = wrapAttr === null ? !isCopiedFromEditor : wrapAttr !== 'false';
                const hideLineNumbers = dom.getAttribute('data-hide-line-numbers') === 'true';
                return {
                    language: language,
                    wrap: wrap,
                    hideLineNumbers: hideLineNumbers,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {
                    wrap: true
                };
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $cb1643b6288b18a5$var$parseCodeFromHtml(domNode);
                return code ? (0, $aPdNQ.Fragment).from(schema.text(code)) : (0, $aPdNQ.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {
                    wrap: true
                };
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {
                    wrap: true
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {};
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        // Always serialize data-wrap explicitly (both true and false) so that
        // editor-to-editor paste can distinguish intentional wrap:false from
        // absent data-wrap (which parseDOM defaults to wrap:true for external HTML).
        attrs['data-wrap'] = node.attrs.wrap ? 'true' : 'false';
        if (node.attrs.hideLineNumbers) attrs['data-hide-line-numbers'] = 'true';
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $cb1643b6288b18a5$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            if (key === 'wrap' && node.attrs.wrap === null) return memo;
            if (key === 'hideLineNumbers' && !node.attrs.hideLineNumbers) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });
const $cb1643b6288b18a5$export$3f75de798a0b5356 = (0, $472n0.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $cb1643b6288b18a5$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $cb1643b6288b18a5$var$getLanguageFromEditorStyle(dom.parentElement) || $cb1643b6288b18a5$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $cb1643b6288b18a5$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $cb1643b6288b18a5$var$parseCodeFromHtml(domNode);
                return code ? (0, $aPdNQ.Fragment).from(schema.text(code)) : (0, $aPdNQ.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        const attrs = {};
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
module.exports["codeBlock"] = $cb1643b6288b18a5$export$7bb0d5c671655cc4;
module.exports["toJSON"] = $cb1643b6288b18a5$export$54fd2c36b5cc6731;
module.exports["codeBlockWithLocalId"] = $cb1643b6288b18a5$export$3f75de798a0b5356;

});

parcelRegister("aPdNQ", function(module, exports) {
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $f37657c8250158ad$var$OrderedMap(content) {
    this.content = content;
}
$f37657c8250158ad$var$OrderedMap.prototype = {
    constructor: $f37657c8250158ad$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $f37657c8250158ad$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $f37657c8250158ad$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $f37657c8250158ad$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $f37657c8250158ad$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $f37657c8250158ad$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $f37657c8250158ad$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $f37657c8250158ad$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $f37657c8250158ad$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $f37657c8250158ad$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $f37657c8250158ad$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$f37657c8250158ad$var$OrderedMap.from = function(value) {
    if (value instanceof $f37657c8250158ad$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $f37657c8250158ad$var$OrderedMap(content);
};
var $f37657c8250158ad$export$2e2bcd8739ae039 = $f37657c8250158ad$var$OrderedMap;


function $7e195fc5b289c822$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $7e195fc5b289c822$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $7e195fc5b289c822$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $7e195fc5b289c822$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $7e195fc5b289c822$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $7e195fc5b289c822$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $7e195fc5b289c822$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $7e195fc5b289c822$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $7e195fc5b289c822$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $7e195fc5b289c822$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $7e195fc5b289c822$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $7e195fc5b289c822$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $7e195fc5b289c822$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $7e195fc5b289c822$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $7e195fc5b289c822$var$retIndex(0, pos);
        if (pos == this.size) return $7e195fc5b289c822$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $7e195fc5b289c822$var$retIndex(i + 1, end);
                return $7e195fc5b289c822$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $7e195fc5b289c822$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $7e195fc5b289c822$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $7e195fc5b289c822$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $7e195fc5b289c822$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $7e195fc5b289c822$export$ffb0004e005737fa.empty;
        if (nodes instanceof $7e195fc5b289c822$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $7e195fc5b289c822$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $7e195fc5b289c822$export$ffb0004e005737fa.empty = new $7e195fc5b289c822$export$ffb0004e005737fa([], 0);
const $7e195fc5b289c822$var$found = {
    index: 0,
    offset: 0
};
function $7e195fc5b289c822$var$retIndex(index, offset) {
    $7e195fc5b289c822$var$found.index = index;
    $7e195fc5b289c822$var$found.offset = offset;
    return $7e195fc5b289c822$var$found;
}
function $7e195fc5b289c822$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$7e195fc5b289c822$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$7e195fc5b289c822$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $7e195fc5b289c822$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $7e195fc5b289c822$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
        if (marks instanceof $7e195fc5b289c822$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $7e195fc5b289c822$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $7e195fc5b289c822$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $7e195fc5b289c822$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $7e195fc5b289c822$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $7e195fc5b289c822$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $7e195fc5b289c822$export$b3f2e2de3a8baa1e($7e195fc5b289c822$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $7e195fc5b289c822$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $7e195fc5b289c822$export$b3f2e2de3a8baa1e($7e195fc5b289c822$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $7e195fc5b289c822$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $7e195fc5b289c822$export$b3f2e2de3a8baa1e.empty = new $7e195fc5b289c822$export$b3f2e2de3a8baa1e($7e195fc5b289c822$export$ffb0004e005737fa.empty, 0, 0);
function $7e195fc5b289c822$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($7e195fc5b289c822$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $7e195fc5b289c822$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $7e195fc5b289c822$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $7e195fc5b289c822$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $7e195fc5b289c822$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $7e195fc5b289c822$export$6de0e778727af3f2("Inconsistent open depths");
    return $7e195fc5b289c822$var$replaceOuter($from, $to, slice, 0);
}
function $7e195fc5b289c822$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $7e195fc5b289c822$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $7e195fc5b289c822$var$close(node, $7e195fc5b289c822$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $7e195fc5b289c822$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $7e195fc5b289c822$var$prepareSliceForReplace(slice, $from);
        return $7e195fc5b289c822$var$close(node, $7e195fc5b289c822$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $7e195fc5b289c822$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $7e195fc5b289c822$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $7e195fc5b289c822$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $7e195fc5b289c822$var$checkJoin(node, $after.node(depth));
    return node;
}
function $7e195fc5b289c822$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $7e195fc5b289c822$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $7e195fc5b289c822$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$7e195fc5b289c822$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $7e195fc5b289c822$var$addNode($end.nodeBefore, target);
}
function $7e195fc5b289c822$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $7e195fc5b289c822$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $7e195fc5b289c822$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $7e195fc5b289c822$var$joinable($end, $to, depth + 1);
    let content = [];
    $7e195fc5b289c822$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $7e195fc5b289c822$var$checkJoin(openStart, openEnd);
        $7e195fc5b289c822$var$addNode($7e195fc5b289c822$var$close(openStart, $7e195fc5b289c822$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $7e195fc5b289c822$var$addNode($7e195fc5b289c822$var$close(openStart, $7e195fc5b289c822$var$replaceTwoWay($from, $start, depth + 1)), content);
        $7e195fc5b289c822$var$addRange($start, $end, depth, content);
        if (openEnd) $7e195fc5b289c822$var$addNode($7e195fc5b289c822$var$close(openEnd, $7e195fc5b289c822$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $7e195fc5b289c822$var$addRange($to, null, depth, content);
    return new $7e195fc5b289c822$export$ffb0004e005737fa(content);
}
function $7e195fc5b289c822$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $7e195fc5b289c822$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $7e195fc5b289c822$var$joinable($from, $to, depth + 1);
        $7e195fc5b289c822$var$addNode($7e195fc5b289c822$var$close(type, $7e195fc5b289c822$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $7e195fc5b289c822$var$addRange($to, null, depth, content);
    return new $7e195fc5b289c822$export$ffb0004e005737fa(content);
}
function $7e195fc5b289c822$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($7e195fc5b289c822$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $7e195fc5b289c822$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $7e195fc5b289c822$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $7e195fc5b289c822$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $7e195fc5b289c822$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $7e195fc5b289c822$var$resolveCache.set(doc, cache = new $7e195fc5b289c822$var$ResolveCache);
        let result = cache.elts[cache.i] = $7e195fc5b289c822$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $7e195fc5b289c822$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $7e195fc5b289c822$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $7e195fc5b289c822$var$resolveCacheSize = 12, $7e195fc5b289c822$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $7e195fc5b289c822$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $7e195fc5b289c822$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $7e195fc5b289c822$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $7e195fc5b289c822$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $7e195fc5b289c822$var$emptyAttrs) && $7e195fc5b289c822$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $7e195fc5b289c822$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $7e195fc5b289c822$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $7e195fc5b289c822$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $7e195fc5b289c822$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $7e195fc5b289c822$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $7e195fc5b289c822$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $7e195fc5b289c822$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $7e195fc5b289c822$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $7e195fc5b289c822$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $7e195fc5b289c822$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$7e195fc5b289c822$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $7e195fc5b289c822$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $7e195fc5b289c822$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $7e195fc5b289c822$export$ffb0004e005737fa.empty;
    }
}
$7e195fc5b289c822$export$85c928794f8d04d4.prototype.text = undefined;
class $7e195fc5b289c822$var$TextNode extends $7e195fc5b289c822$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $7e195fc5b289c822$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $7e195fc5b289c822$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $7e195fc5b289c822$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $7e195fc5b289c822$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $7e195fc5b289c822$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $7e195fc5b289c822$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $7e195fc5b289c822$export$364ed450558d7ec4.empty;
        let expr = $7e195fc5b289c822$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $7e195fc5b289c822$var$dfa($7e195fc5b289c822$var$nfa(expr));
        $7e195fc5b289c822$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $7e195fc5b289c822$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $7e195fc5b289c822$export$364ed450558d7ec4.empty = new $7e195fc5b289c822$export$364ed450558d7ec4(true);
class $7e195fc5b289c822$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $7e195fc5b289c822$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($7e195fc5b289c822$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $7e195fc5b289c822$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($7e195fc5b289c822$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $7e195fc5b289c822$var$parseExprSubscript(stream) {
    let expr = $7e195fc5b289c822$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $7e195fc5b289c822$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $7e195fc5b289c822$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $7e195fc5b289c822$var$parseExprRange(stream, expr) {
    let min = $7e195fc5b289c822$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $7e195fc5b289c822$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $7e195fc5b289c822$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $7e195fc5b289c822$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $7e195fc5b289c822$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $7e195fc5b289c822$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $7e195fc5b289c822$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $7e195fc5b289c822$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $7e195fc5b289c822$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($7e195fc5b289c822$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $7e195fc5b289c822$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($7e195fc5b289c822$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $7e195fc5b289c822$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $7e195fc5b289c822$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($7e195fc5b289c822$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $7e195fc5b289c822$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $7e195fc5b289c822$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $7e195fc5b289c822$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $7e195fc5b289c822$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $7e195fc5b289c822$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $7e195fc5b289c822$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $7e195fc5b289c822$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $7e195fc5b289c822$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $7e195fc5b289c822$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $7e195fc5b289c822$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $7e195fc5b289c822$export$ffb0004e005737fa.from(content), $7e195fc5b289c822$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $7e195fc5b289c822$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $7e195fc5b289c822$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $7e195fc5b289c822$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $7e195fc5b289c822$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($7e195fc5b289c822$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $7e195fc5b289c822$export$85c928794f8d04d4(this, attrs, content.append(after), $7e195fc5b289c822$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $7e195fc5b289c822$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $7e195fc5b289c822$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $7e195fc5b289c822$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $7e195fc5b289c822$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $7e195fc5b289c822$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $7e195fc5b289c822$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $7e195fc5b289c822$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $7e195fc5b289c822$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $7e195fc5b289c822$export$c9d15bcfc6d42044(this, $7e195fc5b289c822$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $7e195fc5b289c822$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $7e195fc5b289c822$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $7e195fc5b289c822$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $7e195fc5b289c822$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $7e195fc5b289c822$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $7e195fc5b289c822$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $7e195fc5b289c822$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $7e195fc5b289c822$var$TextNode(type, type.defaultAttrs, text, $7e195fc5b289c822$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $7e195fc5b289c822$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $7e195fc5b289c822$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $f37657c8250158ad$export$2e2bcd8739ae039).from(spec.nodes), instanceSpec.marks = (0, $f37657c8250158ad$export$2e2bcd8739ae039).from(spec.marks || {}), this.nodes = $7e195fc5b289c822$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $7e195fc5b289c822$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $7e195fc5b289c822$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $7e195fc5b289c822$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $7e195fc5b289c822$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $7e195fc5b289c822$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $7e195fc5b289c822$var$isTagRule(rule) {
    return rule.tag != null;
}
function $7e195fc5b289c822$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $7e195fc5b289c822$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $7e195fc5b289c822$var$ParseContext(this, options, false);
        context.addAll(dom, $7e195fc5b289c822$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $7e195fc5b289c822$var$ParseContext(this, options, true);
        context.addAll(dom, $7e195fc5b289c822$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $7e195fc5b289c822$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($7e195fc5b289c822$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $7e195fc5b289c822$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $7e195fc5b289c822$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $7e195fc5b289c822$export$1059c6e7d2ce5669(schema, $7e195fc5b289c822$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($7e195fc5b289c822$var$isTagRule(rule)) this.tags.push(rule);
            else if ($7e195fc5b289c822$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $7e195fc5b289c822$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $7e195fc5b289c822$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $7e195fc5b289c822$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $7e195fc5b289c822$var$OPT_PRESERVE_WS = 1, $7e195fc5b289c822$var$OPT_PRESERVE_WS_FULL = 2, $7e195fc5b289c822$var$OPT_OPEN_LEFT = 4;
function $7e195fc5b289c822$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $7e195fc5b289c822$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $7e195fc5b289c822$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $7e195fc5b289c822$var$OPT_PRESERVE_WS | $7e195fc5b289c822$var$OPT_PRESERVE_WS_FULL : base & ~$7e195fc5b289c822$var$OPT_OPEN_LEFT;
}
class $7e195fc5b289c822$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($7e195fc5b289c822$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $7e195fc5b289c822$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $7e195fc5b289c822$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($7e195fc5b289c822$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$7e195fc5b289c822$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $7e195fc5b289c822$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $7e195fc5b289c822$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $7e195fc5b289c822$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $7e195fc5b289c822$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($7e195fc5b289c822$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $7e195fc5b289c822$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $7e195fc5b289c822$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($7e195fc5b289c822$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $7e195fc5b289c822$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $7e195fc5b289c822$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $7e195fc5b289c822$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $7e195fc5b289c822$var$OPT_OPEN_LEFT;
        let applyMarks = $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $7e195fc5b289c822$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $7e195fc5b289c822$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $7e195fc5b289c822$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $7e195fc5b289c822$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $7e195fc5b289c822$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $7e195fc5b289c822$var$NodeContext(topNode.type, topNode.attrs, $7e195fc5b289c822$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $7e195fc5b289c822$var$NodeContext(null, null, $7e195fc5b289c822$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $7e195fc5b289c822$var$NodeContext(parser.schema.topNodeType, null, $7e195fc5b289c822$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $7e195fc5b289c822$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $7e195fc5b289c822$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $7e195fc5b289c822$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $7e195fc5b289c822$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $7e195fc5b289c822$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $7e195fc5b289c822$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $7e195fc5b289c822$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $7e195fc5b289c822$var$renderSpec($7e195fc5b289c822$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $7e195fc5b289c822$var$renderSpec($7e195fc5b289c822$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $7e195fc5b289c822$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $7e195fc5b289c822$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $7e195fc5b289c822$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $7e195fc5b289c822$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $7e195fc5b289c822$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $7e195fc5b289c822$var$doc(options) {
    return options.document || window.document;
}
const $7e195fc5b289c822$var$suspiciousAttributeCache = new WeakMap();
function $7e195fc5b289c822$var$suspiciousAttributes(attrs) {
    let value = $7e195fc5b289c822$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $7e195fc5b289c822$var$suspiciousAttributeCache.set(attrs, value = $7e195fc5b289c822$var$suspiciousAttributesInner(attrs));
    return value;
}
function $7e195fc5b289c822$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $7e195fc5b289c822$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $7e195fc5b289c822$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $7e195fc5b289c822$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}
module.exports["Fragment"] = $7e195fc5b289c822$export$ffb0004e005737fa;
module.exports["Mark"] = $7e195fc5b289c822$export$c9d15bcfc6d42044;
module.exports["ReplaceError"] = $7e195fc5b289c822$export$6de0e778727af3f2;
module.exports["Slice"] = $7e195fc5b289c822$export$b3f2e2de3a8baa1e;
module.exports["ResolvedPos"] = $7e195fc5b289c822$export$b2a42f82e59e4b19;
module.exports["NodeRange"] = $7e195fc5b289c822$export$7bc461ceb770fb16;
module.exports["Node"] = $7e195fc5b289c822$export$85c928794f8d04d4;
module.exports["MarkType"] = $7e195fc5b289c822$export$b6a78689043c6521;
module.exports["Schema"] = $7e195fc5b289c822$export$19342e026b58ebb7;
module.exports["DOMParser"] = $7e195fc5b289c822$export$1059c6e7d2ce5669;
module.exports["DOMSerializer"] = $7e195fc5b289c822$export$3476b78f8f5a8b72;

});

parcelRegister("2nOF5", function(module, exports) {
const $f01e37d6f1388a96$export$1c3aefb711c3a4cc = ()=>// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/gu, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
let $f01e37d6f1388a96$var$staticValue = false;
const $f01e37d6f1388a96$export$31b40729666a4ae0 = {
    setStatic (value) {
        $f01e37d6f1388a96$var$staticValue = value;
    },
    generate () {
        return $f01e37d6f1388a96$var$staticValue || $f01e37d6f1388a96$export$1c3aefb711c3a4cc();
    }
};
module.exports["generateUuid"] = $f01e37d6f1388a96$export$1c3aefb711c3a4cc;
module.exports["uuid"] = $f01e37d6f1388a96$export$31b40729666a4ae0;

});

parcelRegister("kHCzj", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");


var $kaBfx = parcelRequire("kaBfx");

const $d64f3c6b3909df83$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $kaBfx.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $d64f3c6b3909df83$export$3024f02c495408d6 = (0, $hFHBb.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$d64f3c6b3909df83$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $d64f3c6b3909df83$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};
module.exports["dataConsumer"] = $d64f3c6b3909df83$export$3024f02c495408d6;
module.exports["toJSON"] = $d64f3c6b3909df83$export$54fd2c36b5cc6731;

});

parcelRegister("chuMh", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

function $3e5a500049219548$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $3e5a500049219548$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $3e5a500049219548$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $3e5a500049219548$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $3e5a500049219548$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $3e5a500049219548$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $3e5a500049219548$export$7b80cba28d10b2c1 = (0, $472n0.expand)($3e5a500049219548$var$nodeSpecOptions);
const $3e5a500049219548$export$2ae5e7565ff9ffa6 = (0, $472n0.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $3e5a500049219548$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $3e5a500049219548$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $3e5a500049219548$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $3e5a500049219548$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $3e5a500049219548$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
module.exports["expandWithNestedExpand"] = $3e5a500049219548$export$7b80cba28d10b2c1;
module.exports["expandWithNestedExpandLocalId"] = $3e5a500049219548$export$2ae5e7565ff9ffa6;
module.exports["toJSON"] = $3e5a500049219548$export$54fd2c36b5cc6731;

});

parcelRegister("hwsSH", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");


var $kaBfx = parcelRequire("kaBfx");

const $8efc0f5bc0914369$var$parseFragment = (maybeValue)=>{
    if (!(0, $kaBfx.isDOMElement)(maybeValue)) return false;
    const name = maybeValue.getAttribute('data-name') ?? undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $8efc0f5bc0914369$export$f00aeb236b6f05af = (0, $hFHBb.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$8efc0f5bc0914369$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $8efc0f5bc0914369$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};
module.exports["fragment"] = $8efc0f5bc0914369$export$f00aeb236b6f05af;
module.exports["toJSON"] = $8efc0f5bc0914369$export$54fd2c36b5cc6731;

});

parcelRegister("3uRAA", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");


var $9p0BY = parcelRequire("9p0BY");

const $c63c671227617ce6$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $9p0BY.isSafeUrl)(href)) return false;
        if ((0, $9p0BY.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $9p0BY.normalizeUrl)(href);
        return attrs;
    };
const $c63c671227617ce6$export$9c30223ca0a664fb = (0, $hFHBb.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $c63c671227617ce6$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $c63c671227617ce6$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $9p0BY.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $c63c671227617ce6$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $c63c671227617ce6$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($c63c671227617ce6$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });
module.exports["link"] = $c63c671227617ce6$export$9c30223ca0a664fb;
module.exports["toJSON"] = $c63c671227617ce6$export$54fd2c36b5cc6731;

});

parcelRegister("9p0BY", function(module, exports) {
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $8Ik5z = parcelRequire("8Ik5z");

const $58b83256e07d7036$var$whitelistedURLPatterns = [
    /^https?:\/\//imu,
    /^ftps?:\/\//imu,
    /^gopher:\/\//imu,
    /^integrity:\/\//imu,
    /^file:\/\//imu,
    /^smb:\/\//imu,
    /^dynamicsnav:\/\//imu,
    /^jamfselfservice:\/\//imu,
    /^\//imu,
    /^mailto:/imu,
    /^skype:/imu,
    /^callto:/imu,
    /^facetime:/imu,
    /^git:/imu,
    /^irc6?:/imu,
    /^news:/imu,
    /^nntp:/imu,
    /^feed:/imu,
    /^cvs:/imu,
    /^svn:/imu,
    /^mvn:/imu,
    /^ssh:/imu,
    /^scp:\/\//imu,
    /^sftp:\/\//imu,
    /^itms:/imu,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/imu,
    /^notes:\/\//imu,
    /^hipchat:\/\//imu,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/imu,
    /^sourcetree:\/\//imu,
    /^urn:/imu,
    /^tel:/imu,
    /^xmpp:/imu,
    /^telnet:/imu,
    /^vnc:/imu,
    /^rdp:/imu,
    /^whatsapp:/imu,
    /^slack:/imu,
    /^sips?:/imu,
    /^magnet:/imu,
    /^#/imu
];
const $58b83256e07d7036$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url?.trim();
    if (urlTrimmed === undefined) return true;
    if (urlTrimmed.length === 0) return true;
    return $58b83256e07d7036$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $58b83256e07d7036$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($8Ik5z)))();
$58b83256e07d7036$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$58b83256e07d7036$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $58b83256e07d7036$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/u
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$58b83256e07d7036$export$8ccbde94d5c7f8e7.add('tel:', $58b83256e07d7036$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$58b83256e07d7036$export$8ccbde94d5c7f8e7.add('file:', $58b83256e07d7036$var$urlWithoutSpacesValidator);
$58b83256e07d7036$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $58b83256e07d7036$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $58b83256e07d7036$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$58b83256e07d7036$var$tlds.push($58b83256e07d7036$var$tlds2Char);
$58b83256e07d7036$export$8ccbde94d5c7f8e7.tlds($58b83256e07d7036$var$tlds, false);
const $58b83256e07d7036$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/u;
const $58b83256e07d7036$export$6f7d7761b97f967 = (text)=>{
    if (!$58b83256e07d7036$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    substr = text.substr(startpos);
    while(substr){
        const link = (substr.match($58b83256e07d7036$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($58b83256e07d7036$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};
function $58b83256e07d7036$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $58b83256e07d7036$export$6f7d7761b97f967(str);
    if (!match.length) match = $58b83256e07d7036$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $58b83256e07d7036$export$6535eb414fa2c8b6(url) {
    const match = $58b83256e07d7036$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $58b83256e07d7036$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}
module.exports["isSafeUrl"] = $58b83256e07d7036$export$c9f92f5469372e0f;
module.exports["linkify"] = $58b83256e07d7036$export$8ccbde94d5c7f8e7;
module.exports["linkifyMatch"] = $58b83256e07d7036$export$6f7d7761b97f967;
module.exports["getLinkMatch"] = $58b83256e07d7036$export$ce9ae45aed3e4ec;
module.exports["normalizeUrl"] = $58b83256e07d7036$export$6535eb414fa2c8b6;
module.exports["isRootRelative"] = $58b83256e07d7036$export$23579274a7a24f7b;

});

parcelRegister("8Ik5z", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $65820401d786e4ca$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $65820401d786e4ca$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $65820401d786e4ca$var$isString(obj) {
    return $65820401d786e4ca$var$_class(obj) === '[object String]';
}
function $65820401d786e4ca$var$isObject(obj) {
    return $65820401d786e4ca$var$_class(obj) === '[object Object]';
}
function $65820401d786e4ca$var$isRegExp(obj) {
    return $65820401d786e4ca$var$_class(obj) === '[object RegExp]';
}
function $65820401d786e4ca$var$isFunction(obj) {
    return $65820401d786e4ca$var$_class(obj) === '[object Function]';
}
function $65820401d786e4ca$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $65820401d786e4ca$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $65820401d786e4ca$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $65820401d786e4ca$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $65820401d786e4ca$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $65820401d786e4ca$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $65820401d786e4ca$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $65820401d786e4ca$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $65820401d786e4ca$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $65820401d786e4ca$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $65820401d786e4ca$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("iNWEs"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($65820401d786e4ca$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($65820401d786e4ca$var$isObject(val)) {
            if ($65820401d786e4ca$var$isRegExp(val.validate)) compiled.validate = $65820401d786e4ca$var$createValidator(val.validate);
            else if ($65820401d786e4ca$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($65820401d786e4ca$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $65820401d786e4ca$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($65820401d786e4ca$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $65820401d786e4ca$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($65820401d786e4ca$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $65820401d786e4ca$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $65820401d786e4ca$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $65820401d786e4ca$var$createMatch(self, shift) {
    var match = new $65820401d786e4ca$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $65820401d786e4ca$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $65820401d786e4ca$var$LinkifyIt)) return new $65820401d786e4ca$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($65820401d786e4ca$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $65820401d786e4ca$var$assign({}, $65820401d786e4ca$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $65820401d786e4ca$var$assign({}, $65820401d786e4ca$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $65820401d786e4ca$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $65820401d786e4ca$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $65820401d786e4ca$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $65820401d786e4ca$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $65820401d786e4ca$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $65820401d786e4ca$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $65820401d786e4ca$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $65820401d786e4ca$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $65820401d786e4ca$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $65820401d786e4ca$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($65820401d786e4ca$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($65820401d786e4ca$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $65820401d786e4ca$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $65820401d786e4ca$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $65820401d786e4ca$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $65820401d786e4ca$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $65820401d786e4ca$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $65820401d786e4ca$var$LinkifyIt;

});

parcelRegister("iNWEs", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("9oUnB")).source;
    re.src_Cc = (parcelRequire("62DG8")).source;
    re.src_Z = (parcelRequire("idoWF")).source;
    re.src_P = (parcelRequire("84v5S")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});

parcelRegister("9oUnB", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("62DG8", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("idoWF", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});

parcelRegister("84v5S", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("f3bB0", function(module, exports) {
var $6d3000bf8fd5e45e$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});



var $kaBfx = parcelRequire("kaBfx");


var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $9be2d15a82f89460$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    layout: {
        default: 'center'
    }
};
const $9be2d15a82f89460$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false, generateLocalId: generateLocalId = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $kaBfx.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $2nOF5.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $6d3000bf8fd5e45e$export$4d41558722ac7eed).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) attrs['data-local-id'] = node?.attrs?.localId || undefined;
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $6d3000bf8fd5e45e$export$4d41558722ac7eed).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $472n0.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $472n0.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $472n0.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $472n0.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $9be2d15a82f89460$export$969fe3781ca15058 = $9be2d15a82f89460$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $9be2d15a82f89460$export$d35e6c006d4abdfb = $9be2d15a82f89460$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $9be2d15a82f89460$export$9c58e19811ce4cf5 = $9be2d15a82f89460$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $9be2d15a82f89460$export$7e767666f2ce108a = $9be2d15a82f89460$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $9be2d15a82f89460$export$75376a385837c942 = $9be2d15a82f89460$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
const $9be2d15a82f89460$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
module.exports["mediaSingleSpec"] = $9be2d15a82f89460$export$5a1e124099b60c6b;
module.exports["mediaSingle"] = $9be2d15a82f89460$export$969fe3781ca15058;
module.exports["mediaSingleWithCaption"] = $9be2d15a82f89460$export$d35e6c006d4abdfb;
module.exports["mediaSingleWithWidthType"] = $9be2d15a82f89460$export$9c58e19811ce4cf5;
module.exports["mediaSingleFull"] = $9be2d15a82f89460$export$7e767666f2ce108a;
module.exports["mediaSingleFullWithLocalId"] = $9be2d15a82f89460$export$75376a385837c942;
module.exports["toJSON"] = $9be2d15a82f89460$export$54fd2c36b5cc6731;

});

parcelRegister("2fsTz", function(module, exports) {

var $kf78l = parcelRequire("kf78l");


var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $e2ac74e3d072e7db$export$bb3fe706be61f640 = {
    ...(0, $472n0.media)({}).attrs
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $e2ac74e3d072e7db$var$PRIVATE_ATTR_PREFIX_REGEX = /^__/u;
const $e2ac74e3d072e7db$export$f84fdfb973c05bd8 = (str)=>// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    str.replace(/([^A-Z]+)([A-Z])/gu, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $e2ac74e3d072e7db$export$111130fa8968d741 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
from, // eslint-disable-next-line @typescript-eslint/no-explicit-any
to, attributes, map)=>{
    const attrs = attributes || {};
    Object.keys(attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
const $e2ac74e3d072e7db$export$35bdbf5bc8caa677 = (attributes, inline = false, generateLocalId = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    const key = $e2ac74e3d072e7db$export$f84fdfb973c05bd8(k).replace($e2ac74e3d072e7db$var$PRIVATE_ATTR_PREFIX_REGEX, '');
                    const value = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $2nOF5.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $kf78l.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $e2ac74e3d072e7db$export$111130fa8968d741(node.attrs, attrs, attributes, (key)=>`data-${$e2ac74e3d072e7db$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $472n0.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $472n0.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $2nOF5.uuid).generate();
                    return attrs;
                }
            }
        ],
        toDOM: toDOM
    });
};
const $e2ac74e3d072e7db$export$987d49ffe1b0900f = $e2ac74e3d072e7db$export$35bdbf5bc8caa677($e2ac74e3d072e7db$export$bb3fe706be61f640, false, false);
const $e2ac74e3d072e7db$export$8446e47a4c7fd000 = $e2ac74e3d072e7db$export$35bdbf5bc8caa677({
    ...$e2ac74e3d072e7db$export$bb3fe706be61f640,
    localId: {
        default: (0, $2nOF5.uuid).generate()
    }
}, false, true);
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $e2ac74e3d072e7db$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
const $e2ac74e3d072e7db$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
const $e2ac74e3d072e7db$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_'))// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $e2ac74e3d072e7db$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($e2ac74e3d072e7db$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
module.exports["copyPrivateAttributes"] = $e2ac74e3d072e7db$export$111130fa8968d741;
module.exports["createMediaSpec"] = $e2ac74e3d072e7db$export$35bdbf5bc8caa677;
module.exports["media"] = $e2ac74e3d072e7db$export$987d49ffe1b0900f;
module.exports["toJSON"] = $e2ac74e3d072e7db$export$54fd2c36b5cc6731;

});

parcelRegister("kf78l", function(module, exports) {
// @ts-ignore
// eslint-disable-next-line import/no-namespace
var $e5c2b06b2fdf3428$exports = {};
$e5c2b06b2fdf3428$exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");


const $5dfbdb9f0cfb9428$export$4b84fd0e2c617bd = '#FFEBE6';
const $5dfbdb9f0cfb9428$export$b34b069eff244586 = '#FFBDAD';
const $5dfbdb9f0cfb9428$export$be802dd0d8b57f35 = '#FF8F73';
const $5dfbdb9f0cfb9428$export$60847d42f9da92a6 = '#FFD5D2';
const $5dfbdb9f0cfb9428$export$4a7404f376229999 = '#FF5630';
const $5dfbdb9f0cfb9428$export$2010d0fb4295b346 = '#DE350B';
const $5dfbdb9f0cfb9428$export$2837b5a1a71d5c02 = '#BF2600';
const $5dfbdb9f0cfb9428$export$8d9596b529bbb9cf = '#FFFAE6';
const $5dfbdb9f0cfb9428$export$41060a744ab0b7ae = '#FFF0B3';
const $5dfbdb9f0cfb9428$export$5aae31392d72caaa = '#FFC400';
const $5dfbdb9f0cfb9428$export$fc857b6f8771648a = '#F8E6A0';
const $5dfbdb9f0cfb9428$export$59619663aa6500fb = '#FF991F';
const $5dfbdb9f0cfb9428$export$874739ea9e379ab6 = '#FF8B00';
const $5dfbdb9f0cfb9428$export$8d067e56aec921ba = '#B38600';
const $5dfbdb9f0cfb9428$export$880b9499608823af = '#7F5F01';
const $5dfbdb9f0cfb9428$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5dfbdb9f0cfb9428$export$69a3bf21b9686c2b = '#ABF5D1';
const $5dfbdb9f0cfb9428$export$747d86715d4175de = '#57D9A3';
const $5dfbdb9f0cfb9428$export$940e1f69e873f202 = '#36B37E';
const $5dfbdb9f0cfb9428$export$a49394138f7b8e85 = '#00875A';
const $5dfbdb9f0cfb9428$export$6fa04827ac68a4fb = '#006644';
const $5dfbdb9f0cfb9428$export$226de0355ed012f8 = '#DEEBFF';
const $5dfbdb9f0cfb9428$export$8c13c2ee36917869 = '#B3D4FF';
const $5dfbdb9f0cfb9428$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5dfbdb9f0cfb9428$export$b3de0ae08da2ce64 = '#0052CC';
const $5dfbdb9f0cfb9428$export$a6ee3d71bc067634 = '#0747A6';
const $5dfbdb9f0cfb9428$export$f72948ef771f6f15 = '#D3F1A7';
const $5dfbdb9f0cfb9428$export$b118f20869cce368 = '#6A9A23';
const $5dfbdb9f0cfb9428$export$4d2dfdfde6a26b06 = '#4C6B1F';
const $5dfbdb9f0cfb9428$export$29a4f05edc054374 = '#FFFFFF';
const $5dfbdb9f0cfb9428$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5dfbdb9f0cfb9428$export$3e51e8f1440314ba = '#EBECF0';
const $5dfbdb9f0cfb9428$export$1ce2d1575d444ceb = '#DFE1E6';
const $5dfbdb9f0cfb9428$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5dfbdb9f0cfb9428$export$c2e91cbeada39b8b = '#B3BAC5';
const $5dfbdb9f0cfb9428$export$eaa8c8a70ac22806 = '#97A0AF';
const $5dfbdb9f0cfb9428$export$7c87d337fb91a97d = '#8993A4';
const $5dfbdb9f0cfb9428$export$f563ee71e9ee74cd = '#6B778C';
const $5dfbdb9f0cfb9428$export$e2ef2124cf4024b1 = '#5E6C84';
const $5dfbdb9f0cfb9428$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $5dfbdb9f0cfb9428$export$13609db0e6812ab8 = '#091E4224';
const $5dfbdb9f0cfb9428$export$c39c0fe0f26207ae = '#42526E';
const $5dfbdb9f0cfb9428$export$7090862dc3038a9f = '#758195';
const $5dfbdb9f0cfb9428$export$7d61b15e0da132af = '#172B4D';
const $5dfbdb9f0cfb9428$export$f78789c8b01753cd = '#172B4D';
const $5dfbdb9f0cfb9428$export$a19f0c33186f7767 = '#FDD0EC';
const $5dfbdb9f0cfb9428$export$3bff0a0c68537008 = '#CD519D';
const $5dfbdb9f0cfb9428$export$aedcf6658caf5ad6 = '#943D73';
const $5dfbdb9f0cfb9428$export$51716a84e62e022c = '#FEDEC8';
const $5dfbdb9f0cfb9428$export$a0fa9fa6bfbb29d1 = '#FCE4A6';
const $5dfbdb9f0cfb9428$export$65becf92d294645b = '#E06C00';
const $5dfbdb9f0cfb9428$export$d50a5202329f668e = '#9E4C00';
const $5dfbdb9f0cfb9428$export$363e4475840015bb = '#EAE6FF';
const $5dfbdb9f0cfb9428$export$4b0a4417ed59760f = '#C0B6F2';
const $5dfbdb9f0cfb9428$export$6011520a64d9a187 = '#998DD9';
const $5dfbdb9f0cfb9428$export$a7175d4e9206bc80 = '#DFD8FD';
const $5dfbdb9f0cfb9428$export$b48405b95304b5a1 = '#6554C0';
const $5dfbdb9f0cfb9428$export$c71e4279dd54a18d = '#5243AA';
const $5dfbdb9f0cfb9428$export$147899de772240ec = '#403294';
const $5dfbdb9f0cfb9428$export$2cf711fe14c66f06 = '#E6FCFF';
const $5dfbdb9f0cfb9428$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5dfbdb9f0cfb9428$export$776c9c497ef08533 = '#79E2F2';
const $5dfbdb9f0cfb9428$export$69cb3ca10c1e330e = '#C6EDFB';
const $5dfbdb9f0cfb9428$export$9dc1ef0f3f48059b = '#00B8D9';
const $5dfbdb9f0cfb9428$export$6036577f95c3877e = '#008DA6';
function $5dfbdb9f0cfb9428$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($5dfbdb9f0cfb9428$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($5dfbdb9f0cfb9428$export$e698776ec826343(color)) return $5dfbdb9f0cfb9428$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $e5c2b06b2fdf3428$exports.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $e5c2b06b2fdf3428$exports.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $e5c2b06b2fdf3428$exports.default[color];
        else if ($e5c2b06b2fdf3428$exports && $e5c2b06b2fdf3428$exports[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $e5c2b06b2fdf3428$exports[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $5dfbdb9f0cfb9428$export$5a544e13ad4e1fa5(color) {
    if (!$5dfbdb9f0cfb9428$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $5dfbdb9f0cfb9428$export$9665a07d9187b414(rawColor, alpha) {
    const color = $5dfbdb9f0cfb9428$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>{
        // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[a-z0-9]{2}/giu).map((hex)=>parseInt(hex, 16));
    };
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $5dfbdb9f0cfb9428$export$34d09c4a771c46ef(value) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const matches = value.match(/(0?\.?\d{1,3})%?\b/gu);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $5dfbdb9f0cfb9428$var$IS_RGB_REGEX = /rgba?\(/u;
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $5dfbdb9f0cfb9428$var$IS_HEX_REGEX = /^#([A-Fa-f0-9]{3}){1,2}$/u;
function $5dfbdb9f0cfb9428$export$e698776ec826343(color) {
    return $5dfbdb9f0cfb9428$var$IS_RGB_REGEX.test(color);
}
function $5dfbdb9f0cfb9428$export$8a9b6341a7c96bc(color) {
    return $5dfbdb9f0cfb9428$var$IS_HEX_REGEX.test(color);
}
module.exports["R50"] = $5dfbdb9f0cfb9428$export$4b84fd0e2c617bd;
module.exports["R75"] = $5dfbdb9f0cfb9428$export$b34b069eff244586;
module.exports["R100"] = $5dfbdb9f0cfb9428$export$be802dd0d8b57f35;
module.exports["R200"] = $5dfbdb9f0cfb9428$export$60847d42f9da92a6;
module.exports["R300"] = $5dfbdb9f0cfb9428$export$4a7404f376229999;
module.exports["R500"] = $5dfbdb9f0cfb9428$export$2837b5a1a71d5c02;
module.exports["Y50"] = $5dfbdb9f0cfb9428$export$8d9596b529bbb9cf;
module.exports["Y75"] = $5dfbdb9f0cfb9428$export$41060a744ab0b7ae;
module.exports["Y200"] = $5dfbdb9f0cfb9428$export$5aae31392d72caaa;
module.exports["Yellow200"] = $5dfbdb9f0cfb9428$export$fc857b6f8771648a;
module.exports["Y400"] = $5dfbdb9f0cfb9428$export$59619663aa6500fb;
module.exports["Y600"] = $5dfbdb9f0cfb9428$export$8d067e56aec921ba;
module.exports["Y800"] = $5dfbdb9f0cfb9428$export$880b9499608823af;
module.exports["G50"] = $5dfbdb9f0cfb9428$export$8a6341c32b6a3ee6;
module.exports["G75"] = $5dfbdb9f0cfb9428$export$69a3bf21b9686c2b;
module.exports["G200"] = $5dfbdb9f0cfb9428$export$747d86715d4175de;
module.exports["G300"] = $5dfbdb9f0cfb9428$export$940e1f69e873f202;
module.exports["G500"] = $5dfbdb9f0cfb9428$export$6fa04827ac68a4fb;
module.exports["B50"] = $5dfbdb9f0cfb9428$export$226de0355ed012f8;
module.exports["B75"] = $5dfbdb9f0cfb9428$export$8c13c2ee36917869;
module.exports["B100"] = $5dfbdb9f0cfb9428$export$ecfc1dff386a3e7a;
module.exports["B400"] = $5dfbdb9f0cfb9428$export$b3de0ae08da2ce64;
module.exports["B500"] = $5dfbdb9f0cfb9428$export$a6ee3d71bc067634;
module.exports["L200"] = $5dfbdb9f0cfb9428$export$f72948ef771f6f15;
module.exports["L600"] = $5dfbdb9f0cfb9428$export$b118f20869cce368;
module.exports["L800"] = $5dfbdb9f0cfb9428$export$4d2dfdfde6a26b06;
module.exports["N0"] = $5dfbdb9f0cfb9428$export$29a4f05edc054374;
module.exports["N20"] = $5dfbdb9f0cfb9428$export$9fdfb749e33cdf97;
module.exports["N30"] = $5dfbdb9f0cfb9428$export$3e51e8f1440314ba;
module.exports["N60"] = $5dfbdb9f0cfb9428$export$c2e91cbeada39b8b;
module.exports["N80"] = $5dfbdb9f0cfb9428$export$eaa8c8a70ac22806;
module.exports["Neutral300"] = $5dfbdb9f0cfb9428$export$1ae1cebe22dcedb4;
module.exports["N300A"] = $5dfbdb9f0cfb9428$export$13609db0e6812ab8;
module.exports["N600"] = $5dfbdb9f0cfb9428$export$7090862dc3038a9f;
module.exports["N800"] = $5dfbdb9f0cfb9428$export$7d61b15e0da132af;
module.exports["N1000"] = $5dfbdb9f0cfb9428$export$f78789c8b01753cd;
module.exports["M200"] = $5dfbdb9f0cfb9428$export$a19f0c33186f7767;
module.exports["M600"] = $5dfbdb9f0cfb9428$export$3bff0a0c68537008;
module.exports["M800"] = $5dfbdb9f0cfb9428$export$aedcf6658caf5ad6;
module.exports["O200"] = $5dfbdb9f0cfb9428$export$51716a84e62e022c;
module.exports["Orange200"] = $5dfbdb9f0cfb9428$export$a0fa9fa6bfbb29d1;
module.exports["O600"] = $5dfbdb9f0cfb9428$export$65becf92d294645b;
module.exports["O800"] = $5dfbdb9f0cfb9428$export$d50a5202329f668e;
module.exports["P50"] = $5dfbdb9f0cfb9428$export$363e4475840015bb;
module.exports["P75"] = $5dfbdb9f0cfb9428$export$4b0a4417ed59760f;
module.exports["P100"] = $5dfbdb9f0cfb9428$export$6011520a64d9a187;
module.exports["P200"] = $5dfbdb9f0cfb9428$export$a7175d4e9206bc80;
module.exports["P300"] = $5dfbdb9f0cfb9428$export$b48405b95304b5a1;
module.exports["P500"] = $5dfbdb9f0cfb9428$export$147899de772240ec;
module.exports["T50"] = $5dfbdb9f0cfb9428$export$2cf711fe14c66f06;
module.exports["T75"] = $5dfbdb9f0cfb9428$export$7a8f4d33f6f9772c;
module.exports["T100"] = $5dfbdb9f0cfb9428$export$776c9c497ef08533;
module.exports["T200"] = $5dfbdb9f0cfb9428$export$69cb3ca10c1e330e;
module.exports["T300"] = $5dfbdb9f0cfb9428$export$9dc1ef0f3f48059b;
module.exports["T500"] = $5dfbdb9f0cfb9428$export$6036577f95c3877e;
module.exports["normalizeHexColor"] = $5dfbdb9f0cfb9428$export$b61655071712e690;
module.exports["isHex"] = $5dfbdb9f0cfb9428$export$8a9b6341a7c96bc;
module.exports["isRgb"] = $5dfbdb9f0cfb9428$export$e698776ec826343;
module.exports["rgbToHex"] = $5dfbdb9f0cfb9428$export$34d09c4a771c46ef;
module.exports["hexToRgb"] = $5dfbdb9f0cfb9428$export$5a544e13ad4e1fa5;
module.exports["hexToRgba"] = $5dfbdb9f0cfb9428$export$9665a07d9187b414;

});

parcelRegister("jKue6", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");


var $472n0 = parcelRequire("472n0");

var $36264df1732d5e21$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $36264df1732d5e21$export$db83999c14438df4 = (0, $472n0.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $36264df1732d5e21$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $36264df1732d5e21$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $36264df1732d5e21$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $2nOF5.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($36264df1732d5e21$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $36264df1732d5e21$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $36264df1732d5e21$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($36264df1732d5e21$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
module.exports["mention"] = $36264df1732d5e21$export$db83999c14438df4;
module.exports["toJSON"] = $36264df1732d5e21$export$54fd2c36b5cc6731;

});

parcelRegister("39Puj", function(module, exports) {

var $4jl6R = parcelRequire("4jl6R");


var $kf78l = parcelRequire("kf78l");


var $2nOF5 = parcelRequire("2nOF5");


var $cbws3 = parcelRequire("cbws3");


var $472n0 = parcelRequire("472n0");


var $mrh47 = parcelRequire("mrh47");

const $ddc153dd41e1112d$export$9cfceb893b24742a = 'pm-table';
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $ddc153dd41e1112d$var$COL_WIDTH_ATTR_REGEX = /^\d+(,\d+)*$/u;
const $ddc153dd41e1112d$export$69cb4c3f80383763 = `${$ddc153dd41e1112d$export$9cfceb893b24742a}-cell-content-wrap`;
const $ddc153dd41e1112d$export$7b07d37d879c957f = `${$ddc153dd41e1112d$export$9cfceb893b24742a}-header-content-wrap`;
const $ddc153dd41e1112d$export$8dd42a84cd52da07 = `${$ddc153dd41e1112d$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $ddc153dd41e1112d$export$5e26a5c19f0865d8 = `${$ddc153dd41e1112d$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $ddc153dd41e1112d$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $kf78l.N20).toLocaleLowerCase();
const $ddc153dd41e1112d$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && $ddc153dd41e1112d$var$COL_WIDTH_ATTR_REGEX.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $kf78l.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $kf78l.isRgb)(backgroundColor)) {
        const result = (0, $kf78l.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    const localId = defaultValues?.localId;
    const valign = (0, $mrh47.parseValign)(dom.getAttribute('data-valign'));
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode,
        ...localId && {
            localId: localId
        },
        ...valign && {
            valign: valign
        }
    };
};
// these are for test only
let $ddc153dd41e1112d$var$testGlobalTheme;
const $ddc153dd41e1112d$export$fd7e0dd2b74807f7 = (theme)=>{
    $ddc153dd41e1112d$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $ddc153dd41e1112d$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($ddc153dd41e1112d$var$testGlobalTheme) return {
        colorMode: $ddc153dd41e1112d$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $ddc153dd41e1112d$var$cssVariablePattern = /^var\(--.*\)$/u;
const $ddc153dd41e1112d$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $ddc153dd41e1112d$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $ddc153dd41e1112d$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $kf78l.isRgb)(background) && (0, $kf78l.rgbToHex)(background) ? (0, $kf78l.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $4jl6R.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $ddc153dd41e1112d$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($ddc153dd41e1112d$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $cbws3.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $ddc153dd41e1112d$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $ddc153dd41e1112d$export$7b07d37d879c957f;
    else attrs.class = $ddc153dd41e1112d$export$69cb4c3f80383763;
    if (node?.attrs?.localId) attrs['data-local-id'] = node.attrs.localId;
    if (node.attrs.valign) attrs['data-valign'] = node.attrs.valign;
    return attrs;
};
const $ddc153dd41e1112d$export$219b7f492ad209f8 = new Map();
const $ddc153dd41e1112d$export$95e9c925fbf01d1c = (0, $kf78l.hexToRgba)((0, $kf78l.N800), 0.12) || (0, $kf78l.N0);
const $ddc153dd41e1112d$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $kf78l.N0),
        'White'
    ],
    [
        (0, $kf78l.B50),
        'Light blue'
    ],
    [
        (0, $kf78l.T50),
        'Light teal'
    ],
    [
        (0, $kf78l.G50),
        'Light green'
    ],
    [
        (0, $kf78l.Y50),
        'Light yellow'
    ],
    [
        (0, $kf78l.R50),
        'Light red'
    ],
    [
        (0, $kf78l.P50),
        'Light purple'
    ],
    [
        (0, $kf78l.N20),
        'Light gray'
    ],
    [
        (0, $kf78l.B75),
        'Blue'
    ],
    [
        (0, $kf78l.T75),
        'Teal'
    ],
    [
        (0, $kf78l.G75),
        'Green'
    ],
    [
        (0, $kf78l.Y75),
        'Yellow'
    ],
    [
        (0, $kf78l.R75),
        'Red'
    ],
    [
        (0, $kf78l.P75),
        'Purple'
    ],
    [
        (0, $kf78l.N60),
        'Gray'
    ],
    [
        (0, $kf78l.B100),
        'Dark blue'
    ],
    [
        (0, $kf78l.T100),
        'Dark teal'
    ],
    [
        (0, $kf78l.G200),
        'Dark green'
    ],
    [
        (0, $kf78l.Y200),
        'Dark yellow'
    ],
    [
        (0, $kf78l.R100),
        'Dark red'
    ],
    [
        (0, $kf78l.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $ddc153dd41e1112d$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $ddc153dd41e1112d$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
const $ddc153dd41e1112d$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = node;
                const breakoutWrapper = dom.parentElement?.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || // copying from renderer
                    breakoutWrapper?.getAttribute('data-layout') || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $2nOF5.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
const $ddc153dd41e1112d$var$createTableSpec = ()=>(0, $472n0.table)($ddc153dd41e1112d$var$tableNodeSpecOptions);
const $ddc153dd41e1112d$export$9852986a3ec5f6a0 = $ddc153dd41e1112d$var$createTableSpec();
const $ddc153dd41e1112d$export$90e634fbace1f0c4 = $ddc153dd41e1112d$var$createTableSpec();
const $ddc153dd41e1112d$export$3862de5c8c9098cf = $ddc153dd41e1112d$var$createTableSpec();
const $ddc153dd41e1112d$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $ddc153dd41e1112d$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$ddc153dd41e1112d$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $ddc153dd41e1112d$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $ddc153dd41e1112d$export$ce666bf02318c957 = (0, $472n0.tableRow)($ddc153dd41e1112d$var$tableRowNodeSpecOptions);
const $ddc153dd41e1112d$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    },
    valign: {
        default: null,
        optional: true
    }
};
const $ddc153dd41e1112d$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (dom)=>$ddc153dd41e1112d$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $ddc153dd41e1112d$export$363c8dda799bfe9c(node),
            0
        ]
};
const $ddc153dd41e1112d$export$e1e720e5f4603e6a = (0, $472n0.tableCell)($ddc153dd41e1112d$var$tableCellNodeSpecOptions);
const $ddc153dd41e1112d$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            // Only process keys that are defined in cellAttrs
            if ($ddc153dd41e1112d$var$cellAttrs[key] && $ddc153dd41e1112d$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $ddc153dd41e1112d$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $ddc153dd41e1112d$export$43977bde391e007(dom, {
                    background: $ddc153dd41e1112d$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $ddc153dd41e1112d$export$363c8dda799bfe9c(node),
            0
        ]
};
const $ddc153dd41e1112d$export$48884d2a5190dc73 = (0, $472n0.tableHeader)($ddc153dd41e1112d$var$tableHeaderNodeSpecOptions);
const $ddc153dd41e1112d$export$2af48797a1010bb1 = $ddc153dd41e1112d$export$2ac34c099660f1a8;
const $ddc153dd41e1112d$export$ce086a560a1d05f5 = (0, $472n0.tableWithNestedTable)($ddc153dd41e1112d$var$tableNodeSpecOptions);
const $ddc153dd41e1112d$export$7d657479499397 = (0, $472n0.tableRowWithNestedTable)($ddc153dd41e1112d$var$tableRowNodeSpecOptions);
const $ddc153dd41e1112d$export$abf39ca178940ff3 = (0, $472n0.tableCellWithNestedTable)($ddc153dd41e1112d$var$tableCellNodeSpecOptions);
const $ddc153dd41e1112d$export$2a5a518232fa1a97 = (0, $472n0.tableHeaderWithNestedTable)($ddc153dd41e1112d$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
const $ddc153dd41e1112d$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'tr',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
};
const $ddc153dd41e1112d$export$c8f0853ac97552c9 = (0, $472n0.tableRow)($ddc153dd41e1112d$var$tableRowNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $ddc153dd41e1112d$export$43977bde391e007(dom, {
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'td',
            $ddc153dd41e1112d$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
const $ddc153dd41e1112d$export$db76cfd28a574029 = (0, $472n0.tableCell)($ddc153dd41e1112d$var$tableCellNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $ddc153dd41e1112d$export$43977bde391e007(dom, {
                    background: $ddc153dd41e1112d$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $ddc153dd41e1112d$export$363c8dda799bfe9c(node),
            0
        ]
};
const $ddc153dd41e1112d$export$b82d2b1d8824143d = (0, $472n0.tableHeader)($ddc153dd41e1112d$var$tableHeaderNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$export$27926e30c8a74147 = (0, $472n0.tableRowWithNestedTable)($ddc153dd41e1112d$var$tableRowNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$export$e9fd700fafee293a = (0, $472n0.tableCellWithNestedTable)($ddc153dd41e1112d$var$tableCellNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$export$7928c3aeb4cd2213 = (0, $472n0.tableHeaderWithNestedTable)($ddc153dd41e1112d$var$tableHeaderNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$export$7ffdb7030e2f2223 = $ddc153dd41e1112d$export$db76cfd28a574029;
const $ddc153dd41e1112d$export$53c69bb0cddd9750 = $ddc153dd41e1112d$export$b82d2b1d8824143d;
const $ddc153dd41e1112d$export$10671ff6b5f3bd84 = $ddc153dd41e1112d$export$e9fd700fafee293a;
const $ddc153dd41e1112d$export$69bdb7ac5d810d92 = $ddc153dd41e1112d$export$7928c3aeb4cd2213;
module.exports["tablePrefixSelector"] = $ddc153dd41e1112d$export$9cfceb893b24742a;
module.exports["tableCellSelector"] = $ddc153dd41e1112d$export$69cb4c3f80383763;
module.exports["tableHeaderSelector"] = $ddc153dd41e1112d$export$7b07d37d879c957f;
module.exports["tableCellContentWrapperSelector"] = $ddc153dd41e1112d$export$8dd42a84cd52da07;
module.exports["tableCellContentDomSelector"] = $ddc153dd41e1112d$export$5e26a5c19f0865d8;
module.exports["getCellAttrs"] = $ddc153dd41e1112d$export$43977bde391e007;
module.exports["getCellDomAttrs"] = $ddc153dd41e1112d$export$363c8dda799bfe9c;
module.exports["tableBackgroundColorNames"] = $ddc153dd41e1112d$export$8cc2833b5b349a1e;
module.exports["tableBackgroundColorPalette"] = $ddc153dd41e1112d$export$219b7f492ad209f8;
module.exports["tableBackgroundBorderColor"] = $ddc153dd41e1112d$export$95e9c925fbf01d1c;
module.exports["table"] = $ddc153dd41e1112d$export$9852986a3ec5f6a0;
module.exports["tableWithCustomWidth"] = $ddc153dd41e1112d$export$90e634fbace1f0c4;
module.exports["tableStage0"] = $ddc153dd41e1112d$export$3862de5c8c9098cf;
module.exports["tableToJSON"] = $ddc153dd41e1112d$export$1f92a2f429e06fa8;
module.exports["tableRow"] = $ddc153dd41e1112d$export$ce666bf02318c957;
module.exports["tableCell"] = $ddc153dd41e1112d$export$e1e720e5f4603e6a;
module.exports["toJSONTableCell"] = $ddc153dd41e1112d$export$2ac34c099660f1a8;
module.exports["tableHeader"] = $ddc153dd41e1112d$export$48884d2a5190dc73;
module.exports["toJSONTableHeader"] = $ddc153dd41e1112d$export$2af48797a1010bb1;
module.exports["tableWithNestedTable"] = $ddc153dd41e1112d$export$ce086a560a1d05f5;
module.exports["tableRowWithNestedTable"] = $ddc153dd41e1112d$export$7d657479499397;
module.exports["tableCellWithNestedTable"] = $ddc153dd41e1112d$export$abf39ca178940ff3;
module.exports["tableHeaderWithNestedTable"] = $ddc153dd41e1112d$export$2a5a518232fa1a97;
module.exports["tableRowWithLocalId"] = $ddc153dd41e1112d$export$c8f0853ac97552c9;
module.exports["tableCellWithLocalId"] = $ddc153dd41e1112d$export$db76cfd28a574029;
module.exports["tableHeaderWithLocalId"] = $ddc153dd41e1112d$export$b82d2b1d8824143d;
module.exports["tableRowWithNestedTableWithLocalId"] = $ddc153dd41e1112d$export$27926e30c8a74147;
module.exports["tableCellWithNestedTableWithLocalId"] = $ddc153dd41e1112d$export$e9fd700fafee293a;
module.exports["tableHeaderWithNestedTableWithLocalId"] = $ddc153dd41e1112d$export$7928c3aeb4cd2213;
module.exports["tableCellStage0"] = $ddc153dd41e1112d$export$7ffdb7030e2f2223;
module.exports["tableHeaderStage0"] = $ddc153dd41e1112d$export$53c69bb0cddd9750;
module.exports["tableCellWithNestedTableStage0"] = $ddc153dd41e1112d$export$10671ff6b5f3bd84;
module.exports["tableHeaderWithNestedTableStage0"] = $ddc153dd41e1112d$export$69bdb7ac5d810d92;

});

parcelRegister("cbws3", function(module, exports) {
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $8ef1e3049ac57e55$var$SHORTHAND_HEX_REGEX = /^#?([a-f\d])([a-f\d])([a-f\d])$/iu;
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $8ef1e3049ac57e55$var$FULL_HEX_REGEX = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/iu;
const $8ef1e3049ac57e55$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $8ef1e3049ac57e55$var$expandShorthandHex = (input)=>input.replace($8ef1e3049ac57e55$var$SHORTHAND_HEX_REGEX, (_m, r, g, b)=>r + r + g + g + b + b);
const $8ef1e3049ac57e55$var$rgbFromHex = (input)=>{
    const fullHex = $8ef1e3049ac57e55$var$expandShorthandHex(input);
    const result = $8ef1e3049ac57e55$var$FULL_HEX_REGEX.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $8ef1e3049ac57e55$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $8ef1e3049ac57e55$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $8ef1e3049ac57e55$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $8ef1e3049ac57e55$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $8ef1e3049ac57e55$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $8ef1e3049ac57e55$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $8ef1e3049ac57e55$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $8ef1e3049ac57e55$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $8ef1e3049ac57e55$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $8ef1e3049ac57e55$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $8ef1e3049ac57e55$var$rgbToLch = (rgb)=>$8ef1e3049ac57e55$var$labToLch($8ef1e3049ac57e55$var$xyzToLab($8ef1e3049ac57e55$var$rgbToXyz(rgb)));
const $8ef1e3049ac57e55$var$lchToRgb = (lch)=>$8ef1e3049ac57e55$var$xyzToRgb($8ef1e3049ac57e55$var$labToXyz($8ef1e3049ac57e55$var$lchToLab(lch)));
const $8ef1e3049ac57e55$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $8ef1e3049ac57e55$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $8ef1e3049ac57e55$var$rgbToLch(rgb);
    lch.l = $8ef1e3049ac57e55$var$clamp(newPercent, 0, 100);
    return $8ef1e3049ac57e55$var$rgbToHex($8ef1e3049ac57e55$var$lchToRgb(lch));
};
const $8ef1e3049ac57e55$var$getLightness = (color)=>{
    const rgb = $8ef1e3049ac57e55$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $8ef1e3049ac57e55$var$rgbToLch(rgb);
    return lch.l;
};
const $8ef1e3049ac57e55$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $8ef1e3049ac57e55$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $8ef1e3049ac57e55$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};
module.exports["getDarkModeLCHColor"] = $8ef1e3049ac57e55$export$a5065c3b8aacaf99;

});

parcelRegister("4XbfY", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $chuMh = parcelRequire("chuMh");

var $ixHGM = parcelRequire("ixHGM");

var $6OV8L = parcelRequire("6OV8L");

var $39Puj = parcelRequire("39Puj");


var $2kGqi = parcelRequire("2kGqi");


var $jVdlG = parcelRequire("jVdlG");


var $8OOZ2 = parcelRequire("8OOZ2");

const $c1823554174253d2$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'panel_c1',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'fontSize',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $c1823554174253d2$export$e4e3ac1fa64862db = $c1823554174253d2$var$getDefaultSchemaConfig();
const $c1823554174253d2$export$fd147e7d448dea03 = (0, $dOBRD.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(stage = 'final')=>{
    const defaultSchemaConfig = $c1823554174253d2$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $6OV8L.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $ixHGM.multiBodiedExtension),
        extensionFrame: (0, $ixHGM.extensionFrame),
        expand: (0, $chuMh.expandWithNestedExpand),
        table: (0, $39Puj.tableWithNestedTable),
        tableRow: (0, $39Puj.tableRowWithNestedTable),
        tableCell: (0, $39Puj.tableCellWithNestedTableStage0),
        tableHeader: (0, $39Puj.tableHeaderWithNestedTableStage0),
        panel: (0, $jVdlG.extendedPanelRootOnlyStage0)(true),
        panel_c1: (0, $jVdlG.extendedPanelC1RootOnlyStage0)(true),
        rule: (0, $2kGqi.ruleRootOnlyStage0)
    };
    return (0, $8OOZ2.createSchema)(defaultSchemaConfig);
});
const $c1823554174253d2$export$1db618b7b2275ea1 = $c1823554174253d2$export$fd147e7d448dea03();
module.exports["defaultSchemaConfig"] = $c1823554174253d2$export$e4e3ac1fa64862db;
module.exports["getSchemaBasedOnStage"] = $c1823554174253d2$export$fd147e7d448dea03;
module.exports["defaultSchema"] = $c1823554174253d2$export$1db618b7b2275ea1;

});

parcelRegister("ixHGM", function(module, exports) {

var $4qeZw = parcelRequire("4qeZw");


var $472n0 = parcelRequire("472n0");

const $b44265b26fb0c5d7$export$4fdcae991fd743e7 = (0, $472n0.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true',
            // Frames are hidden by default and the active frame is revealed via CSS.
            // Using an inline style ensures frames are invisible from the moment
            // ProseMirror inserts them into the DOM, preventing a flash of all
            // frames before the styles are injected.
            style: 'display:none'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $b44265b26fb0c5d7$export$c3c04d555a8b9013 = (0, $472n0.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $4qeZw.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["extensionFrame"] = $b44265b26fb0c5d7$export$4fdcae991fd743e7;
module.exports["multiBodiedExtension"] = $b44265b26fb0c5d7$export$c3c04d555a8b9013;

});

parcelRegister("6OV8L", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $a478ba1cefaa3646$export$b3b6a70a7fa4a5be = (0, $472n0.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a478ba1cefaa3646$export$cdae19acb0a520fd = (0, $472n0.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a478ba1cefaa3646$export$4f9d8f623ff17117 = (0, $472n0.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a478ba1cefaa3646$export$d9d3c69a64270b13 = (0, $472n0.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: ()=>{
                const localId = (0, $2nOF5.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a478ba1cefaa3646$export$64facded20dfd85c = (0, $472n0.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                const localId = (0, $2nOF5.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["layoutSection"] = $a478ba1cefaa3646$export$b3b6a70a7fa4a5be;
module.exports["layoutSectionWithSingleColumn"] = $a478ba1cefaa3646$export$4f9d8f623ff17117;
module.exports["layoutSectionWithLocalId"] = $a478ba1cefaa3646$export$d9d3c69a64270b13;
module.exports["layoutSectionWithSingleColumnLocalId"] = $a478ba1cefaa3646$export$64facded20dfd85c;

});

parcelRegister("2kGqi", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $1c7c624baaef4ae4$var$hrDOM = [
    'hr'
];
const $1c7c624baaef4ae4$export$fbeb3a3956e8a3c7 = (0, $472n0.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $1c7c624baaef4ae4$var$hrDOM;
    }
});
const $1c7c624baaef4ae4$export$bf3ef6fb6ad90e7 = (0, $472n0.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'hr',
            {
                'data-local-id': node?.attrs?.localId || undefined
            }
        ];
    }
});
const $1c7c624baaef4ae4$export$1d53b70195c9c417 = {
    ...$1c7c624baaef4ae4$export$bf3ef6fb6ad90e7,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};
module.exports["rule"] = $1c7c624baaef4ae4$export$fbeb3a3956e8a3c7;
module.exports["ruleWithLocalId"] = $1c7c624baaef4ae4$export$bf3ef6fb6ad90e7;
module.exports["ruleRootOnlyStage0"] = $1c7c624baaef4ae4$export$1d53b70195c9c417;

});

parcelRegister("jVdlG", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

var $56be3a0ac801be4f$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $56be3a0ac801be4f$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': nodeAttrs?.localId || undefined
    };
    return attrs;
};
const $56be3a0ac801be4f$var$getParseDOMAttrs = (allowCustomPanel, dom, generateLocalId)=>{
    let parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $2nOF5.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === "custom" ? "info" : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $56be3a0ac801be4f$var$createPanelNodeSpecOptions = (allowCustomPanel, generateLocalId)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$56be3a0ac801be4f$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId)
            }
        ],
        toDOM (node) {
            const attrs = $56be3a0ac801be4f$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $56be3a0ac801be4f$export$ce20b13564211141 = (allowCustomPanel)=>(0, $472n0.panel)($56be3a0ac801be4f$var$createPanelNodeSpecOptions(allowCustomPanel));
const $56be3a0ac801be4f$export$855c3c67c9c9ebaf = (allowCustomPanel)=>(0, $472n0.panel)($56be3a0ac801be4f$var$createPanelNodeSpecOptions(allowCustomPanel, true));
const $56be3a0ac801be4f$export$c158ac2988d2f011 = (allowCustomPanel)=>(0, $472n0.panelC1)($56be3a0ac801be4f$var$createPanelNodeSpecOptions(allowCustomPanel));
const $56be3a0ac801be4f$export$9c65e35ecb68f683 = (allowCustomPanel)=>(0, $472n0.panelC1)($56be3a0ac801be4f$var$createPanelNodeSpecOptions(allowCustomPanel, true));
const $56be3a0ac801be4f$export$71123ea8f73a7fb = (allowCustomPanel)=>{
    const panelNodeSpec = $56be3a0ac801be4f$export$855c3c67c9c9ebaf(allowCustomPanel);
    return {
        ...panelNodeSpec,
        marks: `breakout ${panelNodeSpec.marks}`
    };
};
const $56be3a0ac801be4f$export$9ef8544aba133962 = (allowCustomPanel)=>{
    const panelNodeSpec = $56be3a0ac801be4f$export$9c65e35ecb68f683(allowCustomPanel);
    return {
        ...panelNodeSpec,
        marks: `breakout ${panelNodeSpec.marks}`
    };
};
module.exports["PanelType"] = $56be3a0ac801be4f$export$969277cf61e5a7aa;
module.exports["extendedPanel"] = $56be3a0ac801be4f$export$ce20b13564211141;
module.exports["extendedPanelWithLocalId"] = $56be3a0ac801be4f$export$855c3c67c9c9ebaf;
module.exports["extendedPanelC1"] = $56be3a0ac801be4f$export$c158ac2988d2f011;
module.exports["extendedPanelC1WithLocalId"] = $56be3a0ac801be4f$export$9c65e35ecb68f683;
module.exports["extendedPanelRootOnlyStage0"] = $56be3a0ac801be4f$export$71123ea8f73a7fb;
module.exports["extendedPanelC1RootOnlyStage0"] = $56be3a0ac801be4f$export$9ef8544aba133962;

});

parcelRegister("8OOZ2", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $604248bd3081612c$export$4498a6080fed604c = 'fontStyle';
const $604248bd3081612c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $604248bd3081612c$export$b395009ca7f092c7 = 'link';
const $604248bd3081612c$export$9b982809044276a6 = 'color';
const $604248bd3081612c$export$470d0905851e47a1 = 'alignment';
const $604248bd3081612c$export$bacb7f4b06a06b22 = 'indentation';



var $22m0b = parcelRequire("22m0b");


var $luPs0 = parcelRequire("luPs0");

var $epbW8 = parcelRequire("epbW8");

var $1ptyh = parcelRequire("1ptyh");

var $dWeA1 = parcelRequire("dWeA1");

var $acWDI = parcelRequire("acWDI");

var $bwEl8 = parcelRequire("bwEl8");

var $hFHBb = parcelRequire("hFHBb");

const $606ba856d7ca291f$export$f3b72f8fc4684ecd = (0, $hFHBb.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});


var $kHCzj = parcelRequire("kHCzj");

var $6nekq = parcelRequire("6nekq");

var $4Fod8 = parcelRequire("4Fod8");

var $hwsSH = parcelRequire("hwsSH");

var $7toP7 = parcelRequire("7toP7");

var $3uRAA = parcelRequire("3uRAA");

var $fyiBi = parcelRequire("fyiBi");

var $fa9Se = parcelRequire("fa9Se");

var $lhe5G = parcelRequire("lhe5G");

var $jj5Xg = parcelRequire("jj5Xg");

var $koZsE = parcelRequire("koZsE");

var $cI9Wu = parcelRequire("cI9Wu");

var $bliHm = parcelRequire("bliHm");

var $jZlhw = parcelRequire("jZlhw");


var $azoPw = parcelRequire("azoPw");

var $9ehdj = parcelRequire("9ehdj");

var $04Oo7 = parcelRequire("04Oo7");

var $c0Rae = parcelRequire("c0Rae");

var $9nUB4 = parcelRequire("9nUB4");

var $c94QJ = parcelRequire("c94QJ");

var $jDAs4 = parcelRequire("jDAs4");

var $9zObh = parcelRequire("9zObh");

var $g185T = parcelRequire("g185T");

var $1E9VS = parcelRequire("1E9VS");

var $eq809 = parcelRequire("eq809");

var $98Lj8 = parcelRequire("98Lj8");

var $kAzEy = parcelRequire("kAzEy");

var $5SlVI = parcelRequire("5SlVI");

var $dtmRZ = parcelRequire("dtmRZ");

var $kOOm4 = parcelRequire("kOOm4");

var $chuMh = parcelRequire("chuMh");

var $9oc8s = parcelRequire("9oc8s");

var $jVdlG = parcelRequire("jVdlG");

var $hVgcP = parcelRequire("hVgcP");

var $ixHGM = parcelRequire("ixHGM");

var $ioLmC = parcelRequire("ioLmC");

var $3RygG = parcelRequire("3RygG");

var $234td = parcelRequire("234td");

var $dYkuB = parcelRequire("dYkuB");

var $20WsY = parcelRequire("20WsY");

var $6UUJT = parcelRequire("6UUJT");

var $6OV8L = parcelRequire("6OV8L");

var $f5nzM = parcelRequire("f5nzM");

var $2fsTz = parcelRequire("2fsTz");

var $l73oM = parcelRequire("l73oM");

var $9biYD = parcelRequire("9biYD");

var $f3bB0 = parcelRequire("f3bB0");

var $jKue6 = parcelRequire("jKue6");

var $7RQ8H = parcelRequire("7RQ8H");

var $ab7A2 = parcelRequire("ab7A2");

var $gMOVH = parcelRequire("gMOVH");

var $59uj0 = parcelRequire("59uj0");

var $2kGqi = parcelRequire("2kGqi");

var $PYwg9 = parcelRequire("PYwg9");

var $5Z7gB = parcelRequire("5Z7gB");

var $39Puj = parcelRequire("39Puj");

var $7eTEw = parcelRequire("7eTEw");

var $etdmL = parcelRequire("etdmL");

var $hXS29 = parcelRequire("hXS29");

var $egqI8 = parcelRequire("egqI8");

var $kwL1e = parcelRequire("kwL1e");

function $31f16925c66f14d9$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
	 * Add built-in Node / Mark specs
	 */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
	 * Add Custom Node / Mark specs
	 */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $31f16925c66f14d9$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $31f16925c66f14d9$var$markGroupDeclarations = [
    $31f16925c66f14d9$var$groupDeclaration((0, $604248bd3081612c$export$9b982809044276a6)),
    $31f16925c66f14d9$var$groupDeclaration((0, $604248bd3081612c$export$4498a6080fed604c)),
    $31f16925c66f14d9$var$groupDeclaration((0, $604248bd3081612c$export$f8e8a5f34f6ea725)),
    $31f16925c66f14d9$var$groupDeclaration((0, $604248bd3081612c$export$b395009ca7f092c7))
];
const $31f16925c66f14d9$var$markGroupDeclarationsNames = $31f16925c66f14d9$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $31f16925c66f14d9$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $5SlVI.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $gMOVH.paragraph)
    },
    {
        name: 'text',
        spec: (0, $etdmL.text)
    },
    {
        name: 'bulletList',
        spec: (0, $9nUB4.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $ab7A2.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $f5nzM.listItem)
    },
    {
        name: 'heading',
        spec: (0, $3RygG.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $9oc8s.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $jDAs4.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $jVdlG.extendedPanel)(true)
    },
    {
        name: 'panel_c1',
        spec: (0, $jVdlG.extendedPanelC1)(true)
    },
    {
        name: 'rule',
        spec: (0, $2kGqi.rule)
    },
    {
        name: 'image',
        spec: (0, $234td.image)
    },
    {
        name: 'mention',
        spec: (0, $jKue6.mention)
    },
    {
        name: 'caption',
        spec: (0, $c94QJ.caption)
    },
    {
        name: 'media',
        spec: (0, $2fsTz.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $l73oM.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $f3bB0.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $9biYD.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $59uj0.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $6OV8L.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $6UUJT.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $ioLmC.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $kOOm4.emoji)
    },
    {
        name: 'table',
        spec: (0, $39Puj.table)
    },
    {
        name: 'tableCell',
        spec: (0, $39Puj.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $39Puj.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $39Puj.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $9zObh.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $1E9VS.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $g185T.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $kAzEy.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $98Lj8.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $7eTEw.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $9ehdj.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $9ehdj.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $eq809.date)
    },
    {
        name: 'status',
        spec: (0, $PYwg9.status)
    },
    {
        name: 'expand',
        spec: (0, $chuMh.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $7RQ8H.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $hVgcP.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $20WsY.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $04Oo7.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $ixHGM.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $ixHGM.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $dYkuB.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $azoPw.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $dtmRZ.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $5Z7gB.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $c0Rae.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $hXS29.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $egqI8.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $kwL1e.unsupportedInline)
    }
];
const $31f16925c66f14d9$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $3uRAA.link)
    },
    {
        name: 'em',
        spec: (0, $6nekq.em)
    },
    {
        name: 'strong',
        spec: (0, $fa9Se.strong)
    },
    {
        name: 'textColor',
        spec: (0, $jj5Xg.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $1ptyh.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $fyiBi.strike)
    },
    {
        name: 'subsup',
        spec: (0, $lhe5G.subsup)
    },
    {
        name: 'underline',
        spec: (0, $cI9Wu.underline)
    },
    {
        name: 'code',
        spec: (0, $bwEl8.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $koZsE.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $luPs0.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $epbW8.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $606ba856d7ca291f$export$f3b72f8fc4684ecd)
    },
    ...$31f16925c66f14d9$var$markGroupDeclarations,
    {
        name: 'fontSize',
        spec: (0, $4Fod8.fontSize)
    },
    {
        name: 'breakout',
        spec: (0, $acWDI.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $kHCzj.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $hwsSH.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $7toP7.indentation)
    },
    {
        name: 'border',
        spec: (0, $dWeA1.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $bliHm.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $jZlhw.unsupportedNodeAttribute)
    }
];
function $31f16925c66f14d9$export$2d0c32a809131488() {
    const nodes = $31f16925c66f14d9$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $31f16925c66f14d9$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $31f16925c66f14d9$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($31f16925c66f14d9$var$markGroupDeclarationsNames);
    let nodes = $31f16925c66f14d9$var$addItems($31f16925c66f14d9$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $31f16925c66f14d9$var$addItems($31f16925c66f14d9$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $22m0b.sanitizeNodes)(nodes, marks);
    return new (0, $aPdNQ.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $31f16925c66f14d9$export$c77b6d30da5276a1 = true;
module.exports["createSchema"] = $31f16925c66f14d9$export$5f4ce795563f4211;

});

parcelRegister("22m0b", function(module, exports) {
function $650a04925a78c2ad$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $650a04925a78c2ad$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $650a04925a78c2ad$var$sanitizeNodeSpecContent(nodes, rawContent) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const content = rawContent.replace(/\W/gu, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = Array.from(new Set(contentKeys.filter((contentKey)=>!$650a04925a78c2ad$var$isContentSupported(nodes, contentKey)))).sort((a, b)=>b.length - a.length);
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$650a04925a78c2ad$var$sanitizedContent(newContent, nodeName), rawContent);
}
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $650a04925a78c2ad$var$WORD_CHAR_REGEX = /\w/u;
function $650a04925a78c2ad$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match($650a04925a78c2ad$var$WORD_CHAR_REGEX)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    // Ignored via go/ees019
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $650a04925a78c2ad$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}
module.exports["sanitizeNodes"] = $650a04925a78c2ad$export$daf54fed04c8fb77;

});

parcelRegister("luPs0", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $5a12cb8d876640d2$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $5a12cb8d876640d2$export$8e53000a4ec837 = (0, $hFHBb.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});
module.exports["alignmentPositionMap"] = $5a12cb8d876640d2$export$be9cf49015769bbd;
module.exports["alignment"] = $5a12cb8d876640d2$export$8e53000a4ec837;

});

parcelRegister("epbW8", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

var $60ca9155c04cd171$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $60ca9155c04cd171$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $60ca9155c04cd171$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $60ca9155c04cd171$export$8512c9afa7b24c3b = (0, $hFHBb.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
        Data attributes on the DOM node are a temporary means of
        incrementally switching over to the Annotation mark. Once renderer
        provides native support for inline comments the data attributes on the
        DOM nodes will be removed.
      */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$60ca9155c04cd171$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});
module.exports["AnnotationTypes"] = $60ca9155c04cd171$export$94aa2fc69ad33d19;
module.exports["AnnotationMarkStates"] = $60ca9155c04cd171$export$4bab14797673da9f;
module.exports["buildDataAttributes"] = $60ca9155c04cd171$export$93a98caa8bc6cb07;
module.exports["annotation"] = $60ca9155c04cd171$export$8512c9afa7b24c3b;

});

parcelRegister("1ptyh", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $hFHBb = parcelRequire("hFHBb");


var $kf78l = parcelRequire("kf78l");


var $4jl6R = parcelRequire("4jl6R");


var $cbws3 = parcelRequire("cbws3");


var $jj5Xg = parcelRequire("jj5Xg");

const $761381ade481848a$var$colorArrayPalette = [
    [
        (0, $kf78l.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $kf78l.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $kf78l.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $kf78l.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $kf78l.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $kf78l.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $kf78l.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
const $761381ade481848a$var$colorArrayPaletteNew = [
    [
        (0, $kf78l.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $kf78l.B75),
        'Blue'
    ],
    // token: color.background.accent.blue.subtler
    [
        (0, $kf78l.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $kf78l.G75),
        'Green'
    ],
    // token: color.background.accent.green.subtler
    [
        (0, $kf78l.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $kf78l.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $kf78l.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $kf78l.R200),
        'Red'
    ],
    // token: color.background.accent.red.subtler
    [
        (0, $kf78l.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $kf78l.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $761381ade481848a$export$14ec3f21a268e497 = new Map();
$761381ade481848a$var$colorArrayPalette.forEach(([color, label])=>$761381ade481848a$export$14ec3f21a268e497.set(color.toLowerCase(), label));
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $761381ade481848a$var$RGB_PREFIX_BG_COLOR_REGEX = /^rgb/iu;
const $761381ade481848a$export$5e11ef3de07e2b1 = new Map();
$761381ade481848a$var$colorArrayPaletteNew.forEach(([color, label])=>$761381ade481848a$export$5e11ef3de07e2b1.set(color.toLowerCase(), label));
const $761381ade481848a$var$isSupportedBackgroundColor = (hexColor)=>{
    if ($761381ade481848a$export$14ec3f21a268e497.has(hexColor)) return true;
    return (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $761381ade481848a$export$5e11ef3de07e2b1.has(hexColor) && (hexColor !== (0, $kf78l.R200).toLowerCase() || (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1'));
};
const $761381ade481848a$export$8c5a050822fd698c = (0, $hFHBb.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match($761381ade481848a$var$RGB_PREFIX_BG_COLOR_REGEX)) hexColor = (0, $kf78l.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $761381ade481848a$var$isSupportedBackgroundColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $761381ade481848a$var$isSupportedBackgroundColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $4jl6R.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $jj5Xg.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $cbws3.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});
module.exports["backgroundColorPalette"] = $761381ade481848a$export$14ec3f21a268e497;
module.exports["backgroundColorPaletteNew"] = $761381ade481848a$export$5e11ef3de07e2b1;
module.exports["backgroundColor"] = $761381ade481848a$export$8c5a050822fd698c;

});

parcelRegister("jj5Xg", function(module, exports) {

var $anBbz = parcelRequire("anBbz");


var $hFHBb = parcelRequire("hFHBb");


var $4jl6R = parcelRequire("4jl6R");


var $kf78l = parcelRequire("kf78l");


var $cbws3 = parcelRequire("cbws3");

// used for extended palette in text color picker
const $cea277b6aca296ea$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $kf78l.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $kf78l.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $kf78l.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $kf78l.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $kf78l.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $kf78l.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $kf78l.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $kf78l.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $kf78l.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $kf78l.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $kf78l.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $kf78l.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $kf78l.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $kf78l.N0),
        'White'
    ],
    [
        (0, $kf78l.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $kf78l.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $kf78l.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $kf78l.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $kf78l.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $kf78l.P50),
        'Light purple'
    ] // Lavender secret
];
// experiment: platform_editor_lovability_text_bg_color
const $cea277b6aca296ea$var$colorArrayPaletteNew = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $kf78l.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $kf78l.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $kf78l.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $kf78l.L800),
        'Dark lime'
    ],
    [
        (0, $kf78l.Y800),
        'Dark yellow'
    ],
    [
        (0, $kf78l.O800),
        'Dark orange'
    ],
    [
        (0, $kf78l.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $kf78l.M800),
        'Dark magenta'
    ],
    [
        (0, $kf78l.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $kf78l.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $kf78l.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $kf78l.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $kf78l.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $kf78l.L600),
        'Lime'
    ],
    [
        (0, $kf78l.Y600),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $kf78l.O600),
        'Orange'
    ],
    [
        (0, $kf78l.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $kf78l.M600),
        'Magenta'
    ],
    [
        (0, $kf78l.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $kf78l.N0),
        'White'
    ],
    [
        (0, $kf78l.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $kf78l.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $kf78l.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $kf78l.L200),
        'Light lime'
    ],
    [
        (0, $kf78l.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $kf78l.Orange200),
        'Light orange'
    ],
    [
        (0, $kf78l.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $kf78l.M200),
        'Light magenta'
    ],
    [
        (0, $kf78l.P50),
        'Light purple'
    ] // Lavender secret
];
const $cea277b6aca296ea$export$569885e57444f84a = new Map();
const $cea277b6aca296ea$export$dee1d8a8cb3ab555 = new Map();
const $cea277b6aca296ea$export$81e5ed9e84fe2e28 = $cea277b6aca296ea$export$569885e57444f84a;
$cea277b6aca296ea$var$colorArrayPalette.forEach(([color, label])=>$cea277b6aca296ea$export$569885e57444f84a.set(color.toLowerCase(), label));
$cea277b6aca296ea$var$colorArrayPaletteNew.forEach(([color, label])=>$cea277b6aca296ea$export$dee1d8a8cb3ab555.set(color.toLowerCase(), label));
const $cea277b6aca296ea$var$isSupportedTextColor = (hexColor)=>{
    if ($cea277b6aca296ea$export$569885e57444f84a.has(hexColor)) return true;
    return (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $cea277b6aca296ea$export$dee1d8a8cb3ab555.has(hexColor);
};
// these are for test only
let $cea277b6aca296ea$var$testGlobalTheme;
const $cea277b6aca296ea$export$fd7e0dd2b74807f7 = (theme)=>{
    $cea277b6aca296ea$var$testGlobalTheme = theme;
};
const $cea277b6aca296ea$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($cea277b6aca296ea$var$testGlobalTheme) return {
        colorMode: $cea277b6aca296ea$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $cea277b6aca296ea$var$RGB_PREFIX_TEXT_COLOR_REGEX = /^rgb/iu;
const $cea277b6aca296ea$export$32f78bffcd82ff28 = (0, $hFHBb.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match($cea277b6aca296ea$var$RGB_PREFIX_TEXT_COLOR_REGEX)) hexColor = (0, $kf78l.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $cea277b6aca296ea$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $cea277b6aca296ea$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $4jl6R.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($cea277b6aca296ea$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $cbws3.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});
module.exports["colorPalette"] = $cea277b6aca296ea$export$569885e57444f84a;
module.exports["colorPaletteNew"] = $cea277b6aca296ea$export$dee1d8a8cb3ab555;
module.exports["getGlobalTheme"] = $cea277b6aca296ea$export$813ecdf77207a053;
module.exports["textColor"] = $cea277b6aca296ea$export$32f78bffcd82ff28;

});

parcelRegister("dWeA1", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");


var $4jl6R = parcelRequire("4jl6R");


var $kf78l = parcelRequire("kf78l");

const $d4e95c3b3e2156ff$var$borderColorArrayPalette = [
    [
        (0, $kf78l.N300A),
        'Subtle gray'
    ],
    [
        (0, $kf78l.N600),
        'Gray'
    ],
    [
        (0, $kf78l.N1000),
        'Bold gray'
    ]
];
const $d4e95c3b3e2156ff$export$e4e044c989c86ca7 = new Map();
$d4e95c3b3e2156ff$var$borderColorArrayPalette.forEach(([color, label])=>$d4e95c3b3e2156ff$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $d4e95c3b3e2156ff$export$1edee58a52776cd9 = (0, $hFHBb.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const color = (dom.getAttribute('data-color') ?? '').toLowerCase();
                const size = +(dom.getAttribute('data-size') ?? '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $d4e95c3b3e2156ff$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $4jl6R.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});
module.exports["borderColorPalette"] = $d4e95c3b3e2156ff$export$e4e044c989c86ca7;
module.exports["border"] = $d4e95c3b3e2156ff$export$1edee58a52776cd9;

});

parcelRegister("acWDI", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $5aa9e82185c941db$var$allowedTypes = [
    'wide',
    'full-width'
];
const $5aa9e82185c941db$export$89015c65f1c75e3f = (0, $hFHBb.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const width = dom.getAttribute('data-width');
                return {
                    mode: $5aa9e82185c941db$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': mark.attrs?.width
            },
            0
        ];
    }
});
module.exports["breakout"] = $5aa9e82185c941db$export$89015c65f1c75e3f;

});

parcelRegister("bwEl8", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $507c5fb6ee89e882$export$6565f9f03506010b = (0, $hFHBb.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});
module.exports["code"] = $507c5fb6ee89e882$export$6565f9f03506010b;

});

parcelRegister("6nekq", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $a8456ac0822da1bf$var$emDOM = [
    'em'
];
const $a8456ac0822da1bf$export$c63c6f932822f543 = (0, $hFHBb.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $a8456ac0822da1bf$var$emDOM;
    }
});
module.exports["em"] = $a8456ac0822da1bf$export$c63c6f932822f543;

});

parcelRegister("4Fod8", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $128cdaa202f0ab8b$var$allowedSizes = [
    'small'
];
const $128cdaa202f0ab8b$export$85e3c3ca0c6fb93 = (0, $hFHBb.fontSize)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-font-size',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const fontSize = dom.getAttribute('data-font-size');
                return {
                    fontSize: $128cdaa202f0ab8b$var$allowedSizes.indexOf(fontSize || '') === -1 ? 'small' : fontSize
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-font-size',
                'data-font-size': mark.attrs.fontSize
            },
            0
        ];
    }
});
module.exports["fontSize"] = $128cdaa202f0ab8b$export$85e3c3ca0c6fb93;

});

parcelRegister("7toP7", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $44c8abae69fe372d$export$480c699bd4ec0d86 = (0, $hFHBb.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});
module.exports["indentation"] = $44c8abae69fe372d$export$480c699bd4ec0d86;

});

parcelRegister("fyiBi", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $5400955bb947e2e6$export$4899a95d70ec5056 = (0, $hFHBb.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});
module.exports["strike"] = $5400955bb947e2e6$export$4899a95d70ec5056;

});

parcelRegister("fa9Se", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $69bd9cf0e17538f6$var$strongDOM = [
    'strong'
];
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $69bd9cf0e17538f6$var$BOLD_FONT_WEIGHT_REGEX = /^(bold(er)?|[5-9]\d{2,})$/u;
const $69bd9cf0e17538f6$export$59ae2c325a998f89 = (0, $hFHBb.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || $69bd9cf0e17538f6$var$BOLD_FONT_WEIGHT_REGEX.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $69bd9cf0e17538f6$var$strongDOM;
    }
});
module.exports["strong"] = $69bd9cf0e17538f6$export$59ae2c325a998f89;

});

parcelRegister("lhe5G", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

function $0a14b49585d2e952$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $0a14b49585d2e952$export$b3401ee80eb31041 = (0, $hFHBb.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$0a14b49585d2e952$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$0a14b49585d2e952$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});
module.exports["subsup"] = $0a14b49585d2e952$export$b3401ee80eb31041;

});

parcelRegister("koZsE", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");


var $kf78l = parcelRequire("kf78l");

const $79b02a3b17c3e93d$export$20af3dabbb5538df = (0, $hFHBb.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $kf78l.B400)}`
            }
        ];
    }
});
module.exports["typeAheadQuery"] = $79b02a3b17c3e93d$export$20af3dabbb5538df;

});

parcelRegister("cI9Wu", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $472feb293228fed1$export$425327af25286e5e = (0, $hFHBb.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});
module.exports["underline"] = $472feb293228fed1$export$425327af25286e5e;

});

parcelRegister("bliHm", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $ea0fff0b88b8f10f$export$30d78d5eb6719bb8 = (0, $hFHBb.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});
module.exports["unsupportedMark"] = $ea0fff0b88b8f10f$export$30d78d5eb6719bb8;

});

parcelRegister("jZlhw", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $758f7255c61ac577$export$a316dc07ff5182a2 = (0, $hFHBb.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});
module.exports["unsupportedNodeAttribute"] = $758f7255c61ac577$export$a316dc07ff5182a2;

});

parcelRegister("azoPw", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $9bd015de1953428b$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $9bd015de1953428b$export$c4c2f833baaebdb8 = (0, $472n0.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$9bd015de1953428b$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$9bd015de1953428b$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            node?.attrs?.url || ' '
        ];
    }
});
const $9bd015de1953428b$export$9894f24949f094e5 = (0, $472n0.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$9bd015de1953428b$var$getCommonAttributesFromDom(dom),
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$9bd015de1953428b$var$getCommonAttributesFromDom(dom),
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'a',
            attrs,
            node?.attrs?.url || ' '
        ];
    }
});
module.exports["blockCard"] = $9bd015de1953428b$export$c4c2f833baaebdb8;
module.exports["blockCardWithLocalId"] = $9bd015de1953428b$export$9894f24949f094e5;

});

parcelRegister("9ehdj", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");


var $472n0 = parcelRequire("472n0");

const $c772ee8acbd535f5$export$6d8b0ef52e2e6390 = (0, $472n0.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2nOF5.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c772ee8acbd535f5$export$16018c61064a18df = (0, $472n0.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2nOF5.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["taskItem"] = $c772ee8acbd535f5$export$6d8b0ef52e2e6390;
module.exports["blockTaskItem"] = $c772ee8acbd535f5$export$16018c61064a18df;

});

parcelRegister("04Oo7", function(module, exports) {

var $4qeZw = parcelRequire("4qeZw");


var $472n0 = parcelRequire("472n0");

const $64939c8f60c9dee6$export$27903d543b563e39 = (0, $472n0.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $4qeZw.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["bodiedExtension"] = $64939c8f60c9dee6$export$27903d543b563e39;

});

parcelRegister("c0Rae", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $b06c5cbe8b2603cf$export$e92c7e4302dd4371 = (0, $472n0.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $2nOF5.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});
module.exports["bodiedSyncBlock"] = $b06c5cbe8b2603cf$export$e92c7e4302dd4371;

});

parcelRegister("9nUB4", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");


var $472n0 = parcelRequire("472n0");

const $243fa11ffeedc385$export$5f25a39efab3b58b = '.ak-ul';
const $243fa11ffeedc385$export$a140c94e5ea26bee = (0, $472n0.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $243fa11ffeedc385$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
const $243fa11ffeedc385$export$dfd406053b2bab40 = (0, $472n0.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: ()=>{
                return {
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            class: $243fa11ffeedc385$export$5f25a39efab3b58b.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
module.exports["bulletListSelector"] = $243fa11ffeedc385$export$5f25a39efab3b58b;
module.exports["bulletList"] = $243fa11ffeedc385$export$a140c94e5ea26bee;
module.exports["bulletListWithLocalId"] = $243fa11ffeedc385$export$dfd406053b2bab40;

});

parcelRegister("c94QJ", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $f70d9f094f7e44ae$export$8e3c2dfdc4f0453d = (0, $472n0.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
const $f70d9f094f7e44ae$export$b5d01ee303c467aa = (0, $472n0.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: ()=>{
                return {
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-caption': 'true'
        };
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
module.exports["caption"] = $f70d9f094f7e44ae$export$8e3c2dfdc4f0453d;
module.exports["captionWithLocalId"] = $f70d9f094f7e44ae$export$b5d01ee303c467aa;

});

parcelRegister("9zObh", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $1f214e1a17634f84$var$name = 'confluenceJiraIssue';
const $1f214e1a17634f84$export$daf889beb5092f95 = (0, $472n0.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$1f214e1a17634f84$var$name}"]`,
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $1f214e1a17634f84$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});
module.exports["confluenceJiraIssue"] = $1f214e1a17634f84$export$daf889beb5092f95;

});

parcelRegister("g185T", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $15def6c333b69ab9$var$name = 'confluenceUnsupportedBlock';
const $15def6c333b69ab9$export$e6e4878f43c27cab = (0, $472n0.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $15def6c333b69ab9$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$15def6c333b69ab9$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});
module.exports["confluenceUnsupportedBlock"] = $15def6c333b69ab9$export$e6e4878f43c27cab;

});

parcelRegister("1E9VS", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $7ebe11d6bfa92b70$var$name = 'confluenceUnsupportedInline';
const $7ebe11d6bfa92b70$export$3e6d667072febc87 = (0, $472n0.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $7ebe11d6bfa92b70$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$7ebe11d6bfa92b70$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});
module.exports["confluenceUnsupportedInline"] = $7ebe11d6bfa92b70$export$3e6d667072febc87;

});

parcelRegister("eq809", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $0162fa8c6d43e134$export$324d90190a8b822a = (0, $472n0.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
const $0162fa8c6d43e134$export$a6a035390e3921b2 = (0, $472n0.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});
module.exports["date"] = $0162fa8c6d43e134$export$324d90190a8b822a;
module.exports["dateWithLocalId"] = $0162fa8c6d43e134$export$a6a035390e3921b2;

});

parcelRegister("98Lj8", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");


var $472n0 = parcelRequire("472n0");

const $9f53cdfd571108a7$export$6959e16eeff859b4 = (0, $472n0.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2nOF5.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});
module.exports["decisionItem"] = $9f53cdfd571108a7$export$6959e16eeff859b4;

});

parcelRegister("kAzEy", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");


var $472n0 = parcelRequire("472n0");

const $d7d4928c0f00c358$var$name = 'decisionList';
const $d7d4928c0f00c358$export$a5393ce68c2ff601 = `[data-node-type="${$d7d4928c0f00c358$var$name}"]`;
const $d7d4928c0f00c358$export$62d45a65fb43d95e = (0, $472n0.decisionList)({
    parseDOM: [
        {
            tag: `ol${$d7d4928c0f00c358$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $d7d4928c0f00c358$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
module.exports["decisionListSelector"] = $d7d4928c0f00c358$export$a5393ce68c2ff601;
module.exports["decisionList"] = $d7d4928c0f00c358$export$62d45a65fb43d95e;

});

parcelRegister("5SlVI", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $565971f8f49c71e0$export$2a111da947c407d2 = (0, $472n0.doc)({});
module.exports["doc"] = $565971f8f49c71e0$export$2a111da947c407d2;

});

parcelRegister("dtmRZ", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $b8a468944c963c38$export$be4283d9a1cb1ff6 = (0, $472n0.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
const $b8a468944c963c38$export$36734475a7f6fd3e = (0, $472n0.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});
module.exports["embedCard"] = $b8a468944c963c38$export$be4283d9a1cb1ff6;
module.exports["embedCardWithLocalId"] = $b8a468944c963c38$export$36734475a7f6fd3e;

});

parcelRegister("kOOm4", function(module, exports) {

var $4inos = parcelRequire("4inos");


var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $dc51790223cf45cc$export$a19185d1233fc4b2 = (0, $472n0.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: (dom)=>(0, $4inos.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: (dom)=>(0, $4inos.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $dc51790223cf45cc$export$ebb3b3c7a0ac9936 = (0, $472n0.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const attrs = (0, $4inos.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const attrs = (0, $4inos.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["emoji"] = $dc51790223cf45cc$export$a19185d1233fc4b2;
module.exports["emojiWithLocalId"] = $dc51790223cf45cc$export$ebb3b3c7a0ac9936;

});

parcelRegister("4inos", function(module, exports) {
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $8b0dfb4e845ae0c0$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $8b0dfb4e845ae0c0$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $8b0dfb4e845ae0c0$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $8b0dfb4e845ae0c0$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $8b0dfb4e845ae0c0$export$f61e93bda2a8b420(acName) {
    const emojiData = $8b0dfb4e845ae0c0$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $8b0dfb4e845ae0c0$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $8b0dfb4e845ae0c0$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$8b0dfb4e845ae0c0$var$acNameToEmojiMap[acName] ? $8b0dfb4e845ae0c0$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($8b0dfb4e845ae0c0$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $8b0dfb4e845ae0c0$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$8b0dfb4e845ae0c0$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $8b0dfb4e845ae0c0$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $8b0dfb4e845ae0c0$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($8b0dfb4e845ae0c0$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $8b0dfb4e845ae0c0$var$getAcNameFromShortName(shortName);
        if (possibleName in $8b0dfb4e845ae0c0$var$acNameToEmojiMap) return possibleName;
    }
    return $8b0dfb4e845ae0c0$export$bc94e44ec0e7bd82(id) || $8b0dfb4e845ae0c0$var$DEFAULT_EMOJI_ACNAME;
}
module.exports["acNameToEmoji"] = $8b0dfb4e845ae0c0$export$f61e93bda2a8b420;
module.exports["acShortcutToEmoji"] = $8b0dfb4e845ae0c0$export$441f8b58f5790a68;
module.exports["getEmojiAcName"] = $8b0dfb4e845ae0c0$export$880a2465992fbbe;

});

parcelRegister("9oc8s", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $c3380208f25c290b$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $c3380208f25c290b$export$67dc04e652a298ca = (0, $472n0.blockquoteLegacy)($c3380208f25c290b$var$nodeSpecOptions);
const $c3380208f25c290b$export$70a64939da3e8455 = (0, $472n0.blockquote)($c3380208f25c290b$var$nodeSpecOptions);
const $c3380208f25c290b$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: ()=>{
                return {
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'blockquote',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
};
const $c3380208f25c290b$export$950ebf43f3364a0f = (0, $472n0.blockquote)($c3380208f25c290b$var$nodeSpecOptionsWithLocalId);
module.exports["blockquote"] = $c3380208f25c290b$export$67dc04e652a298ca;
module.exports["extendedBlockquote"] = $c3380208f25c290b$export$70a64939da3e8455;
module.exports["extendedBlockquoteWithLocalId"] = $c3380208f25c290b$export$950ebf43f3364a0f;

});

parcelRegister("hVgcP", function(module, exports) {

var $4qeZw = parcelRequire("4qeZw");


var $472n0 = parcelRequire("472n0");

const $47a3a9f15ea9fc74$export$1b45514b112dd749 = (0, $472n0.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $4qeZw.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});
module.exports["extension"] = $47a3a9f15ea9fc74$export$1b45514b112dd749;

});

parcelRegister("ioLmC", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $bad09377b26ad4d0$export$371da9dd35aba193 = (0, $472n0.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});
module.exports["hardBreak"] = $bad09377b26ad4d0$export$371da9dd35aba193;

});

parcelRegister("3RygG", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $f00d07bb0a0eea13$var$getAttrs = (level)=>(domNode)=>({
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        });
const $f00d07bb0a0eea13$export$46e4a324ac90507f = (0, $472n0.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});
module.exports["heading"] = $f00d07bb0a0eea13$export$46e4a324ac90507f;

});

parcelRegister("234td", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $13d7a2f955e63612$export$5c452ff88e35e47d = (0, $472n0.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});
module.exports["image"] = $13d7a2f955e63612$export$5c452ff88e35e47d;

});

parcelRegister("dYkuB", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $14201e157179d403$export$cbf8224b64e0d942 = (0, $472n0.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
const $14201e157179d403$export$7ed775fc743eadd1 = (0, $472n0.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': node?.attrs?.localId || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
module.exports["inlineCard"] = $14201e157179d403$export$cbf8224b64e0d942;
module.exports["inlineCardWithLocalId"] = $14201e157179d403$export$7ed775fc743eadd1;

});

parcelRegister("20WsY", function(module, exports) {

var $4qeZw = parcelRequire("4qeZw");


var $472n0 = parcelRequire("472n0");

const $a4f2688aaf2c17a3$export$16b353b2649bd8d9 = (0, $472n0.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $4qeZw.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});
module.exports["inlineExtension"] = $a4f2688aaf2c17a3$export$16b353b2649bd8d9;

});

parcelRegister("6UUJT", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");


var $fqVYq = parcelRequire("fqVYq");


var $mrh47 = parcelRequire("mrh47");

const $4006f3dbb1a9689a$var$setColumnAttributes = (node, { withLocalId: withLocalId = false } = {})=>{
    const attrs = {
        'data-layout-column': 'true'
    };
    const { width: width, valign: valign, localId: localId } = node.attrs;
    if (width) {
        const baseStyle = `flex-basis: ${width}%`;
        const columnWidthVar = (0, $fqVYq.editorExperiment)('platform_editor_layout_column_resize_handle', true) ? `; --column-width: ${width}%` : '';
        attrs['style'] = baseStyle + columnWidthVar;
        attrs['data-column-width'] = `${width}`;
    }
    if (valign) attrs['data-valign'] = valign;
    if (withLocalId && localId) attrs['data-local-id'] = localId;
    return attrs;
};
const $4006f3dbb1a9689a$var$getColumnAttrs = ({ withLocalId: withLocalId = false } = {})=>(domNode)=>{
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dom = domNode;
        const base = {
            width: Number(dom.getAttribute('data-column-width')) || undefined,
            ...withLocalId && {
                localId: (0, $2nOF5.uuid).generate()
            }
        };
        const valign = (0, $mrh47.parseValign)(dom.getAttribute('data-valign'));
        return valign ? {
            ...base,
            valign: valign
        } : base;
    };
// We need to apply an attribute to the innermost child to help ProseMirror
// identify its boundaries better.
const $4006f3dbb1a9689a$var$LAYOUT_CONTENT_ATTRS = {
    'data-layout-content': 'true'
};
const $4006f3dbb1a9689a$export$ab76e7c03cd6f650 = (0, $472n0.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $4006f3dbb1a9689a$var$getColumnAttrs()
        }
    ],
    toDOM (node) {
        return [
            'div',
            $4006f3dbb1a9689a$var$setColumnAttributes(node),
            [
                'div',
                $4006f3dbb1a9689a$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $4006f3dbb1a9689a$export$b2e27d292505bac2 = (0, $472n0.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $4006f3dbb1a9689a$var$getColumnAttrs({
                withLocalId: true
            })
        }
    ],
    toDOM (node) {
        return [
            'div',
            $4006f3dbb1a9689a$var$setColumnAttributes(node, {
                withLocalId: true
            }),
            [
                'div',
                $4006f3dbb1a9689a$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $4006f3dbb1a9689a$export$f8cda4c28dab3f58 = $4006f3dbb1a9689a$export$b2e27d292505bac2;
module.exports["layoutColumn"] = $4006f3dbb1a9689a$export$ab76e7c03cd6f650;
module.exports["layoutColumnWithLocalId"] = $4006f3dbb1a9689a$export$b2e27d292505bac2;
module.exports["layoutColumnStage0"] = $4006f3dbb1a9689a$export$f8cda4c28dab3f58;

});

parcelRegister("f5nzM", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $73efe09e407baaed$export$76c7e83ecc9cdf05 = (0, $472n0.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $73efe09e407baaed$export$483d52f09158e61c = (0, $472n0.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'li',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
});
module.exports["listItem"] = $73efe09e407baaed$export$76c7e83ecc9cdf05;
module.exports["listItemWithLocalId"] = $73efe09e407baaed$export$483d52f09158e61c;

});

parcelRegister("l73oM", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $cca07b8f0be72577$export$2855e964765eac9 = (0, $472n0.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});
module.exports["mediaGroup"] = $cca07b8f0be72577$export$2855e964765eac9;

});

parcelRegister("9biYD", function(module, exports) {

var $2fsTz = parcelRequire("2fsTz");


var $2nOF5 = parcelRequire("2nOF5");


var $472n0 = parcelRequire("472n0");

const $8a39e669b4d04c0c$export$38bab695e3f720f1 = (0, $2fsTz.createMediaSpec)((0, $472n0.mediaInline)({}).attrs, true);
const $8a39e669b4d04c0c$export$aea8e9c496505c61 = (0, $2fsTz.createMediaSpec)({
    ...(0, $472n0.mediaInline)({}).attrs,
    localId: {
        default: (0, $2nOF5.uuid).generate()
    }
}, true, true);
module.exports["mediaInline"] = $8a39e669b4d04c0c$export$38bab695e3f720f1;

});

parcelRegister("7RQ8H", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

function $dd90a51500a49197$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $2nOF5.uuid).generate() : undefined
    };
}
const $dd90a51500a49197$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$dd90a51500a49197$var$getExpandAttrs(domNode, false)
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$dd90a51500a49197$var$getExpandAttrs(domNode, false)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $dd90a51500a49197$export$63cadbf5f4296627 = (0, $472n0.nestedExpand)($dd90a51500a49197$var$nestedExpandFactoryOptions);
const $dd90a51500a49197$export$b854197485aa1fa0 = (0, $472n0.nestedExpand)({
    ...$dd90a51500a49197$var$nestedExpandFactoryOptions,
    parseDOM: [
        ...$dd90a51500a49197$var$nestedExpandFactoryOptions.parseDOM || [],
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$dd90a51500a49197$var$getExpandAttrs(domNode, true)
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$dd90a51500a49197$var$getExpandAttrs(domNode, true)
        }
    ]
});
module.exports["nestedExpand"] = $dd90a51500a49197$export$63cadbf5f4296627;
module.exports["nestedExpandWithLocalId"] = $dd90a51500a49197$export$b854197485aa1fa0;

});

parcelRegister("ab7A2", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");


var $472n0 = parcelRequire("472n0");

const $7a7807fed393433e$export$4e7125c7ff595be5 = '.ak-ol';
const $7a7807fed393433e$export$a5dc81035676e7a = (0, $472n0.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $7a7807fed393433e$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $7a7807fed393433e$export$8157adc5747ec436 = (0, $472n0.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            class: $7a7807fed393433e$export$4e7125c7ff595be5.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a7807fed393433e$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $7a7807fed393433e$export$b9ab759e8298198f = (0, $472n0.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $7a7807fed393433e$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        const start = $7a7807fed393433e$var$resolveStart(node?.attrs?.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $7a7807fed393433e$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $7a7807fed393433e$export$2ea3505d41d7525d = (0, $472n0.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                const localId = (0, $2nOF5.uuid).generate();
                if (startDOMAttr) {
                    const start = $7a7807fed393433e$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const start = $7a7807fed393433e$var$resolveStart(node?.attrs?.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $7a7807fed393433e$export$4e7125c7ff595be5.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
module.exports["orderedListSelector"] = $7a7807fed393433e$export$4e7125c7ff595be5;
module.exports["orderedList"] = $7a7807fed393433e$export$a5dc81035676e7a;
module.exports["orderedListWithLocalId"] = $7a7807fed393433e$export$8157adc5747ec436;
module.exports["orderedListWithOrder"] = $7a7807fed393433e$export$b9ab759e8298198f;
module.exports["orderedListWithOrderAndLocalId"] = $7a7807fed393433e$export$2ea3505d41d7525d;

});

parcelRegister("gMOVH", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $b0a12bd9f48bf0d3$export$9c206ddddb32a9b = (0, $472n0.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || $b0a12bd9f48bf0d3$export$9c206ddddb32a9b.attrs?.localId?.default
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});
module.exports["paragraph"] = $b0a12bd9f48bf0d3$export$9c206ddddb32a9b;

});

parcelRegister("59uj0", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $7bf6ae074785ede0$export$c7187bbd1a7a9244 = (0, $472n0.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $7bf6ae074785ede0$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $7bf6ae074785ede0$export$6205248609a8f7a0 = (0, $472n0.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $7bf6ae074785ede0$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["placeholder"] = $7bf6ae074785ede0$export$c7187bbd1a7a9244;
module.exports["placeholderWithLocalId"] = $7bf6ae074785ede0$export$6205248609a8f7a0;

});

parcelRegister("PYwg9", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");


var $472n0 = parcelRequire("472n0");

// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $6a7115fe59548296$var$NEWLINE_REGEX = /\n/u;
const $6a7115fe59548296$export$471f7ae5c4103ae1 = (0, $472n0.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const textContent = dom.textContent.replace($6a7115fe59548296$var$NEWLINE_REGEX, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                const text = dom.getAttribute('data-text') || textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $2nOF5.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["status"] = $6a7115fe59548296$export$471f7ae5c4103ae1;

});

parcelRegister("5Z7gB", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $c47563b56c5a13e3$export$faab0ca9701d7048 = (0, $472n0.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $2nOF5.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});
module.exports["syncBlock"] = $c47563b56c5a13e3$export$faab0ca9701d7048;

});

parcelRegister("7eTEw", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $48d7d0fb254819d3$var$name = 'actionList';
const $48d7d0fb254819d3$export$c0ec71adb7a18fb2 = `[data-node-type="${$48d7d0fb254819d3$var$name}"]`;
const $48d7d0fb254819d3$var$taskListParseDOMAndToDOM = {
    parseDOM: [
        {
            tag: `div${$48d7d0fb254819d3$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $48d7d0fb254819d3$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $48d7d0fb254819d3$export$375b6afcc5f4d291 = (0, $472n0.taskList)($48d7d0fb254819d3$var$taskListParseDOMAndToDOM);
module.exports["taskListSelector"] = $48d7d0fb254819d3$export$c0ec71adb7a18fb2;
module.exports["taskList"] = $48d7d0fb254819d3$export$375b6afcc5f4d291;

});

parcelRegister("etdmL", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $8ae18626367d5f49$export$6f093cfa640b7166 = (0, $472n0.text)({
    toDebugString: ()=>'text_node'
});
module.exports["text"] = $8ae18626367d5f49$export$6f093cfa640b7166;

});

parcelRegister("hXS29", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc796c55e8bf30f5$export$2e2bcd8739ae039);
const $bc796c55e8bf30f5$var$name = 'unknownBlock';
var $bc796c55e8bf30f5$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $bc796c55e8bf30f5$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$bc796c55e8bf30f5$var$name}"]`
        }
    ]
};

});

parcelRegister("egqI8", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $3738731172cde68a$export$44b79b0979d0f0f7 = (0, $472n0.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});
module.exports["unsupportedBlock"] = $3738731172cde68a$export$44b79b0979d0f0f7;

});

parcelRegister("kwL1e", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $d4e5ad2da3d7794c$export$310ebe0d80122e9b = (0, $472n0.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});
module.exports["unsupportedInline"] = $d4e5ad2da3d7794c$export$310ebe0d80122e9b;

});

parcelRegister("islpn", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $e8TeZ = parcelRequire("e8TeZ");

/** NodeNestingTransformError  */ class $cc3d2aee47b701ef$export$3d8e8d2182f13924 extends Error {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}


const $ef582f075e33d911$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $ef582f075e33d911$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $ef582f075e33d911$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $ef582f075e33d911$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $ef582f075e33d911$var$NESTED_TABLE_EXTENSION_KEY;
const $ef582f075e33d911$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $cc3d2aee47b701ef$export$3d8e8d2182f13924)('Failed to parse nested table content');
    }
};
const $ef582f075e33d911$export$18544d0b5f43e4a1 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $jTt8P.traverse)(adf, {
        extension: (node)=>{
            if ($ef582f075e33d911$export$f45e7335ec874bfe(node)) {
                isTransformed = true;
                return $ef582f075e33d911$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $ef582f075e33d911$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $e8TeZ.extension)({
                    extensionType: $ef582f075e33d911$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $ef582f075e33d911$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $cc3d2aee47b701ef$export$3d8e8d2182f13924)('Failed to encode nested table node');
    }
};
module.exports["isNestedTableExtension"] = $ef582f075e33d911$export$f45e7335ec874bfe;
module.exports["transformNestedTablesIncomingDocument"] = $ef582f075e33d911$export$18544d0b5f43e4a1;
module.exports["transformNestedTableNodeOutgoingDocument"] = $ef582f075e33d911$export$8a334a7d9fe120ec;

});

parcelRegister("e8TeZ", function(module, exports) {
const $1f18f28387429092$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });
module.exports["extension"] = $1f18f28387429092$export$1b45514b112dd749;

});

parcelRegister("krYZG", function(module, exports) {
var $ea0c6e41cf42a972$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $ea0c6e41cf42a972$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["COPY_FAILED"] = "copyFailed";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    ACTION["DISCARDED"] = "discarded";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPLAYED"] = "displayed";
    ACTION["DIVERGED"] = "diverged";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPERIENCE_MEASURED"] = "experienceMeasured";
    ACTION["EXPERIENCE_SAMPLED"] = "experienceSampled";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FETCHED"] = "fetched";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INSERT_ATTEMPTED"] = "insertAttempted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LANGUAGE_AUTO_DETECTED"] = "languageAutoDetected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["ACCEPTED"] = "accepted";
    ACTION["NO_DIFF_FOUND"] = "noDiffFound";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OFFLINE_STORAGE_RESTORE_STEPS_INITIATED"] = "offlineStorageRestoreStepsInitiated";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION["REFERENCE_SYNCED_BLOCK_UNSYNC"] = "referenceSyncedBlockUnsync";
    ACTION["REFERENCE_SYNCED_BLOCK_COPY"] = "referenceSyncedBlockCopy";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION["SYNCED_BLOCK_UNSYNC"] = "syncedBlockUnsync";
    ACTION["SYNCED_BLOCK_EDIT_SOURCE"] = "syncedBlockEditSource";
    ACTION["SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS"] = "syncedBlockViewSyncedLocations";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["TRIGGERED"] = "triggered";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["RENDERED_SAMPLED"] = "renderedSampled";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
   * @private
   * @deprecated
   *
   * This is no longer used and can be removed at a later date
   */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["CONTAINER_NODE_TRANSFORMED"] = "containerNodeTransformed";
    ACTION["NATIVE_EMBEDS_TRANSFORMED"] = "nativeEmbedsTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    // remove this enum when cleaning up platform_editor_remove_collab_step_metrics
    ACTION["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["ORGANIC_CHANGES_TRACKED"] = "organicChangesTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_FOLDING"] = "toggleCodeFolding";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["TOGGLE_CODE_BLOCK_LINE_NUMBERS"] = "toggleCodeBlockLineNumbers";
    ACTION["TRANSFORMED"] = "transformed";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    ACTION["LOCAL_ID_NOT_FOUND"] = "localIdNotFound";
    ACTION["NO_DOC_CHANGE_FOUND"] = "noDocChangeFound";
    ACTION["INVALID_COMMAND_FOUND"] = "invalidCommandFound";
    ACTION["MEDIA_SINGLE_WIDTH_TRANSFORMED"] = "mediaSingleWidthTransformed";
    /**
   * used in Editor AI inline suggestion for a track event when a suggestion is inserted
   * previously tracked events being used by Editor AI proactive suggestion
   *
   */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    // fired when the on-device autocomplete LLM finishes loading/starting
    ACTION["LOCAL_MODEL_LOADED"] = "localModelLoaded";
    // fired when the on-device autocomplete LLM fails to load/start
    ACTION["LOCAL_MODEL_LOAD_FAILED"] = "localModelLoadFailed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    ACTION["SUPPRESSED"] = "suppressed";
    return ACTION;
}({});
var $ea0c6e41cf42a972$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    INPUT_METHOD["SYNCED_BLOCK_TB"] = "syncedBlockToolbar";
    INPUT_METHOD["BLOCK_MENU"] = "blockMenu";
    INPUT_METHOD["SMART_LINK"] = "smartLink";
    INPUT_METHOD["ELEMENT_BROWSER"] = "elementBrowser";
    INPUT_METHOD["LAYOUT_COLUMN_MENU"] = "layoutColumnMenu";
    INPUT_METHOD["REMIX"] = "remix";
    INPUT_METHOD["REMIX_FROM_MEDIA_INSERTS"] = "remixFromMediaInserts";
    return INPUT_METHOD;
}({});
var $ea0c6e41cf42a972$export$9395e0d0ae49956f = /*#__PURE__*/ function(MEDIA_INSERT_TAB) {
    MEDIA_INSERT_TAB["CREATE"] = "create";
    MEDIA_INSERT_TAB["LINK"] = "link";
    MEDIA_INSERT_TAB["UPLOAD"] = "upload";
    return MEDIA_INSERT_TAB;
}({});
var $ea0c6e41cf42a972$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $ea0c6e41cf42a972$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    // single key, e.g. Esc, Enter
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    // combination of keys, e.g. Mod + F
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $ea0c6e41cf42a972$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["AI_STREAMING"] = "aiStreaming";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["EXTENSION_AS_INLINE"] = "extensionAsInline";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LAYOUT_COLUMN_MENU"] = "layoutColumnMenu";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["AI_QUICK_PROMPT"] = "aiQuickPrompt";
    ACTION_SUBJECT["AI_AUTOCOMPLETE"] = "aiAutocomplete";
    ACTION_SUBJECT["AI_SUGGESTIONS"] = "aiSuggestions";
    ACTION_SUBJECT["CONTEXTUAL_TYPEAHEAD"] = "contextualTypeahead";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU"] = "toolbarDropdownMenu";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU_ITEM"] = "toolbarDropdownMenuItem";
    ACTION_SUBJECT["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT["BLOCK_MENU_ITEM"] = "blockMenuItem";
    ACTION_SUBJECT["PASTE_ACTIONS_MENU"] = "pasteActionsMenu";
    ACTION_SUBJECT["SYNCED_BLOCK"] = "syncedBlock";
    ACTION_SUBJECT["NATIVE_EMBED"] = "nativeEmbed";
    ACTION_SUBJECT["NATIVE_EMBED_FALLBACK"] = "nativeEmbedFallback";
    return ACTION_SUBJECT;
}({});
var $ea0c6e41cf42a972$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_CHANGES_ACCEPT_BUTTON"] = "aiChangesAcceptButton";
    ACTION_SUBJECT_ID["AI_CHANGES_REJECT_BUTTON"] = "aiChangesRejectButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["AI_ASK_ROVO_BUTTON"] = "aiAskRovoButton";
    ACTION_SUBJECT_ID["AI_HERO_PROMPT_BUTTON"] = "aiHeroPromptButton";
    ACTION_SUBJECT_ID["AI_REMIX_BUTTON"] = "aiRemixButton";
    ACTION_SUBJECT_ID["AI_MORE_ROVO_OPTIONS"] = "aiMoreRovoOptions";
    ACTION_SUBJECT_ID["AI_TRANSLATE"] = "aiTranslate";
    ACTION_SUBJECT_ID["AI_CHANGE_TONE"] = "aiChangeTone";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["COPY_BLOCK"] = "copyBlock";
    ACTION_SUBJECT_ID["COPY_LINK_TO_BLOCK"] = "copyLinkToBlock";
    ACTION_SUBJECT_ID["DELETE_BLOCK"] = "deleteBlock";
    ACTION_SUBJECT_ID["MOVE_UP_BLOCK"] = "moveUpBlock";
    ACTION_SUBJECT_ID["MOVE_DOWN_BLOCK"] = "moveDownBlock";
    ACTION_SUBJECT_ID["TRANSFORM_BLOCK"] = "transformBlock";
    ACTION_SUBJECT_ID["FORMAT_MENU"] = "formatMenu";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DISCARD_STREAM"] = "discardStream";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR"] = "floatingToolbar";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_SMALL_TEXT"] = "smallText";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LAYOUT_COLUMN"] = "layoutColumn";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRIMARY_TOOLBAR"] = "primaryToolbar";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["SMART_LINK_ROVO_BUTTON"] = "smartLinkRovoButton";
    ACTION_SUBJECT_ID["SMART_LINK_SUMMARIZE_BUTTON"] = "smartLinkSummarizeButton";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["TOOLBAR_PREVIEW"] = "previewFromToolbar";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPDATE_STREAM"] = "updateStream";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR"] = "selectionToolbar";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    ACTION_SUBJECT_ID["TRANSFORM"] = "transform";
    ACTION_SUBJECT_ID["BODIED_SYNCED_BLOCK"] = "bodiedSyncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK"] = "syncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_TOOLBAR"] = "syncedBlockToolbar";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_COPY"] = "syncedBlockCopy";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_URL"] = "syncedBlockSourceUrl";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE_CACHE"] = "syncedBlockUpdateCache";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_ADD_CONTENT"] = "syncedBlockAddContent";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_CREATE"] = "referenceSyncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CLICK_SYNCED_LOCATION"] = "syncedBlockClickSyncedLocation";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_LABEL"] = "syncedBlockLabel";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SSR_ERROR"] = "syncedBlockSSRError";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_INFO_ORPHANED"] = "syncedBlockSourceInfoOrphaned";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CACHE_DELETION_FORCED"] = "syncedBlockCacheDeletionForced";
    ACTION_SUBJECT_ID["UNSUPPORTED_SURFACE"] = "unsupportedSurface";
    ACTION_SUBJECT_ID["TABLE_STICKY_HEADER"] = "tableStickyHeader";
    ACTION_SUBJECT_ID["SNIPPET"] = "snippet";
    return ACTION_SUBJECT_ID;
}({});
var $ea0c6e41cf42a972$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $ea0c6e41cf42a972$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    CONTENT_COMPONENT["SELECTION_TOOLBAR"] = "selectionToolbar";
    return CONTENT_COMPONENT;
}({});
module.exports["EVENT_TYPE"] = $ea0c6e41cf42a972$export$76a2e4c433c23bb9;
module.exports["ACTION"] = $ea0c6e41cf42a972$export$9523889e0a5da4ba;
module.exports["INPUT_METHOD"] = $ea0c6e41cf42a972$export$85f107b1fcc9d96f;
module.exports["MEDIA_INSERT_TAB"] = $ea0c6e41cf42a972$export$9395e0d0ae49956f;
module.exports["INSERT_MEDIA_VIA"] = $ea0c6e41cf42a972$export$9b31fa32ae3f8051;
module.exports["TRIGGER_METHOD"] = $ea0c6e41cf42a972$export$81a8b7dba1aa8f75;
module.exports["ACTION_SUBJECT"] = $ea0c6e41cf42a972$export$7525482b5931e326;
module.exports["ACTION_SUBJECT_ID"] = $ea0c6e41cf42a972$export$9957974f8b4d8f74;
module.exports["CONTENT_COMPONENT"] = $ea0c6e41cf42a972$export$9f0b2adf3cfd71b7;

});

parcelRegister("j4yZr", function(module, exports) {

var $4Vrrm = parcelRequire("4Vrrm");


var $cAUrU = parcelRequire("cAUrU");

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $de29885240f8faa2$var$camelCase = $cAUrU(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $4Vrrm(word) : word);
});
module.exports = $de29885240f8faa2$var$camelCase;

});

parcelRegister("4Vrrm", function(module, exports) {

var $dojlP = parcelRequire("dojlP");


var $gfV78 = parcelRequire("gfV78");

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $3961c55ddcaba459$var$capitalize(string) {
    return $gfV78($dojlP(string).toLowerCase());
}
module.exports = $3961c55ddcaba459$var$capitalize;

});

parcelRegister("cAUrU", function(module, exports) {

var $1XwR6 = parcelRequire("1XwR6");


var $iJuQU = parcelRequire("iJuQU");

var $487a257bdcb2bdff$exports = {};
var $9a2f3e75ee5feeb7$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $9a2f3e75ee5feeb7$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $9a2f3e75ee5feeb7$var$asciiWords(string) {
    return string.match($9a2f3e75ee5feeb7$var$reAsciiWord) || [];
}
$9a2f3e75ee5feeb7$exports = $9a2f3e75ee5feeb7$var$asciiWords;


var $0345ee1c1330ce64$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $0345ee1c1330ce64$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $0345ee1c1330ce64$var$hasUnicodeWord(string) {
    return $0345ee1c1330ce64$var$reHasUnicodeWord.test(string);
}
$0345ee1c1330ce64$exports = $0345ee1c1330ce64$var$hasUnicodeWord;



var $dojlP = parcelRequire("dojlP");

var $0ad8475f7d1b2066$exports = {};
/** Used to compose unicode character classes. */ var $0ad8475f7d1b2066$var$rsAstralRange = '\\ud800-\\udfff', $0ad8475f7d1b2066$var$rsComboMarksRange = '\\u0300-\\u036f', $0ad8475f7d1b2066$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0ad8475f7d1b2066$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0ad8475f7d1b2066$var$rsComboRange = $0ad8475f7d1b2066$var$rsComboMarksRange + $0ad8475f7d1b2066$var$reComboHalfMarksRange + $0ad8475f7d1b2066$var$rsComboSymbolsRange, $0ad8475f7d1b2066$var$rsDingbatRange = '\\u2700-\\u27bf', $0ad8475f7d1b2066$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $0ad8475f7d1b2066$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $0ad8475f7d1b2066$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $0ad8475f7d1b2066$var$rsPunctuationRange = '\\u2000-\\u206f', $0ad8475f7d1b2066$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $0ad8475f7d1b2066$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $0ad8475f7d1b2066$var$rsVarRange = '\\ufe0e\\ufe0f', $0ad8475f7d1b2066$var$rsBreakRange = $0ad8475f7d1b2066$var$rsMathOpRange + $0ad8475f7d1b2066$var$rsNonCharRange + $0ad8475f7d1b2066$var$rsPunctuationRange + $0ad8475f7d1b2066$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $0ad8475f7d1b2066$var$rsApos = "['\u2019]", $0ad8475f7d1b2066$var$rsBreak = '[' + $0ad8475f7d1b2066$var$rsBreakRange + ']', $0ad8475f7d1b2066$var$rsCombo = '[' + $0ad8475f7d1b2066$var$rsComboRange + ']', $0ad8475f7d1b2066$var$rsDigits = '\\d+', $0ad8475f7d1b2066$var$rsDingbat = '[' + $0ad8475f7d1b2066$var$rsDingbatRange + ']', $0ad8475f7d1b2066$var$rsLower = '[' + $0ad8475f7d1b2066$var$rsLowerRange + ']', $0ad8475f7d1b2066$var$rsMisc = '[^' + $0ad8475f7d1b2066$var$rsAstralRange + $0ad8475f7d1b2066$var$rsBreakRange + $0ad8475f7d1b2066$var$rsDigits + $0ad8475f7d1b2066$var$rsDingbatRange + $0ad8475f7d1b2066$var$rsLowerRange + $0ad8475f7d1b2066$var$rsUpperRange + ']', $0ad8475f7d1b2066$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $0ad8475f7d1b2066$var$rsModifier = '(?:' + $0ad8475f7d1b2066$var$rsCombo + '|' + $0ad8475f7d1b2066$var$rsFitz + ')', $0ad8475f7d1b2066$var$rsNonAstral = '[^' + $0ad8475f7d1b2066$var$rsAstralRange + ']', $0ad8475f7d1b2066$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $0ad8475f7d1b2066$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $0ad8475f7d1b2066$var$rsUpper = '[' + $0ad8475f7d1b2066$var$rsUpperRange + ']', $0ad8475f7d1b2066$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $0ad8475f7d1b2066$var$rsMiscLower = '(?:' + $0ad8475f7d1b2066$var$rsLower + '|' + $0ad8475f7d1b2066$var$rsMisc + ')', $0ad8475f7d1b2066$var$rsMiscUpper = '(?:' + $0ad8475f7d1b2066$var$rsUpper + '|' + $0ad8475f7d1b2066$var$rsMisc + ')', $0ad8475f7d1b2066$var$rsOptContrLower = '(?:' + $0ad8475f7d1b2066$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $0ad8475f7d1b2066$var$rsOptContrUpper = '(?:' + $0ad8475f7d1b2066$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $0ad8475f7d1b2066$var$reOptMod = $0ad8475f7d1b2066$var$rsModifier + '?', $0ad8475f7d1b2066$var$rsOptVar = '[' + $0ad8475f7d1b2066$var$rsVarRange + ']?', $0ad8475f7d1b2066$var$rsOptJoin = '(?:' + $0ad8475f7d1b2066$var$rsZWJ + '(?:' + [
    $0ad8475f7d1b2066$var$rsNonAstral,
    $0ad8475f7d1b2066$var$rsRegional,
    $0ad8475f7d1b2066$var$rsSurrPair
].join('|') + ')' + $0ad8475f7d1b2066$var$rsOptVar + $0ad8475f7d1b2066$var$reOptMod + ')*', $0ad8475f7d1b2066$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $0ad8475f7d1b2066$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $0ad8475f7d1b2066$var$rsSeq = $0ad8475f7d1b2066$var$rsOptVar + $0ad8475f7d1b2066$var$reOptMod + $0ad8475f7d1b2066$var$rsOptJoin, $0ad8475f7d1b2066$var$rsEmoji = '(?:' + [
    $0ad8475f7d1b2066$var$rsDingbat,
    $0ad8475f7d1b2066$var$rsRegional,
    $0ad8475f7d1b2066$var$rsSurrPair
].join('|') + ')' + $0ad8475f7d1b2066$var$rsSeq;
/** Used to match complex or compound words. */ var $0ad8475f7d1b2066$var$reUnicodeWord = RegExp([
    $0ad8475f7d1b2066$var$rsUpper + '?' + $0ad8475f7d1b2066$var$rsLower + '+' + $0ad8475f7d1b2066$var$rsOptContrLower + '(?=' + [
        $0ad8475f7d1b2066$var$rsBreak,
        $0ad8475f7d1b2066$var$rsUpper,
        '$'
    ].join('|') + ')',
    $0ad8475f7d1b2066$var$rsMiscUpper + '+' + $0ad8475f7d1b2066$var$rsOptContrUpper + '(?=' + [
        $0ad8475f7d1b2066$var$rsBreak,
        $0ad8475f7d1b2066$var$rsUpper + $0ad8475f7d1b2066$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $0ad8475f7d1b2066$var$rsUpper + '?' + $0ad8475f7d1b2066$var$rsMiscLower + '+' + $0ad8475f7d1b2066$var$rsOptContrLower,
    $0ad8475f7d1b2066$var$rsUpper + '+' + $0ad8475f7d1b2066$var$rsOptContrUpper,
    $0ad8475f7d1b2066$var$rsOrdUpper,
    $0ad8475f7d1b2066$var$rsOrdLower,
    $0ad8475f7d1b2066$var$rsDigits,
    $0ad8475f7d1b2066$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $0ad8475f7d1b2066$var$unicodeWords(string) {
    return string.match($0ad8475f7d1b2066$var$reUnicodeWord) || [];
}
$0ad8475f7d1b2066$exports = $0ad8475f7d1b2066$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $487a257bdcb2bdff$var$words(string, pattern, guard) {
    string = $dojlP(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $0345ee1c1330ce64$exports(string) ? $0ad8475f7d1b2066$exports(string) : $9a2f3e75ee5feeb7$exports(string);
    return string.match(pattern) || [];
}
$487a257bdcb2bdff$exports = $487a257bdcb2bdff$var$words;


/** Used to compose unicode capture groups. */ var $92b4a27016292a01$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $92b4a27016292a01$var$reApos = RegExp($92b4a27016292a01$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $92b4a27016292a01$var$createCompounder(callback) {
    return function(string) {
        return $1XwR6($487a257bdcb2bdff$exports($iJuQU(string).replace($92b4a27016292a01$var$reApos, '')), callback, '');
    };
}
module.exports = $92b4a27016292a01$var$createCompounder;

});

parcelRegister("1XwR6", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $16d4c9915bd47418$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $16d4c9915bd47418$var$arrayReduce;

});

parcelRegister("iJuQU", function(module, exports) {
var $e22b30ab89044a9d$exports = {};

var $aJnR3 = parcelRequire("aJnR3");

/** Used to map Latin Unicode letters to basic Latin letters. */ var $e22b30ab89044a9d$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $e22b30ab89044a9d$var$deburrLetter = $aJnR3($e22b30ab89044a9d$var$deburredLetters);
$e22b30ab89044a9d$exports = $e22b30ab89044a9d$var$deburrLetter;



var $dojlP = parcelRequire("dojlP");

/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $da345c9acd79b047$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $da345c9acd79b047$var$rsComboMarksRange = '\\u0300-\\u036f', $da345c9acd79b047$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $da345c9acd79b047$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $da345c9acd79b047$var$rsComboRange = $da345c9acd79b047$var$rsComboMarksRange + $da345c9acd79b047$var$reComboHalfMarksRange + $da345c9acd79b047$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $da345c9acd79b047$var$rsCombo = '[' + $da345c9acd79b047$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $da345c9acd79b047$var$reComboMark = RegExp($da345c9acd79b047$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $da345c9acd79b047$var$deburr(string) {
    string = $dojlP(string);
    return string && string.replace($da345c9acd79b047$var$reLatin, $e22b30ab89044a9d$exports).replace($da345c9acd79b047$var$reComboMark, '');
}
module.exports = $da345c9acd79b047$var$deburr;

});

parcelRegister("aJnR3", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $7d009c69d9a93bc5$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $7d009c69d9a93bc5$var$basePropertyOf;

});

parcelRegister("kMzDv", function(module, exports) {
$parcel$export(module.exports, "auth", () => (parcelRequire("eEPSE")).auth);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("7zxJs")).AuthError);

var $eEPSE = parcelRequire("eEPSE");


var $7zxJs = parcelRequire("7zxJs");


});

parcelRegister("eEPSE", function(module, exports) {

var $7zxJs = parcelRequire("7zxJs");


var $75u2V = parcelRequire("75u2V");

function $4e31e5414e67a93e$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $75u2V.isOfTypeAuthError)(errorType)) reject(new (0, $7zxJs.AuthError)(data.message, errorType));
                    else reject(new (0, $7zxJs.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $7zxJs.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $4e31e5414e67a93e$export$73693bad9f5880b0;

});

parcelRegister("7zxJs", function(module, exports) {
class $dd3fe40c981b3bd9$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $dd3fe40c981b3bd9$export$145273558d58e0ac;

});

parcelRegister("75u2V", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $6f56de9d96dc4f7f$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $6f56de9d96dc4f7f$export$400e64c8451aa84f;

});

parcelRegister("7Y8M5", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fqVYq = parcelRequire("fqVYq");

const $cf062bdf6f9f2e9e$export$fe6b0b821a0e9067 = 16;
const $cf062bdf6f9f2e9e$export$24495b314f307191 = 13;
const $cf062bdf6f9f2e9e$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $cf062bdf6f9f2e9e$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $cf062bdf6f9f2e9e$export$a7a75e50ae62d0a8 = "var(--ds-border, #0B120E24)";
const $cf062bdf6f9f2e9e$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $cf062bdf6f9f2e9e$export$f0e953d95429ca1 = '12px';
const $cf062bdf6f9f2e9e$export$a309dbdeca0adb1a = '2px 4px';
const $cf062bdf6f9f2e9e$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $cf062bdf6f9f2e9e$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $cf062bdf6f9f2e9e$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $cf062bdf6f9f2e9e$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $cf062bdf6f9f2e9e$export$d2715266dd4a1fd1 = 20;
const $cf062bdf6f9f2e9e$export$cf524c1b49838a49 = "var(--ds-border-selected, #1868DB)";
const $cf062bdf6f9f2e9e$export$8dac549e32469ac4 = 1;
const $cf062bdf6f9f2e9e$export$befaaae517e3d864 = 2;
const $cf062bdf6f9f2e9e$export$6e1e1996c4e8cc51 = `${$cf062bdf6f9f2e9e$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #1868DB)"}`;
const $cf062bdf6f9f2e9e$export$b6a59ac3a19b6343 = `0 0 0 ${$cf062bdf6f9f2e9e$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #1868DB)"}`;
const $cf062bdf6f9f2e9e$export$37e178ca41c198ca = `0 0 0 ${$cf062bdf6f9f2e9e$export$befaaae517e3d864}px ${"var(--ds-border-selected, #1868DB)"}`;
const $cf062bdf6f9f2e9e$export$4a007c22e25e31f6 = 0.3;
const $cf062bdf6f9f2e9e$export$f35cc48f3398ab79 = 1;
const $cf062bdf6f9f2e9e$export$b46cda584c619451 = 2;
const $cf062bdf6f9f2e9e$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $cf062bdf6f9f2e9e$export$321ddd2f049dd12 = $cf062bdf6f9f2e9e$export$6bed85de54b5de42 + 1;
const $cf062bdf6f9f2e9e$export$daeac9b8422ac3c2 = 2;
const $cf062bdf6f9f2e9e$export$501d46e11ed5bf73 = 500;
const $cf062bdf6f9f2e9e$export$6817b4b6a5ef78f1 = 400;
const $cf062bdf6f9f2e9e$export$93768eb72dec48ce = $cf062bdf6f9f2e9e$export$501d46e11ed5bf73 + 10;
const $cf062bdf6f9f2e9e$export$c0aec4e0896849a0 = $cf062bdf6f9f2e9e$export$93768eb72dec48ce - 5;
const $cf062bdf6f9f2e9e$export$5886f057e4f21fe4 = $cf062bdf6f9f2e9e$export$6817b4b6a5ef78f1 + 5;
const $cf062bdf6f9f2e9e$export$6e85faa46d537a3f = 11;
const $cf062bdf6f9f2e9e$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $cf062bdf6f9f2e9e$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $cf062bdf6f9f2e9e$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $cf062bdf6f9f2e9e$export$95e9a0285b97474d = '#2C333A';
const $cf062bdf6f9f2e9e$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #4688EC)";
const $cf062bdf6f9f2e9e$export$76b5e653883e5290 = '3px';
const $cf062bdf6f9f2e9e$export$d0fb376c4d4be9e2 = '--table-container-bg';
const $cf062bdf6f9f2e9e$export$6d85fe8177a50c0c = 0.5;
const $cf062bdf6f9f2e9e$export$fad19f16d3f953a3 = 680;
const $cf062bdf6f9f2e9e$export$9db045950eedb49f = 760;
const $cf062bdf6f9f2e9e$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $cf062bdf6f9f2e9e$export$f580e3d28d0986de = 1800;
const $cf062bdf6f9f2e9e$export$c0f7d71e10d277e9 = 4000;
const $cf062bdf6f9f2e9e$export$9d5488b5afad62bf = 1792;
const $cf062bdf6f9f2e9e$export$45eb0f5135abf6f1 = 4000;
const $cf062bdf6f9f2e9e$export$37df10057d36a0e5 = 42;
const $cf062bdf6f9f2e9e$export$437293c5e9fc2703 = 96;
const $cf062bdf6f9f2e9e$export$6e0f4d52efd3d2d = 32;
const $cf062bdf6f9f2e9e$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $iDrrr.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $cf062bdf6f9f2e9e$export$aae87d25ced827bb = 24;
const $cf062bdf6f9f2e9e$export$cccda66937c91e4c = 600;
const $cf062bdf6f9f2e9e$export$efe8561bbd3f74d2 = 720;
const $cf062bdf6f9f2e9e$export$e4d39a9e8607c1d3 = 48;
const $cf062bdf6f9f2e9e$export$43946f2400ab6f1f = 128;
const $cf062bdf6f9f2e9e$export$558438ae7fd4b8ce = 12;
const $cf062bdf6f9f2e9e$export$6beb98d32d4ca149 = 4;
const $cf062bdf6f9f2e9e$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $cf062bdf6f9f2e9e$export$5edb4f38c3eacb1a = 1024;
const $cf062bdf6f9f2e9e$export$e60820063058ed59 = 1.33;
const $cf062bdf6f9f2e9e$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $cf062bdf6f9f2e9e$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $cf062bdf6f9f2e9e$export$fb15fade89f67217 = $cf062bdf6f9f2e9e$export$f35cc48f3398ab79 * 99;
const $cf062bdf6f9f2e9e$export$847030921e9d5a40 = 12;
const $cf062bdf6f9f2e9e$export$40eb41ab799f0329 = 1.714;
const $cf062bdf6f9f2e9e$export$e271312fc7124aec = '1px';
const $cf062bdf6f9f2e9e$export$d29cb2c31fcbb7c5 = 2;
const $cf062bdf6f9f2e9e$export$688a6dc01e760755 = 320;
const $cf062bdf6f9f2e9e$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $cf062bdf6f9f2e9e$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $cf062bdf6f9f2e9e$export$e88f6c898960b391 = $cf062bdf6f9f2e9e$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $cf062bdf6f9f2e9e$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $cf062bdf6f9f2e9e$export$1d0d506416d457f1 = '0.75rem';
const $cf062bdf6f9f2e9e$export$53030af820b542f5 = '0.75em';
const $cf062bdf6f9f2e9e$export$e683ef42725d1713 = 680;
const $cf062bdf6f9f2e9e$export$226c784ba04bd04b = 480;
const $cf062bdf6f9f2e9e$export$214ff00e5618d86c = 20;
const $cf062bdf6f9f2e9e$export$c82675fa56f2eefd = '56px';
const $cf062bdf6f9f2e9e$var$DEFAULT_FONT_SIZE = 14;
const $cf062bdf6f9f2e9e$export$d7726a000ae2d7c = (isToolbarAIFCEnabled)=>{
    if (// if value is undefined assume this is being called outside of editor where the experiment can be checked
    isToolbarAIFCEnabled === undefined ? (0, $fqVYq.editorExperiment)('platform_editor_toolbar_aifc', true) || (0, $iDrrr.fg)('platform_editor_ai_aifc_streaming') : isToolbarAIFCEnabled) return '44px';
    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
const $cf062bdf6f9f2e9e$export$d1343597f3b52d83 = 40;
const $cf062bdf6f9f2e9e$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $cf062bdf6f9f2e9e$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $cf062bdf6f9f2e9e$var$DEFAULT_FONT_SIZE;
const $cf062bdf6f9f2e9e$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$cf062bdf6f9f2e9e$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $cf062bdf6f9f2e9e$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $cf062bdf6f9f2e9e$export$46715ac1fbd9e64e = (value)=>{
    return `calc(${value} * var(--ak-editor-base-font-size) / ${$cf062bdf6f9f2e9e$export$fe6b0b821a0e9067})`;
};
const $cf062bdf6f9f2e9e$export$96b72b7f243fa693 = {
    a4KMonitor: {
        width: 3440,
        height: 1440
    },
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $cf062bdf6f9f2e9e$export$9369fd010fa0ddd6 = 0;
const $cf062bdf6f9f2e9e$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$cf062bdf6f9f2e9e$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $cf062bdf6f9f2e9e$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $cf062bdf6f9f2e9e$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E06C00)",
    "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #357DE8)",
    "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #AF59E1)",
    "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    "var(--ds-icon-accent-gray, #7D818A)",
    "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #614A05)"
];
const $cf062bdf6f9f2e9e$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
        svgBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        svgBackgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
];
module.exports["akEditorFullPageDefaultFontSize"] = $cf062bdf6f9f2e9e$export$fe6b0b821a0e9067;
module.exports["akEditorFullPageDenseFontSize"] = $cf062bdf6f9f2e9e$export$24495b314f307191;
module.exports["akEditorDeleteBorder"] = $cf062bdf6f9f2e9e$export$3c108a6bc41bb5f2;
module.exports["akEditorCustomIconSize"] = $cf062bdf6f9f2e9e$export$d2715266dd4a1fd1;
module.exports["akEditorSelectedBorderColor"] = $cf062bdf6f9f2e9e$export$cf524c1b49838a49;
module.exports["akEditorSelectedBorderSize"] = $cf062bdf6f9f2e9e$export$8dac549e32469ac4;
module.exports["akEditorSelectedBorderBoldSize"] = $cf062bdf6f9f2e9e$export$befaaae517e3d864;
module.exports["akEditorSelectedBorder"] = $cf062bdf6f9f2e9e$export$6e1e1996c4e8cc51;
module.exports["akEditorSelectedBoxShadow"] = $cf062bdf6f9f2e9e$export$b6a59ac3a19b6343;
module.exports["akEditorUnitZIndex"] = $cf062bdf6f9f2e9e$export$f35cc48f3398ab79;
module.exports["akEditorShadowZIndex"] = $cf062bdf6f9f2e9e$export$b46cda584c619451;
module.exports["akEditorStickyHeaderZIndex"] = $cf062bdf6f9f2e9e$export$6bed85de54b5de42;
module.exports["akEditorSmallZIndex"] = $cf062bdf6f9f2e9e$export$321ddd2f049dd12;
module.exports["akEditorGridLineZIndex"] = $cf062bdf6f9f2e9e$export$daeac9b8422ac3c2;
module.exports["akEditorMenuZIndex"] = $cf062bdf6f9f2e9e$export$501d46e11ed5bf73;
module.exports["akEditorFloatingPanelZIndex"] = $cf062bdf6f9f2e9e$export$6817b4b6a5ef78f1;
module.exports["akEditorFloatingDialogZIndex"] = $cf062bdf6f9f2e9e$export$93768eb72dec48ce;
module.exports["akEditorTableCellOnStickyHeaderZIndex"] = $cf062bdf6f9f2e9e$export$c0aec4e0896849a0;
module.exports["akEditorFloatingOverlapPanelZIndex"] = $cf062bdf6f9f2e9e$export$5886f057e4f21fe4;
module.exports["akEditorTableToolbarSize"] = $cf062bdf6f9f2e9e$export$6e85faa46d537a3f;
module.exports["akEditorTableContainerBg"] = $cf062bdf6f9f2e9e$export$d0fb376c4d4be9e2;
module.exports["akEditorFullPageMaxWidth"] = $cf062bdf6f9f2e9e$export$fad19f16d3f953a3;
module.exports["akEditorDefaultLayoutWidth"] = $cf062bdf6f9f2e9e$export$9db045950eedb49f;
module.exports["akEditorWideLayoutWidth"] = $cf062bdf6f9f2e9e$export$74c442132af16a;
module.exports["akEditorFullWidthLayoutWidth"] = $cf062bdf6f9f2e9e$export$f580e3d28d0986de;
module.exports["akEditorMaxWidthLayoutWidth"] = $cf062bdf6f9f2e9e$export$c0f7d71e10d277e9;
module.exports["akEditorMaxLayoutWidth"] = $cf062bdf6f9f2e9e$export$45eb0f5135abf6f1;
module.exports["akEditorTableNumberColumnWidth"] = $cf062bdf6f9f2e9e$export$37df10057d36a0e5;
module.exports["akEditorBreakoutPadding"] = $cf062bdf6f9f2e9e$export$437293c5e9fc2703;
module.exports["akEditorGutterPadding"] = $cf062bdf6f9f2e9e$export$6e0f4d52efd3d2d;
module.exports["akEditorGutterPaddingDynamic"] = $cf062bdf6f9f2e9e$export$f222e0c7a2dc5324;
module.exports["akEditorGutterPaddingReduced"] = $cf062bdf6f9f2e9e$export$aae87d25ced827bb;
module.exports["akEditorFullPageNarrowBreakout"] = $cf062bdf6f9f2e9e$export$cccda66937c91e4c;
module.exports["akEditorMobileBreakoutPoint"] = $cf062bdf6f9f2e9e$export$efe8561bbd3f74d2;
module.exports["akEditorTableCellMinWidth"] = $cf062bdf6f9f2e9e$export$e4d39a9e8607c1d3;
module.exports["akEditorTableLegacyCellMinWidth"] = $cf062bdf6f9f2e9e$export$43946f2400ab6f1f;
module.exports["akEditorMediaResizeHandlerPaddingWide"] = $cf062bdf6f9f2e9e$export$558438ae7fd4b8ce;
module.exports["akEditorMediaResizeHandlerPadding"] = $cf062bdf6f9f2e9e$export$6beb98d32d4ca149;
module.exports["akEditorSwoopCubicBezier"] = $cf062bdf6f9f2e9e$export$3b24948cd5dbb087;
module.exports["gridMediumMaxWidth"] = $cf062bdf6f9f2e9e$export$5edb4f38c3eacb1a;
module.exports["breakoutWideScaleRatio"] = $cf062bdf6f9f2e9e$export$e60820063058ed59;
module.exports["akEditorCalculatedWideLayoutWidthSmallViewport"] = $cf062bdf6f9f2e9e$export$60da500206e2ceec;
module.exports["akEditorCalculatedWideLayoutWidth"] = $cf062bdf6f9f2e9e$export$c0e6648ae1bb2fac;
module.exports["akRichMediaResizeZIndex"] = $cf062bdf6f9f2e9e$export$fb15fade89f67217;
module.exports["akLayoutGutterOffset"] = $cf062bdf6f9f2e9e$export$847030921e9d5a40;
module.exports["akEditorLineHeight"] = $cf062bdf6f9f2e9e$export$40eb41ab799f0329;
module.exports["akEditorContextPanelWidth"] = $cf062bdf6f9f2e9e$export$688a6dc01e760755;
module.exports["akEditorWrappedNodeZIndex"] = $cf062bdf6f9f2e9e$export$e88f6c898960b391;
module.exports["layoutBreakpointWidth"] = $cf062bdf6f9f2e9e$export$e5c605f2b2a12b00;
module.exports["blockNodesVerticalMargin"] = $cf062bdf6f9f2e9e$export$1d0d506416d457f1;
module.exports["scaledBlockNodesVerticalMargin"] = $cf062bdf6f9f2e9e$export$53030af820b542f5;
module.exports["DEFAULT_EMBED_CARD_WIDTH"] = $cf062bdf6f9f2e9e$export$e683ef42725d1713;
module.exports["DEFAULT_EMBED_CARD_HEIGHT"] = $cf062bdf6f9f2e9e$export$226c784ba04bd04b;
module.exports["MAX_BROWSER_SCROLLBAR_HEIGHT"] = $cf062bdf6f9f2e9e$export$214ff00e5618d86c;
module.exports["FULL_PAGE_EDITOR_TOOLBAR_HEIGHT"] = $cf062bdf6f9f2e9e$export$d7726a000ae2d7c;
module.exports["akEditorFullPageToolbarHeight"] = $cf062bdf6f9f2e9e$export$d1343597f3b52d83;
module.exports["akEditorSelectedNodeClassName"] = $cf062bdf6f9f2e9e$export$a02a3f1515c2e21a;
module.exports["editorFontSize"] = $cf062bdf6f9f2e9e$export$58a725ff69bda73a;
module.exports["relativeFontSizeToBase16"] = $cf062bdf6f9f2e9e$export$59733a9f61449b25;
module.exports["relativeSizeToBaseFontSize"] = $cf062bdf6f9f2e9e$export$46715ac1fbd9e64e;
module.exports["akEditorMobileMaxWidth"] = $cf062bdf6f9f2e9e$export$9369fd010fa0ddd6;
module.exports["participantColors"] = $cf062bdf6f9f2e9e$export$42608c013398a830;

});

parcelRegister("kCECX", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

const $f036df05e43fe672$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $f036df05e43fe672$export$52baac22726c72bf {
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $aPdNQ.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $aPdNQ.Slice).empty : content);
            if (i == 0) $f036df05e43fe672$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $f036df05e43fe672$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $f036df05e43fe672$export$c2b25f346d19bcbb($pos) : $f036df05e43fe672$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $f036df05e43fe672$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $f036df05e43fe672$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $f036df05e43fe672$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $f036df05e43fe672$var$findSelectionIn(doc, doc, 0, 0, 1) || new $f036df05e43fe672$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $f036df05e43fe672$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $f036df05e43fe672$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $f036df05e43fe672$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $f036df05e43fe672$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $f036df05e43fe672$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $f036df05e43fe672$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $f036df05e43fe672$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
}
$f036df05e43fe672$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $f036df05e43fe672$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $f036df05e43fe672$var$warnedAboutTextSelection = false;
function $f036df05e43fe672$var$checkTextSelection($pos) {
    if (!$f036df05e43fe672$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $f036df05e43fe672$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $f036df05e43fe672$export$c2b25f346d19bcbb extends $f036df05e43fe672$export$52baac22726c72bf {
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $f036df05e43fe672$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $f036df05e43fe672$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $aPdNQ.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $aPdNQ.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $f036df05e43fe672$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $f036df05e43fe672$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $f036df05e43fe672$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $f036df05e43fe672$export$52baac22726c72bf.findFrom($head, bias, true) || $f036df05e43fe672$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $f036df05e43fe672$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($f036df05e43fe672$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $f036df05e43fe672$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $f036df05e43fe672$export$c2b25f346d19bcbb($anchor, $head);
    }
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $f036df05e43fe672$var$checkTextSelection($anchor);
        $f036df05e43fe672$var$checkTextSelection($head);
        super($anchor, $head);
    }
}
$f036df05e43fe672$export$52baac22726c72bf.jsonID("text", $f036df05e43fe672$export$c2b25f346d19bcbb);
class $f036df05e43fe672$var$TextBookmark {
    map(mapping) {
        return new $f036df05e43fe672$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $f036df05e43fe672$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $f036df05e43fe672$export$e2940151ac854c0b extends $f036df05e43fe672$export$52baac22726c72bf {
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $f036df05e43fe672$export$52baac22726c72bf.near($pos);
        return new $f036df05e43fe672$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $f036df05e43fe672$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $f036df05e43fe672$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $f036df05e43fe672$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $f036df05e43fe672$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
}
$f036df05e43fe672$export$e2940151ac854c0b.prototype.visible = false;
$f036df05e43fe672$export$52baac22726c72bf.jsonID("node", $f036df05e43fe672$export$e2940151ac854c0b);
class $f036df05e43fe672$var$NodeBookmark {
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $f036df05e43fe672$var$TextBookmark(pos, pos) : new $f036df05e43fe672$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $f036df05e43fe672$export$e2940151ac854c0b.isSelectable(node)) return new $f036df05e43fe672$export$e2940151ac854c0b($pos);
        return $f036df05e43fe672$export$52baac22726c72bf.near($pos);
    }
    constructor(anchor){
        this.anchor = anchor;
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $f036df05e43fe672$export$c15d9ba76bdbcd95 extends $f036df05e43fe672$export$52baac22726c72bf {
    replace(tr, content = (0, $aPdNQ.Slice).empty) {
        if (content == (0, $aPdNQ.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $f036df05e43fe672$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $f036df05e43fe672$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $f036df05e43fe672$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $f036df05e43fe672$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $f036df05e43fe672$var$AllBookmark;
    }
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
}
$f036df05e43fe672$export$52baac22726c72bf.jsonID("all", $f036df05e43fe672$export$c15d9ba76bdbcd95);
const $f036df05e43fe672$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $f036df05e43fe672$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $f036df05e43fe672$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $f036df05e43fe672$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $f036df05e43fe672$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $f036df05e43fe672$export$e2940151ac854c0b.isSelectable(child)) return $f036df05e43fe672$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $f036df05e43fe672$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($f036df05e43fe672$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $f036df05e43fe672$var$UPDATED_SEL = 1, $f036df05e43fe672$var$UPDATED_MARKS = 2, $f036df05e43fe672$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $f036df05e43fe672$export$febc5573c75cefb0 extends (0, $eOaGc.Transform) {
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $f036df05e43fe672$var$UPDATED_SEL) & ~$f036df05e43fe672$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $f036df05e43fe672$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $f036df05e43fe672$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $aPdNQ.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $f036df05e43fe672$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$f036df05e43fe672$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $aPdNQ.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($f036df05e43fe672$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $f036df05e43fe672$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $f036df05e43fe672$var$UPDATED_SCROLL) > 0;
    }
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
}
function $f036df05e43fe672$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $f036df05e43fe672$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $f036df05e43fe672$var$bind(desc.init, self);
        this.apply = $f036df05e43fe672$var$bind(desc.apply, self);
    }
}
const $f036df05e43fe672$var$baseFields = [
    new $f036df05e43fe672$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $f036df05e43fe672$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $f036df05e43fe672$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $f036df05e43fe672$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $f036df05e43fe672$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $f036df05e43fe672$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $f036df05e43fe672$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $f036df05e43fe672$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $f036df05e43fe672$export$afa855cbfaff27f2 {
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $f036df05e43fe672$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $f036df05e43fe672$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $f036df05e43fe672$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $f036df05e43fe672$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $f036df05e43fe672$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $f036df05e43fe672$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $f036df05e43fe672$var$Configuration(config.schema, config.plugins);
        let instance = new $f036df05e43fe672$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $aPdNQ.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $f036df05e43fe672$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
}
function $f036df05e43fe672$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $f036df05e43fe672$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $f036df05e43fe672$export$901cf72dabf2112a {
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $f036df05e43fe672$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $f036df05e43fe672$var$createKey("plugin");
    }
}
const $f036df05e43fe672$var$keys = Object.create(null);
function $f036df05e43fe672$var$createKey(name) {
    if (name in $f036df05e43fe672$var$keys) return name + "$" + ++$f036df05e43fe672$var$keys[name];
    $f036df05e43fe672$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $f036df05e43fe672$export$1692d8b0e89cecc3 {
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $f036df05e43fe672$var$createKey(name);
    }
}
module.exports["Selection"] = $f036df05e43fe672$export$52baac22726c72bf;
module.exports["TextSelection"] = $f036df05e43fe672$export$c2b25f346d19bcbb;
module.exports["AllSelection"] = $f036df05e43fe672$export$c15d9ba76bdbcd95;
module.exports["SelectionRange"] = $f036df05e43fe672$export$7bd1839c3c5d5bd4;
module.exports["NodeSelection"] = $f036df05e43fe672$export$e2940151ac854c0b;
module.exports["Transaction"] = $f036df05e43fe672$export$febc5573c75cefb0;
module.exports["EditorState"] = $f036df05e43fe672$export$afa855cbfaff27f2;
module.exports["Plugin"] = $f036df05e43fe672$export$901cf72dabf2112a;
module.exports["PluginKey"] = $f036df05e43fe672$export$1692d8b0e89cecc3;

});

parcelRegister("eOaGc", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $ac7e04edabedbb6f$var$lower16 = 0xffff;
const $ac7e04edabedbb6f$var$factor16 = Math.pow(2, 16);
function $ac7e04edabedbb6f$var$makeRecover(index, offset) {
    return index + offset * $ac7e04edabedbb6f$var$factor16;
}
function $ac7e04edabedbb6f$var$recoverIndex(value) {
    return value & $ac7e04edabedbb6f$var$lower16;
}
function $ac7e04edabedbb6f$var$recoverOffset(value) {
    return (value - (value & $ac7e04edabedbb6f$var$lower16)) / $ac7e04edabedbb6f$var$factor16;
}
const $ac7e04edabedbb6f$var$DEL_BEFORE = 1, $ac7e04edabedbb6f$var$DEL_AFTER = 2, $ac7e04edabedbb6f$var$DEL_ACROSS = 4, $ac7e04edabedbb6f$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $ac7e04edabedbb6f$export$c77c9be41668e9b4 {
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $ac7e04edabedbb6f$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($ac7e04edabedbb6f$var$DEL_BEFORE | $ac7e04edabedbb6f$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($ac7e04edabedbb6f$var$DEL_AFTER | $ac7e04edabedbb6f$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $ac7e04edabedbb6f$var$DEL_ACROSS) > 0;
    }
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $ac7e04edabedbb6f$export$c53d01c3ab9721b3 {
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $ac7e04edabedbb6f$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $ac7e04edabedbb6f$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $ac7e04edabedbb6f$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $ac7e04edabedbb6f$var$DEL_AFTER : pos == end ? $ac7e04edabedbb6f$var$DEL_BEFORE : $ac7e04edabedbb6f$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $ac7e04edabedbb6f$var$DEL_SIDE;
                return new $ac7e04edabedbb6f$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $ac7e04edabedbb6f$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $ac7e04edabedbb6f$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $ac7e04edabedbb6f$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $ac7e04edabedbb6f$export$c53d01c3ab9721b3.empty : new $ac7e04edabedbb6f$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $ac7e04edabedbb6f$export$c53d01c3ab9721b3.empty) return $ac7e04edabedbb6f$export$c53d01c3ab9721b3.empty;
    }
}
/**
A StepMap that contains no changed ranges.
*/ $ac7e04edabedbb6f$export$c53d01c3ab9721b3.empty = new $ac7e04edabedbb6f$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $ac7e04edabedbb6f$export$f5f785078011b62 {
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $ac7e04edabedbb6f$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $ac7e04edabedbb6f$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $ac7e04edabedbb6f$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $ac7e04edabedbb6f$export$c77c9be41668e9b4(pos, delInfo, null);
    }
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
}
const $ac7e04edabedbb6f$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $ac7e04edabedbb6f$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $ac7e04edabedbb6f$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $ac7e04edabedbb6f$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $ac7e04edabedbb6f$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $ac7e04edabedbb6f$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $ac7e04edabedbb6f$export$8ebf1578a4199c09 {
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $ac7e04edabedbb6f$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $ac7e04edabedbb6f$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $ac7e04edabedbb6f$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $aPdNQ.ReplaceError)) return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
}
function $ac7e04edabedbb6f$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($ac7e04edabedbb6f$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $aPdNQ.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $ac7e04edabedbb6f$export$d24ba56b0e3464a9 extends $ac7e04edabedbb6f$export$fd55ce593607084a {
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $aPdNQ.Slice)($ac7e04edabedbb6f$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $ac7e04edabedbb6f$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $ac7e04edabedbb6f$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $ac7e04edabedbb6f$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ac7e04edabedbb6f$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $ac7e04edabedbb6f$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
}
$ac7e04edabedbb6f$export$fd55ce593607084a.jsonID("addMark", $ac7e04edabedbb6f$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $ac7e04edabedbb6f$export$94150db1311f67a9 extends $ac7e04edabedbb6f$export$fd55ce593607084a {
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $aPdNQ.Slice)($ac7e04edabedbb6f$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $ac7e04edabedbb6f$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $ac7e04edabedbb6f$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $ac7e04edabedbb6f$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ac7e04edabedbb6f$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $ac7e04edabedbb6f$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
}
$ac7e04edabedbb6f$export$fd55ce593607084a.jsonID("removeMark", $ac7e04edabedbb6f$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $ac7e04edabedbb6f$export$adefd16c402fee4e extends $ac7e04edabedbb6f$export$fd55ce593607084a {
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $ac7e04edabedbb6f$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $ac7e04edabedbb6f$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $ac7e04edabedbb6f$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ac7e04edabedbb6f$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $ac7e04edabedbb6f$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
}
$ac7e04edabedbb6f$export$fd55ce593607084a.jsonID("addNodeMark", $ac7e04edabedbb6f$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $ac7e04edabedbb6f$export$fdf7d1dc10724da2 extends $ac7e04edabedbb6f$export$fd55ce593607084a {
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $ac7e04edabedbb6f$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ac7e04edabedbb6f$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $ac7e04edabedbb6f$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
}
$ac7e04edabedbb6f$export$fd55ce593607084a.jsonID("removeNodeMark", $ac7e04edabedbb6f$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $ac7e04edabedbb6f$export$5c860b2e74034756 extends $ac7e04edabedbb6f$export$fd55ce593607084a {
    apply(doc) {
        if (this.structure && $ac7e04edabedbb6f$var$contentBetween(doc, this.from, this.to)) return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $ac7e04edabedbb6f$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $ac7e04edabedbb6f$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $ac7e04edabedbb6f$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $ac7e04edabedbb6f$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $aPdNQ.Slice).empty : new (0, $aPdNQ.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $ac7e04edabedbb6f$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $aPdNQ.Slice).empty : new (0, $aPdNQ.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $ac7e04edabedbb6f$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $ac7e04edabedbb6f$export$5c860b2e74034756(json.from, json.to, (0, $aPdNQ.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
}
$ac7e04edabedbb6f$export$fd55ce593607084a.jsonID("replace", $ac7e04edabedbb6f$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $ac7e04edabedbb6f$export$444ba800d6024a98 extends $ac7e04edabedbb6f$export$fd55ce593607084a {
    apply(doc) {
        if (this.structure && ($ac7e04edabedbb6f$var$contentBetween(doc, this.from, this.gapFrom) || $ac7e04edabedbb6f$var$contentBetween(doc, this.gapTo, this.to))) return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $ac7e04edabedbb6f$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $ac7e04edabedbb6f$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $ac7e04edabedbb6f$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $ac7e04edabedbb6f$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $aPdNQ.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
}
$ac7e04edabedbb6f$export$fd55ce593607084a.jsonID("replaceAround", $ac7e04edabedbb6f$export$444ba800d6024a98);
function $ac7e04edabedbb6f$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $ac7e04edabedbb6f$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $ac7e04edabedbb6f$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $ac7e04edabedbb6f$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $ac7e04edabedbb6f$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $aPdNQ.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $ac7e04edabedbb6f$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $ac7e04edabedbb6f$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $ac7e04edabedbb6f$export$5c860b2e74034756(cur, end, (0, $aPdNQ.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $ac7e04edabedbb6f$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $ac7e04edabedbb6f$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $aPdNQ.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $aPdNQ.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $ac7e04edabedbb6f$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $ac7e04edabedbb6f$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$ac7e04edabedbb6f$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $ac7e04edabedbb6f$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $aPdNQ.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $aPdNQ.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $aPdNQ.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $aPdNQ.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $ac7e04edabedbb6f$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $aPdNQ.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $ac7e04edabedbb6f$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $ac7e04edabedbb6f$var$findWrappingOutside(range, nodeType);
    let inner = around && $ac7e04edabedbb6f$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($ac7e04edabedbb6f$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($ac7e04edabedbb6f$var$withAttrs));
}
function $ac7e04edabedbb6f$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $ac7e04edabedbb6f$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $ac7e04edabedbb6f$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $ac7e04edabedbb6f$var$wrap(tr, range, wrappers) {
    let content = (0, $aPdNQ.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $aPdNQ.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $ac7e04edabedbb6f$export$444ba800d6024a98(start, end, start, end, new (0, $aPdNQ.Slice)(content, 0, 0), wrappers.length, true));
}
function $ac7e04edabedbb6f$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $ac7e04edabedbb6f$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $ac7e04edabedbb6f$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $ac7e04edabedbb6f$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $ac7e04edabedbb6f$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $ac7e04edabedbb6f$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $ac7e04edabedbb6f$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $ac7e04edabedbb6f$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $ac7e04edabedbb6f$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $ac7e04edabedbb6f$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $ac7e04edabedbb6f$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $ac7e04edabedbb6f$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $ac7e04edabedbb6f$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $aPdNQ.Fragment).empty, after = (0, $aPdNQ.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $aPdNQ.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $aPdNQ.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $ac7e04edabedbb6f$export$5c860b2e74034756(pos, pos, new (0, $aPdNQ.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $ac7e04edabedbb6f$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $ac7e04edabedbb6f$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $ac7e04edabedbb6f$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $ac7e04edabedbb6f$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $ac7e04edabedbb6f$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $ac7e04edabedbb6f$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $ac7e04edabedbb6f$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $ac7e04edabedbb6f$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $ac7e04edabedbb6f$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $ac7e04edabedbb6f$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $ac7e04edabedbb6f$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $aPdNQ.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $ac7e04edabedbb6f$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $ac7e04edabedbb6f$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $ac7e04edabedbb6f$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $ac7e04edabedbb6f$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $aPdNQ.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($ac7e04edabedbb6f$var$fitsTrivially($from, $to, slice)) return new $ac7e04edabedbb6f$export$5c860b2e74034756(from, to, slice);
    return new $ac7e04edabedbb6f$var$Fitter($from, $to, slice).fit();
}
function $ac7e04edabedbb6f$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $ac7e04edabedbb6f$var$Fitter {
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $aPdNQ.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $ac7e04edabedbb6f$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $ac7e04edabedbb6f$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $ac7e04edabedbb6f$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $aPdNQ.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $ac7e04edabedbb6f$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $aPdNQ.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $ac7e04edabedbb6f$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $aPdNQ.Slice)($ac7e04edabedbb6f$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $aPdNQ.Slice)($ac7e04edabedbb6f$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($ac7e04edabedbb6f$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $ac7e04edabedbb6f$var$addToFragment(this.placed, frontierDepth, (0, $aPdNQ.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $aPdNQ.Slice)($ac7e04edabedbb6f$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $aPdNQ.Slice).empty : new (0, $aPdNQ.Slice)($ac7e04edabedbb6f$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$ac7e04edabedbb6f$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $ac7e04edabedbb6f$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $ac7e04edabedbb6f$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $ac7e04edabedbb6f$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $ac7e04edabedbb6f$var$addToFragment(this.placed, this.depth, (0, $aPdNQ.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $aPdNQ.Fragment).empty, true);
        if (add.childCount) this.placed = $ac7e04edabedbb6f$var$addToFragment(this.placed, this.frontier.length, add);
    }
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $aPdNQ.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $aPdNQ.Fragment).from($from.node(i).copy(this.placed));
    }
}
function $ac7e04edabedbb6f$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($ac7e04edabedbb6f$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $ac7e04edabedbb6f$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($ac7e04edabedbb6f$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $ac7e04edabedbb6f$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $ac7e04edabedbb6f$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $ac7e04edabedbb6f$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $aPdNQ.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $ac7e04edabedbb6f$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$ac7e04edabedbb6f$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $ac7e04edabedbb6f$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $ac7e04edabedbb6f$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $ac7e04edabedbb6f$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($ac7e04edabedbb6f$var$fitsTrivially($from, $to, slice)) return tr.step(new $ac7e04edabedbb6f$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $ac7e04edabedbb6f$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $ac7e04edabedbb6f$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $aPdNQ.Slice)($ac7e04edabedbb6f$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $ac7e04edabedbb6f$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($ac7e04edabedbb6f$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $aPdNQ.Fragment).empty, true));
    }
    return fragment;
}
function $ac7e04edabedbb6f$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $ac7e04edabedbb6f$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(node), 0, 0));
}
function $ac7e04edabedbb6f$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $ac7e04edabedbb6f$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $ac7e04edabedbb6f$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $ac7e04edabedbb6f$export$626399c38172f669 extends $ac7e04edabedbb6f$export$fd55ce593607084a {
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $ac7e04edabedbb6f$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $ac7e04edabedbb6f$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $ac7e04edabedbb6f$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ac7e04edabedbb6f$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $ac7e04edabedbb6f$export$626399c38172f669(json.pos, json.attr, json.value);
    }
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
}
$ac7e04edabedbb6f$export$fd55ce593607084a.jsonID("attr", $ac7e04edabedbb6f$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $ac7e04edabedbb6f$export$f50707b396300ac9 extends $ac7e04edabedbb6f$export$fd55ce593607084a {
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $ac7e04edabedbb6f$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $ac7e04edabedbb6f$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $ac7e04edabedbb6f$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $ac7e04edabedbb6f$export$f50707b396300ac9(json.attr, json.value);
    }
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
}
$ac7e04edabedbb6f$export$fd55ce593607084a.jsonID("docAttr", $ac7e04edabedbb6f$export$f50707b396300ac9);
/**
@internal
*/ let $ac7e04edabedbb6f$export$88cc3a1dfce48dd3 = class extends Error {
};
$ac7e04edabedbb6f$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$ac7e04edabedbb6f$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$ac7e04edabedbb6f$export$88cc3a1dfce48dd3.prototype.constructor = $ac7e04edabedbb6f$export$88cc3a1dfce48dd3;
$ac7e04edabedbb6f$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $ac7e04edabedbb6f$export$563a914cafbdc389 {
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $ac7e04edabedbb6f$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $aPdNQ.Slice).empty) {
        let step = $ac7e04edabedbb6f$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $aPdNQ.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $ac7e04edabedbb6f$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $ac7e04edabedbb6f$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $ac7e04edabedbb6f$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $ac7e04edabedbb6f$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $ac7e04edabedbb6f$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $ac7e04edabedbb6f$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $ac7e04edabedbb6f$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $ac7e04edabedbb6f$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $ac7e04edabedbb6f$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $ac7e04edabedbb6f$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $ac7e04edabedbb6f$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $aPdNQ.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $ac7e04edabedbb6f$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $ac7e04edabedbb6f$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $ac7e04edabedbb6f$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $ac7e04edabedbb6f$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $ac7e04edabedbb6f$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $ac7e04edabedbb6f$export$f5f785078011b62;
    }
}
module.exports["StepMap"] = $ac7e04edabedbb6f$export$c53d01c3ab9721b3;
module.exports["Mapping"] = $ac7e04edabedbb6f$export$f5f785078011b62;
module.exports["Step"] = $ac7e04edabedbb6f$export$fd55ce593607084a;
module.exports["StepResult"] = $ac7e04edabedbb6f$export$8ebf1578a4199c09;
module.exports["AddMarkStep"] = $ac7e04edabedbb6f$export$d24ba56b0e3464a9;
module.exports["RemoveMarkStep"] = $ac7e04edabedbb6f$export$94150db1311f67a9;
module.exports["AddNodeMarkStep"] = $ac7e04edabedbb6f$export$adefd16c402fee4e;
module.exports["RemoveNodeMarkStep"] = $ac7e04edabedbb6f$export$fdf7d1dc10724da2;
module.exports["ReplaceStep"] = $ac7e04edabedbb6f$export$5c860b2e74034756;
module.exports["ReplaceAroundStep"] = $ac7e04edabedbb6f$export$444ba800d6024a98;
module.exports["liftTarget"] = $ac7e04edabedbb6f$export$f1508b72cc76a09e;
module.exports["findWrapping"] = $ac7e04edabedbb6f$export$118cb9a83e81ba37;
module.exports["canSplit"] = $ac7e04edabedbb6f$export$5aaf008897aef029;
module.exports["canJoin"] = $ac7e04edabedbb6f$export$f15f89fd9d8cc98a;
module.exports["joinPoint"] = $ac7e04edabedbb6f$export$41b1d4cb5ceb3147;
module.exports["insertPoint"] = $ac7e04edabedbb6f$export$64cb316d02de1dd1;
module.exports["dropPoint"] = $ac7e04edabedbb6f$export$2819d598d048fc9c;
module.exports["replaceStep"] = $ac7e04edabedbb6f$export$ed6ac67359824afd;
module.exports["AttrStep"] = $ac7e04edabedbb6f$export$626399c38172f669;
module.exports["DocAttrStep"] = $ac7e04edabedbb6f$export$f50707b396300ac9;
module.exports["Transform"] = $ac7e04edabedbb6f$export$563a914cafbdc389;

});

parcelRegister("bjg0G", function(module, exports) {
// src/selection.ts

var $kCECX = parcelRequire("kCECX");


var $aPdNQ = parcelRequire("aPdNQ");

var $83bde3516f8a33a9$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $83bde3516f8a33a9$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $83bde3516f8a33a9$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $83bde3516f8a33a9$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $83bde3516f8a33a9$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $83bde3516f8a33a9$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $83bde3516f8a33a9$export$7d6e4e6663186878 = (tr)=>{
    if ($83bde3516f8a33a9$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $83bde3516f8a33a9$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $83bde3516f8a33a9$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($83bde3516f8a33a9$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $aPdNQ.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $aPdNQ.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $83bde3516f8a33a9$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $83bde3516f8a33a9$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $kCECX.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $83bde3516f8a33a9$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $aPdNQ.Node) && node.type && node.type.spec.selectable);
var $83bde3516f8a33a9$var$shouldSelectNode = (node)=>$83bde3516f8a33a9$var$isSelectableNode(node) && node.type.isLeaf;
var $83bde3516f8a33a9$var$setSelection = (node, pos, tr)=>{
    if ($83bde3516f8a33a9$var$shouldSelectNode(node)) return tr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve(pos)));
    return $83bde3516f8a33a9$export$1df6d14df6b0b758(pos)(tr);
};
var $83bde3516f8a33a9$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $83bde3516f8a33a9$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($83bde3516f8a33a9$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $83bde3516f8a33a9$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($83bde3516f8a33a9$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $83bde3516f8a33a9$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $83bde3516f8a33a9$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $83bde3516f8a33a9$var$setSelection(content, pos, tr);
            }
        }
        if ($83bde3516f8a33a9$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $83bde3516f8a33a9$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $83bde3516f8a33a9$var$cloneTr($83bde3516f8a33a9$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($83bde3516f8a33a9$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $83bde3516f8a33a9$var$cloneTr($83bde3516f8a33a9$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $83bde3516f8a33a9$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $83bde3516f8a33a9$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $83bde3516f8a33a9$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $83bde3516f8a33a9$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$83bde3516f8a33a9$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $83bde3516f8a33a9$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $83bde3516f8a33a9$var$cloneTr(tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $83bde3516f8a33a9$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $83bde3516f8a33a9$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $83bde3516f8a33a9$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $83bde3516f8a33a9$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $kCECX.NodeSelection);
};
var $83bde3516f8a33a9$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $83bde3516f8a33a9$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $83bde3516f8a33a9$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($83bde3516f8a33a9$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $83bde3516f8a33a9$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $83bde3516f8a33a9$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $83bde3516f8a33a9$var$cloneTr(tr);
        }
        return tr;
    };
var $83bde3516f8a33a9$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $aPdNQ.Fragment) ? content : (0, $aPdNQ.Fragment).from(content));
};
var $83bde3516f8a33a9$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $83bde3516f8a33a9$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $83bde3516f8a33a9$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $aPdNQ.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $aPdNQ.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $83bde3516f8a33a9$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $83bde3516f8a33a9$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $83bde3516f8a33a9$export$fe09644e3bc6166b($from, predicate);
    };
var $83bde3516f8a33a9$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $83bde3516f8a33a9$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $83bde3516f8a33a9$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $83bde3516f8a33a9$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $83bde3516f8a33a9$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$83bde3516f8a33a9$export$dc159056ffdb4c76(predicate)(selection);
    };
var $83bde3516f8a33a9$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $83bde3516f8a33a9$export$dc159056ffdb4c76((node)=>$83bde3516f8a33a9$var$equalNodeType(nodeType, node))(selection);
    };
var $83bde3516f8a33a9$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $83bde3516f8a33a9$export$fe09644e3bc6166b($pos, (node)=>$83bde3516f8a33a9$var$equalNodeType(nodeType, node));
};
var $83bde3516f8a33a9$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $83bde3516f8a33a9$export$178ecaf80f45fdb6((node)=>$83bde3516f8a33a9$var$equalNodeType(nodeType, node))(selection);
    };
var $83bde3516f8a33a9$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $83bde3516f8a33a9$export$8556d79fa8189214((node)=>$83bde3516f8a33a9$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $83bde3516f8a33a9$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($83bde3516f8a33a9$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($83bde3516f8a33a9$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $83bde3516f8a33a9$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $kCECX.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $83bde3516f8a33a9$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $83bde3516f8a33a9$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $83bde3516f8a33a9$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $83bde3516f8a33a9$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $83bde3516f8a33a9$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $83bde3516f8a33a9$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $83bde3516f8a33a9$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $83bde3516f8a33a9$export$ddc1620722e25671 = (node, descend = true)=>{
    return $83bde3516f8a33a9$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $83bde3516f8a33a9$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $83bde3516f8a33a9$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $83bde3516f8a33a9$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $83bde3516f8a33a9$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $83bde3516f8a33a9$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $83bde3516f8a33a9$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $83bde3516f8a33a9$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $83bde3516f8a33a9$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $83bde3516f8a33a9$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$83bde3516f8a33a9$export$96bb9476c7c69f39(node, nodeType).length;
};
module.exports["removeParentNodeOfType"] = $83bde3516f8a33a9$export$5dd18664fe8bcbde;
module.exports["findParentNodeOfType"] = $83bde3516f8a33a9$export$1a3a74094b9968e;
module.exports["replaceParentNodeOfType"] = $83bde3516f8a33a9$export$b72cc612b642c071;
module.exports["removeSelectedNode"] = $83bde3516f8a33a9$export$7d6e4e6663186878;
module.exports["isNodeSelection"] = $83bde3516f8a33a9$export$a8c1d2c13abf8822;
module.exports["replaceSelectedNode"] = $83bde3516f8a33a9$export$39874bca494f9ba3;
module.exports["setTextSelection"] = $83bde3516f8a33a9$export$1df6d14df6b0b758;
module.exports["safeInsert"] = $83bde3516f8a33a9$export$5fe92db78385e37c;
module.exports["canInsert"] = $83bde3516f8a33a9$export$b4d1262a40ad21d4;
module.exports["removeNodeBefore"] = $83bde3516f8a33a9$export$ffb1550ab6c3d03c;
module.exports["findPositionOfNodeBefore"] = $83bde3516f8a33a9$export$f8088819b1e2c2dc;
module.exports["findParentNode"] = $83bde3516f8a33a9$export$dc159056ffdb4c76;
module.exports["findParentNodeClosestToPos"] = $83bde3516f8a33a9$export$fe09644e3bc6166b;
module.exports["findDomRefAtPos"] = $83bde3516f8a33a9$export$666ce65defe9ad6e;
module.exports["hasParentNode"] = $83bde3516f8a33a9$export$178ecaf80f45fdb6;
module.exports["findParentNodeOfTypeClosestToPos"] = $83bde3516f8a33a9$export$8bf0d019bde85d18;
module.exports["hasParentNodeOfType"] = $83bde3516f8a33a9$export$14f438bb7227ce63;
module.exports["findParentDomRefOfType"] = $83bde3516f8a33a9$export$faeafc1151740116;
module.exports["findSelectedNodeOfType"] = $83bde3516f8a33a9$export$924aa2dd4d9a67fa;
module.exports["flatten"] = $83bde3516f8a33a9$export$bffa455ba8c619a6;
module.exports["findChildren"] = $83bde3516f8a33a9$export$f94ca194e830789c;
module.exports["findChildrenByAttr"] = $83bde3516f8a33a9$export$a836476a7f9de5b4;
module.exports["findChildrenByType"] = $83bde3516f8a33a9$export$96bb9476c7c69f39;
module.exports["findChildrenByMark"] = $83bde3516f8a33a9$export$c01a9e7ec615e821;
module.exports["contains"] = $83bde3516f8a33a9$export$2344b14b097df817;

});

parcelRegister("8Z43Z", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $adebb7696b9a760b$var$readFromCache, $adebb7696b9a760b$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $adebb7696b9a760b$var$readFromCache = (key)=>cache.get(key);
    $adebb7696b9a760b$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $adebb7696b9a760b$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $adebb7696b9a760b$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $adebb7696b9a760b$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = void 0;
        this.top = void 0;
        this.right = void 0;
        this.bottom = void 0;
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $adebb7696b9a760b$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $adebb7696b9a760b$export$c60fae4049791eae = 140;
class $adebb7696b9a760b$export$493da463fed0a57a {
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $adebb7696b9a760b$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $adebb7696b9a760b$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $adebb7696b9a760b$var$readFromCache(table) || $adebb7696b9a760b$var$addToCache(table, $adebb7696b9a760b$var$computeMap(table));
    }
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        // The width of the table
        this.width = void 0;
        // The table's height
        this.height = void 0;
        this.map = void 0;
        this.problems = void 0;
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
}
// Compute a table map.
function $adebb7696b9a760b$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $adebb7696b9a760b$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $adebb7696b9a760b$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($adebb7696b9a760b$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $adebb7696b9a760b$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $adebb7696b9a760b$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $adebb7696b9a760b$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $adebb7696b9a760b$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $adebb7696b9a760b$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}
module.exports["Rect"] = $adebb7696b9a760b$export$c79fc6492f3af13d;
module.exports["TableProblemTypes"] = $adebb7696b9a760b$export$d8cd393a71edca79;
module.exports["TableMap"] = $adebb7696b9a760b$export$493da463fed0a57a;

});

parcelRegister("fJCU9", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");

var $0e40051270b2c33f$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $0e40051270b2c33f$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($eSa5t)))();
    }
}
module.exports["AnnotationUpdateEvent"] = $0e40051270b2c33f$export$c1c4b33b4e7b1c70;

});

parcelRegister("fYRS9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");











var $hekY6 = parcelRequire("hekY6");


var $9GVkD = parcelRequire("9GVkD");

const $1b6f0b06c7576879$var$decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
const $1b6f0b06c7576879$export$a592b67c93d52467 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Decorator(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { bidiCharacter: bidiCharacter, children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== bidiCharacter) {
        t1 = $1b6f0b06c7576879$var$getBidiCharacterCode(bidiCharacter);
        $[0] = bidiCharacter;
        $[1] = t1;
    } else t1 = $[1];
    const bidiCharacterCode = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $1b6f0b06c7576879$var$decoration.root
        ]);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== bidiCharacterCode || $[4] !== children || $[5] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true",
            className: t2
        }, children);
        $[3] = bidiCharacterCode;
        $[4] = children;
        $[5] = testId;
        $[6] = t3;
    } else t3 = $[6];
    const t4 = testId && `${testId}--visually-hidden`;
    let t5;
    if ($[7] !== bidiCharacterCode) {
        t5 = /*#__PURE__*/ $cozmU.createElement("mark", null, bidiCharacterCode);
        $[7] = bidiCharacterCode;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t4 || $[10] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
            testId: t4
        }, t5);
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t3 || $[13] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, t3, t6);
        $[12] = t3;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : function Decorator({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $1b6f0b06c7576879$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $1b6f0b06c7576879$var$decoration.root
        ])
    }, children), /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ $cozmU.createElement("mark", null, bidiCharacterCode)));
};
function $1b6f0b06c7576879$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}


/**
 * __Bidi Warning__
 *
 * A component used to render a bidi character warning.
 * A bidi character can be used to perform a "bidi override attack".
 *
 * See https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/1347434677/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability#1)-Providing-visual-cues-for-our-Customers-in-our-affected-products
 */ const $75f6060a0eba078d$var$BidiWarning = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BidiWarning(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: t1 } = t0;
    const label = t1 === undefined ? "Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code." : t1;
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) {
        const t2 = shouldSkip ? null : bidiCharacter;
        let t3;
        if ($[0] !== bidiCharacter || $[1] !== t2 || $[2] !== testId) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1b6f0b06c7576879$export$a592b67c93d52467), {
                testId: testId,
                bidiCharacter: bidiCharacter
            }, t2);
            $[0] = bidiCharacter;
            $[1] = t2;
            $[2] = testId;
            $[3] = t3;
        } else t3 = $[3];
        let t4;
        if ($[4] !== label || $[5] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: label,
                tag: $75f6060a0eba078d$var$CustomizedTagWithRef
            }, t3);
            $[4] = label;
            $[5] = t3;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    const t2 = shouldSkip ? null : bidiCharacter;
    let t3;
    if ($[7] !== bidiCharacter || $[8] !== t2 || $[9] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1b6f0b06c7576879$export$a592b67c93d52467), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, t2);
        $[7] = bidiCharacter;
        $[8] = t2;
        $[9] = testId;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : function BidiWarning({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: label,
        tag: $75f6060a0eba078d$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1b6f0b06c7576879$export$a592b67c93d52467), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1b6f0b06c7576879$export$a592b67c93d52467), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter);
};
var $75f6060a0eba078d$export$2e2bcd8739ae039 = $75f6060a0eba078d$var$BidiWarning;
const $75f6060a0eba078d$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let rest;
    if ($[0] !== props) {
        ({ children: children, ...rest } = props);
        $[0] = props;
        $[1] = children;
        $[2] = rest;
    } else {
        children = $[1];
        rest = $[2];
    }
    let t0;
    if ($[3] !== children || $[4] !== ref || $[5] !== rest) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
        $[3] = children;
        $[4] = ref;
        $[5] = rest;
        $[6] = t0;
    } else t0 = $[6];
    return t0;
} : (props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});
module.exports["default"] = $75f6060a0eba078d$export$2e2bcd8739ae039;

});

parcelRegister("cOjjv", function(module, exports) {
$parcel$export(module.exports, "default", () => $74055aca243263e6$export$2e2bcd8739ae039);

var $id6XS = parcelRequire("id6XS");

function $74055aca243263e6$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll((0, $id6XS.bidiCharacterRegex))
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("a5rDX", function(module, exports) {
const $86842ff0dedec441$export$8633a0edef8e95dd = 'emoji-common-selected';
const $86842ff0dedec441$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $86842ff0dedec441$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $86842ff0dedec441$export$b06c4aab1d012063 = 'emoji-common-node';
const $86842ff0dedec441$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $86842ff0dedec441$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $86842ff0dedec441$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $86842ff0dedec441$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $86842ff0dedec441$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $86842ff0dedec441$export$b0fe756d87022806 = 'emoji-picker-add-emoji';
module.exports["commonSelectedStyles"] = $86842ff0dedec441$export$8633a0edef8e95dd;
module.exports["selectOnHoverStyles"] = $86842ff0dedec441$export$860109dfd198259b;
module.exports["emojiSprite"] = $86842ff0dedec441$export$1c10634420a08d8a;
module.exports["emojiNodeStyles"] = $86842ff0dedec441$export$b06c4aab1d012063;
module.exports["emojiImage"] = $86842ff0dedec441$export$da61cef1c8919f7c;
module.exports["emojiDeleteButton"] = $86842ff0dedec441$export$b11fa39b56a371f6;
module.exports["emojiMainStyle"] = $86842ff0dedec441$export$11462c0756c24ab6;
module.exports["deletableEmoji"] = $86842ff0dedec441$export$22b19c311e9caa4;
module.exports["placeholder"] = $86842ff0dedec441$export$c7187bbd1a7a9244;
module.exports["emojiPickerAddEmoji"] = $86842ff0dedec441$export$b0fe756d87022806;

});

parcelRegister("iUTeb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jawC3 = parcelRequire("jawC3");


var $cMyWi = parcelRequire("cMyWi");


var $fxYwc = parcelRequire("fxYwc");

parcelRequire("kMzDv");
var $eEPSE = parcelRequire("eEPSE");


var $iDrrr = parcelRequire("iDrrr");


var $130CJ = parcelRequire("130CJ");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $aflIU = parcelRequire("aflIU");


var $jdqmT = parcelRequire("jdqmT");


var $2Q7sv = parcelRequire("2Q7sv");





var $kSwu1 = parcelRequire("kSwu1");


var $dM7c5 = parcelRequire("dM7c5");


var $aGLwK = parcelRequire("aGLwK");

/**
 * Smart Link flag module — imperative singleton pattern.
 *
 * ## Why not a React context provider?
 *
 * The natural approach would be to render a `<FlagProvider>` inside the Card
 * component tree, managing flag state via React context. This was the original
 * implementation. However, it caused a critical bug:
 *
 * When a parent component of smart card changed, either swap or unmount,
 * it unmounts the entire card subtree including `FlagsProvider`.
 * Any flag that was visible at that moment is instantly destroyed and lost.
 *
 * ## Why an injected React root?
 *
 * This module manages a persistent `FlagGroup` at `document.body` via its own
 * `createRoot` — completely independent of any card component tree. The root is created
 * lazily on the first `showFlag` call and kept alive indefinitely, re-rendering with
 * the current flags array on every change.
 *
 * Benefits:
 * - Flags survive any card unmount/remount cycle
 * - No provider needed anywhere in the component tree
 * - Works identically for all card paths (Card, CardSSR)
 * - Same pattern as `EmbedModal/utils.tsx` but for a persistent group
 *
 * Usage: import `showFlag` and call it directly — no provider needed.
 */ 



var $9kbTQ = parcelRequire("9kbTQ");


var $fRQ3t = parcelRequire("fRQ3t");





var $lqtHz = parcelRequire("lqtHz");


var $a2foB = parcelRequire("a2foB");





var $6PgB0 = parcelRequire("6PgB0");

const $97aafa98ab25c531$var$FLAG_GROUP_MOUNT_POINT_ID = 'smart-link-flags-mount';
// ---------------------------------------------------------------------------
// Module-level singleton state
// Lives for the entire page session — independent of any React component tree.
//
// The sequence:
// 1. ensureRoot()
//    └── flushSync(() => root.render(<empty FlagGroup>))
//        └── ExitingPersistence mounts with appear=false
//        └── pendingFirstRender = true
//
// 2. showFlag() detects pendingFirstRender=true
//    └── pendingFirstRender = false
//    └── setTimeout(0, () => renderToRoot())
//        ← deferred: runs AFTER useEffect fires
//
// 3. [async] ExitingPersistence's useEffect fires
//    └── appear flips false → true
//
// 4. [async] setTimeout(0) fires → renderToRoot()
//    └── FlagGroup receives flag as new child
//    └── ExitingPersistence sees new child with appear=true → ANIMATES
// ---------------------------------------------------------------------------
let $97aafa98ab25c531$var$flagGroupState = [];
let $97aafa98ab25c531$var$root = null;
// True after ensureRoot() creates a new root but before ExitingPersistence's useEffect
// has flipped `appear` to true. While pending, the first renderToRoot is deferred via
// setTimeout so that the enter animation fires correctly.
let $97aafa98ab25c531$var$pendingFirstRender = false;
const $97aafa98ab25c531$var$removeFlag = (id)=>{
    $97aafa98ab25c531$var$flagGroupState = $97aafa98ab25c531$var$flagGroupState.filter((f)=>f.id !== id);
    $97aafa98ab25c531$var$renderToRoot();
};
const $97aafa98ab25c531$var$renderToRoot = ()=>{
    if (!$97aafa98ab25c531$var$root) return;
    $97aafa98ab25c531$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
        onDismissed: $97aafa98ab25c531$var$removeFlag
    }, $97aafa98ab25c531$var$flagGroupState.map((flagProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6PgB0.default), {
            borderRadius: (0, $iDrrr.fg)('platform-dst-shape-theme-default') ? 'large' : 'small',
            isVisible: true,
            key: flagProps.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
            ...flagProps,
            key: flagProps.id
        }));
    }))));
};
const $97aafa98ab25c531$var$ensureRoot = ()=>{
    if ($97aafa98ab25c531$var$root !== null || typeof document === 'undefined') return;
    let container = document.getElementById($97aafa98ab25c531$var$FLAG_GROUP_MOUNT_POINT_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = $97aafa98ab25c531$var$FLAG_GROUP_MOUNT_POINT_ID;
        document.body.appendChild(container);
    }
    $97aafa98ab25c531$var$root = (0, $fRQ3t.createRoot)(container);
    const locale = typeof navigator !== 'undefined' ? navigator.language || 'en' : 'en';
    // Render an empty FlagGroup immediately so React has a "before" state to diff against.
    // Without this, the first flag has no previous render to compare to — React mounts it
    // directly and the FlagGroup animation library sees it as "already present" rather than
    // "just entered", skipping the slide-in animation.
    // Subsequent flags always have the previous (possibly empty) render to diff against,
    // which is why they animate correctly.
    const renderEmptyFlagGroup = ()=>$97aafa98ab25c531$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
            onDismissed: $97aafa98ab25c531$var$removeFlag
        })));
    // Use flushSync to synchronously commit an empty FlagGroup before any flag is added.
    // This mounts ExitingPersistence (inside FlagGroup) in an empty state so that when the
    // first flag arrives (deferred via setTimeout below), ExitingPersistence recognises it
    // as a genuinely new child and runs the slide-in animation.
    try {
        (0, $9kbTQ.flushSync)(renderEmptyFlagGroup);
    } catch  {
        // flushSync cannot be called during React rendering or from a lifecycle (e.g. useEffect).
        // We try it and fall back to a regular async render if React throws — in that case the
        // first flag may appear without a slide-in animation, but all subsequent flags will
        // animate correctly (ExitingPersistence will have mounted and flipped appear=true by then).
        renderEmptyFlagGroup();
    }
    // After flushSync commits the empty FlagGroup, ExitingPersistence's useEffect runs
    // asynchronously to flip `appear` from false → true (enabling enter animations).
    // We store a pending flag to signal that the first renderToRoot should be deferred.
    $97aafa98ab25c531$var$pendingFirstRender = true;
};
const $97aafa98ab25c531$export$e12b2cc6b75b006b = (options)=>{
    const flagProps = {
        ...options,
        id: options.id || crypto.randomUUID()
    };
    const index = $97aafa98ab25c531$var$flagGroupState.findIndex((f)=>f.id === flagProps.id);
    if (index === -1) $97aafa98ab25c531$var$flagGroupState = [
        flagProps,
        ...$97aafa98ab25c531$var$flagGroupState
    ];
    else $97aafa98ab25c531$var$flagGroupState = $97aafa98ab25c531$var$flagGroupState.map((f, i)=>i === index ? flagProps : f);
    $97aafa98ab25c531$var$ensureRoot();
    if ($97aafa98ab25c531$var$pendingFirstRender) {
        // ensureRoot() just created a new root and committed an empty FlagGroup via flushSync.
        // ExitingPersistence's useEffect (which flips `appear` false→true) runs asynchronously
        // after the commit. We defer renderToRoot via setTimeout(0) to ensure that useEffect
        // has already fired before the flag is added — only then will ExitingPersistence
        // treat it as a new entering child and run the slide-in animation.
        $97aafa98ab25c531$var$pendingFirstRender = false;
        setTimeout(()=>{
            $97aafa98ab25c531$var$renderToRoot();
        }, 0);
    } else $97aafa98ab25c531$var$renderToRoot();
};
const $97aafa98ab25c531$export$3dd8302481493c99 = ()=>{
    $97aafa98ab25c531$var$flagGroupState = [];
    $97aafa98ab25c531$var$pendingFirstRender = false;
    if ($97aafa98ab25c531$var$root) {
        $97aafa98ab25c531$var$root.unmount();
        $97aafa98ab25c531$var$root = null;
    }
    if (typeof document !== 'undefined') document.getElementById($97aafa98ab25c531$var$FLAG_GROUP_MOUNT_POINT_ID)?.remove();
};


const $e5cf0c53c5b9dc80$var$FLAG_ICON_SIZE = '16px';
const $e5cf0c53c5b9dc80$var$renderIcon = (iconUrlOrElement)=>{
    if (!iconUrlOrElement) return;
    const icon = iconUrlOrElement && typeof iconUrlOrElement === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aGLwK.default), {
        height: $e5cf0c53c5b9dc80$var$FLAG_ICON_SIZE,
        testId: "sl-flag",
        url: iconUrlOrElement,
        width: $e5cf0c53c5b9dc80$var$FLAG_ICON_SIZE
    }) : iconUrlOrElement;
    return icon;
};
// Safe wrapper — returns null if IntlProvider is not in the tree
const $e5cf0c53c5b9dc80$var$useIntlSafe = ()=>{
    try {
        return (0, $kSwu1.useIntl)();
    } catch  {
        return null;
    }
};
const $e5cf0c53c5b9dc80$var$useActionFlags = ()=>{
    const intl = $e5cf0c53c5b9dc80$var$useIntlSafe();
    const showConnectFlag = (0, $cozmU.useCallback)(({ provider: provider, ...flagArgs } = {})=>{
        if (!intl) return;
        const context = provider?.text ?? intl.formatMessage((0, $dM7c5.messages).connect_link_account_success_flag_title_default);
        (0, $97aafa98ab25c531$export$e12b2cc6b75b006b)({
            icon: $e5cf0c53c5b9dc80$var$renderIcon(provider?.icon),
            title: intl.formatMessage((0, $dM7c5.messages).connect_link_account_success_flag_title, {
                context: context
            }),
            description: intl.formatMessage((0, $dM7c5.messages).connect_link_account_success_flag_description),
            ...flagArgs
        });
    }, [
        intl
    ]);
    return (0, $cozmU.useMemo)(()=>({
            showConnectFlag: showConnectFlag
        }), [
        showConnectFlag
    ]);
};
var $e5cf0c53c5b9dc80$export$2e2bcd8739ae039 = $e5cf0c53c5b9dc80$var$useActionFlags;



var $kfxZm = parcelRequire("kfxZm");


var $cEvdy = parcelRequire("cEvdy");

const $63f934a66fbfa8fe$var$POST_AUTH_CHAT_EXTENSION_KEY = 'google-object-provider';
// Smart Card resolver key differs from the consumer-facing Rovo payload key.
const $63f934a66fbfa8fe$var$POST_AUTH_CHAT_PAYLOAD_EXTENSION_KEY = 'google-drive';
const $63f934a66fbfa8fe$var$SMART_LINK_3P_POST_AUTH_SOURCE = 'smart-link-3p-post-auth';
const $63f934a66fbfa8fe$var$getPostAuthChatPayloadId = ()=>{
    if (typeof crypto !== 'undefined') {
        if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
        if (typeof crypto.getRandomValues === 'function') {
            const values = new Uint32Array(4);
            crypto.getRandomValues(values);
            return `smart-link-post-auth-chat-${Array.from(values, (value)=>value.toString(16)).join('-')}`;
        }
    }
    return `smart-link-post-auth-chat-${Date.now()}`;
};
const $63f934a66fbfa8fe$var$sendPostAuthChatOpenMessage = (url, documentTitle)=>{
    if (typeof window === 'undefined' || typeof window.parent?.postMessage !== 'function') return;
    const payload = {
        type: 'chat-smartlink-3p-post-auth-launch',
        source: $63f934a66fbfa8fe$var$SMART_LINK_3P_POST_AUTH_SOURCE,
        openChat: true,
        openChatMode: 'mini-modal',
        data: {
            extensionKey: $63f934a66fbfa8fe$var$POST_AUTH_CHAT_PAYLOAD_EXTENSION_KEY,
            provider: 'Google Drive',
            projectContext: {
                projectId: url,
                projectName: documentTitle ?? 'Google Drive',
                projectUrl: url
            }
        }
    };
    window.parent.postMessage({
        eventType: (0, $130CJ.ROVO_POST_MESSAGE_EVENT_TYPE),
        payload: payload,
        payloadId: $63f934a66fbfa8fe$var$getPostAuthChatPayloadId()
    }, '*');
};
const $63f934a66fbfa8fe$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $cEvdy.default)();
    const invokeClientAction = (0, $kfxZm.default)({});
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const flags = (0, $e5cf0c53c5b9dc80$export$2e2bcd8739ae039)();
    const { store: store, rovoOptions: rovoOptions } = (0, $cMyWi.useSmartLinkContext)();
    const rovoOptionsRef = (0, $cozmU.useRef)(rovoOptions);
    rovoOptionsRef.current = rovoOptions;
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $cozmU.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $4yYAm.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $cozmU.useCallback)((metadataStatus)=>{
        dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    // Original resolve function — signature kept intact for maximum safety when FG is off.
    const resolve = (0, $cozmU.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl({
            url: resourceUrl,
            isReloading: isReloading,
            isMetadataRequest: isMetadataRequest,
            id: id
        }), [
        id,
        resolveUrl,
        url
    ]);
    // New resolve function accepting ResolveUrlParams (minus 'id' which is closed over).
    // Used when FG is enabled to pass appearance to ORS.
    const resolveNew = (0, $cozmU.useCallback)(async (params = {})=>{
        const { url: resourceUrl = url, isReloading: isReloading = false, isMetadataRequest: isMetadataRequest = false, appearance: appearance } = params;
        return resolveUrl({
            url: resourceUrl,
            isReloading: isReloading,
            isMetadataRequest: isMetadataRequest,
            id: id,
            appearance: appearance
        });
    }, [
        id,
        resolveUrl,
        url
    ]);
    /**
	 * Register a smart link for resolution.
	 * @param appearance - Card appearance hint for ORS to optimize response payload.
	 *                     When 'inline', ORS returns minimal data (title, status).
	 *                     When 'block' or 'embed', ORS returns full data including summary.
	 */ const register = (0, $cozmU.useCallback)((appearance)=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_RESOLVING), {
                url: url
            }));
            // Always set metadataStatus to 'pending' during registration to prevent
            // loadMetadata from firing a duplicate concurrent fetch if a hover card
            // mounts while registration is in-flight. This matches pre-PR behaviour.
            setMetadataStatus('pending');
        }
        if ((0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return resolveNew({
            url: url,
            appearance: appearance
        });
        return resolve(url);
    }, [
        getSmartLinkState,
        resolve,
        resolveNew,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $cozmU.useCallback)((appearance)=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $2Q7sv.getDefinitionId)(details);
        if ((0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) {
            if (definitionId) (0, $2Q7sv.getByDefinitionId)(definitionId, getState()).map((reloadUrl)=>resolveNew({
                    url: reloadUrl,
                    isReloading: true,
                    appearance: appearance
                }));
            else resolveNew({
                url: url,
                isReloading: true,
                appearance: appearance
            });
        } else if (definitionId) (0, $2Q7sv.getByDefinitionId)(definitionId, getState()).map((reloadUrl)=>resolve(reloadUrl, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve,
        resolveNew
    ]);
    /**
	 * Load metadata for hover card preview.
	 * This always requests 'block' appearance to get full data including summary.
	 *
	 * Inline optimized and SSR-resolved links keep metadataStatus pending until hover
	 * requests the full block response.
	 */ const loadMetadata = (0, $cozmU.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        const needsBlockData = metadataStatus === undefined || metadataStatus === 'pending' && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization');
        if (needsBlockData) {
            setMetadataStatus('pending');
            if ((0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) // Always request 'block' appearance for hover card metadata to get full data
            return resolveNew({
                url: url,
                isMetadataRequest: true,
                appearance: 'block'
            });
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        resolveNew,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $cozmU.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $2Q7sv.getDefinitionId)(details);
        const extensionKey = (0, $2Q7sv.getExtensionKey)(details);
        const isSupportedPostAuthChatExtensionKey = extensionKey === $63f934a66fbfa8fe$var$POST_AUTH_CHAT_EXTENSION_KEY;
        const services = (0, $2Q7sv.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $eEPSE.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $jdqmT.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                // Post-auth Chat onboarding: auto-open Rovo Chat mini-modal with the
                // authed 3P link as context, for supported providers (e.g. Google Drive).
                // Provider eligibility is derived from the pre-auth SmartLink state.
                const isEligibleForPostAuthChat = status === 'unauthorized' && isSupportedPostAuthChatExtensionKey && (0, $iDrrr.fg)('platform_sl_3p_post_auth_chat_open_fg') && (0, $aflIU.getIsRovoChatEnabled)(rovoOptionsRef.current);
                // Experiment check: fires exposure for both control and treatment.
                // Only reached after eligibility preconditions + kill switch pass, so
                // exposure is counted for the triggered eligible pool.
                const isPostAuthChatTreatment = isEligibleForPostAuthChat && (0, $ieeJu.expValEquals)('platform_sl_3p_post_auth_chat_open_exp', 'isEnabled', true);
                if (status === 'unauthorized' && !isPostAuthChatTreatment) {
                    const provider = (0, $jawC3.extractSmartLinkProvider)(details);
                    flags.showConnectFlag({
                        id: `smart-link-connect-success-${extensionKey}`,
                        provider: provider
                    });
                }
                reload();
                if (isPostAuthChatTreatment) $63f934a66fbfa8fe$var$sendPostAuthChatOpenMessage(url, (0, $jawC3.extractSmartLinkTitle)(details));
            }, (err)=>{
                (0, $jdqmT.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent,
        flags,
        url
    ]);
    const invoke = (0, $cozmU.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $cozmU.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};
module.exports["useSmartCardActions"] = $63f934a66fbfa8fe$export$f7c340395f31e832;

});

parcelRegister("2Q7sv", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $7c407c37ca6df037$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};


const $3839c1f5bef1a70a$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $3839c1f5bef1a70a$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $7c407c37ca6df037$export$c81497d3681f24f4)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $3839c1f5bef1a70a$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $3839c1f5bef1a70a$export$218d96312e385949 = (details)=>details?.meta?.key;
const $3839c1f5bef1a70a$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $3839c1f5bef1a70a$export$e029950864672b4 = (details)=>{
    if ((0, $iDrrr.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details?.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $3839c1f5bef1a70a$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $iDrrr.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $3839c1f5bef1a70a$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $3839c1f5bef1a70a$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $3839c1f5bef1a70a$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $3839c1f5bef1a70a$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $3839c1f5bef1a70a$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $3839c1f5bef1a70a$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $3839c1f5bef1a70a$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $3839c1f5bef1a70a$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $3839c1f5bef1a70a$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $3839c1f5bef1a70a$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $3839c1f5bef1a70a$export$ac5d414b1ebfab5a = (details)=>details && $3839c1f5bef1a70a$export$cd41ae544cfc2a65(details) && $3839c1f5bef1a70a$export$795910f5f15a9633(details);
const $3839c1f5bef1a70a$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $3839c1f5bef1a70a$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $3839c1f5bef1a70a$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $3839c1f5bef1a70a$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $3839c1f5bef1a70a$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $3839c1f5bef1a70a$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $3839c1f5bef1a70a$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $3839c1f5bef1a70a$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $3839c1f5bef1a70a$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $3839c1f5bef1a70a$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $3839c1f5bef1a70a$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $3839c1f5bef1a70a$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getByDefinitionId"] = $3839c1f5bef1a70a$export$f75b0b690ab4dfb9;
module.exports["getClickUrl"] = $3839c1f5bef1a70a$export$cf3c5acf9e9d0f02;
module.exports["getDefinitionId"] = $3839c1f5bef1a70a$export$46fa3e7718c82e41;
module.exports["getExtensionKey"] = $3839c1f5bef1a70a$export$218d96312e385949;
module.exports["getObjectAri"] = $3839c1f5bef1a70a$export$81164c1570bcd038;
module.exports["getThirdPartyARI"] = $3839c1f5bef1a70a$export$e029950864672b4;
module.exports["getFirstPartyIdentifier"] = $3839c1f5bef1a70a$export$48b4e58cdb8031ba;
module.exports["getObjectName"] = $3839c1f5bef1a70a$export$5615361d76a8be5;
module.exports["getObjectIconUrl"] = $3839c1f5bef1a70a$export$bcf275804417edda;
module.exports["getResourceType"] = $3839c1f5bef1a70a$export$16c0ebb0de9b767b;
module.exports["getServices"] = $3839c1f5bef1a70a$export$a009e3a1163d46fb;
module.exports["isFinalState"] = $3839c1f5bef1a70a$export$d590d08942abc17a;
module.exports["hasAuthScopeOverrides"] = $3839c1f5bef1a70a$export$3f9446bb21b945a0;

});

parcelRegister("6PgB0", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $IQ4Dz = parcelRequire("IQ4Dz");

/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 





/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.40.0 */ 





let $782284a537b3ed52$var$namespaceUUID = 0;
const $782284a537b3ed52$var$svgStyles = null;
const $782284a537b3ed52$var$blurredStyles = null;
const $782284a537b3ed52$var$notBlurredStyles = null; /**
                                * The bulk of this file is originally from
                                * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
                                * with modifications.
                                */ 
const $782284a537b3ed52$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $cozmU.useRef)(null);
    const namespaceId = (0, $cozmU.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $782284a537b3ed52$var$namespaceUUID;
        $782284a537b3ed52$var$namespaceUUID += 1;
    }
    (0, $cozmU.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current; // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ $cozmU.createElement("svg" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ $cozmU.createElement("defs", null, /*#__PURE__*/ $cozmU.createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $cozmU.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $cozmU.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $cozmU.createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $cozmU.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $cozmU.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $cozmU.createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $cozmU.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $cozmU.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $cozmU.createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $cozmU.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $cozmU.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $cozmU.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    }))), /*#__PURE__*/ $cozmU.createElement("g", {
        strokeWidth: "8"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    })));
};
var $782284a537b3ed52$export$2e2bcd8739ae039 = $782284a537b3ed52$var$AnimatedSvgContainer;


const $10998c9c5bce5e89$var$borderContainerStyles = null;
const $10998c9c5bce5e89$var$borderContentStyles = null; /**
                                   * The bulk of this file is originally from
                                   * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
                                   * with modifications.
                                   */ 
const $10998c9c5bce5e89$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $782284a537b3ed52$export$2e2bcd8739ae039), {
        palette: palette,
        isMoving: isMoving,
        className: className
    }), isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ $cozmU.createElement((0, $782284a537b3ed52$export$2e2bcd8739ae039), {
        palette: palette,
        isMoving: isMoving,
        isGlowing: true,
        className: className
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2rko1mok _16jlkb7n _1pbykb7n"
        ])
    }, children, " "));
var $10998c9c5bce5e89$export$2e2bcd8739ae039 = $10998c9c5bce5e89$var$AIGlowingBorder;


const $ac8328c8a6d542fb$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $ac8328c8a6d542fb$export$23b7b83c7063ccfe = {
    dark: {
        blue: $ac8328c8a6d542fb$export$3088ed82e2905d1e.blue800,
        teal: $ac8328c8a6d542fb$export$3088ed82e2905d1e.teal500,
        yellow: $ac8328c8a6d542fb$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $ac8328c8a6d542fb$export$3088ed82e2905d1e.blue600,
        teal: $ac8328c8a6d542fb$export$3088ed82e2905d1e.teal300,
        yellow: $ac8328c8a6d542fb$export$3088ed82e2905d1e.yellow200
    }
};


const $ce07e7de0e776e65$var$contentStyles = null;
const $ce07e7de0e776e65$var$contentStylesPrismVisible = null;
const $ce07e7de0e776e65$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $ce07e7de0e776e65$var$borderRadiusStyles = {
    large: "_2rko1mok",
    small: "_2rko12b0"
};
const $ce07e7de0e776e65$var$popupContainerStyles = null;
const $ce07e7de0e776e65$var$AIPrism = ({ borderRadius: borderRadius, children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ $cozmU.createElement((0, $10998c9c5bce5e89$export$2e2bcd8739ae039), {
        palette: (0, $ac8328c8a6d542fb$export$23b7b83c7063ccfe)[colorMode] ?? (0, $ac8328c8a6d542fb$export$23b7b83c7063ccfe).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $hekY6.default)([
            $ce07e7de0e776e65$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false'],
            borderRadius && $ce07e7de0e776e65$var$borderRadiusStyles[borderRadius]
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2rko1mok _bfhk1bhr _16qs130s",
            "_v5649spz",
            isVisible && "_16qs1aef"
        ])
    }, children));
};
var $ce07e7de0e776e65$export$2e2bcd8739ae039 = $ce07e7de0e776e65$var$AIPrism;
module.exports["default"] = $ce07e7de0e776e65$export$2e2bcd8739ae039;

});

parcelRegister("5C2uB", function(module, exports) {
const $f6d995b154f38e3a$export$15213acd7ac7d39a = (e)=>{
    return e.button === 1;
};
const $f6d995b154f38e3a$export$bd1e92a09497f497 = (event)=>{
    const currentTarget = event.currentTarget;
    if (!(currentTarget instanceof HTMLAnchorElement)) return {
        href: undefined,
        target: '_self'
    };
    return {
        href: currentTarget.href,
        target: currentTarget.target || '_self'
    };
};
const $f6d995b154f38e3a$export$9853bee72613d48f = (event, href)=>{
    if (!(event.currentTarget instanceof HTMLAnchorElement)) return;
    event.currentTarget.href = href;
};
module.exports["isAuxClick"] = $f6d995b154f38e3a$export$15213acd7ac7d39a;
module.exports["getAnchorAttributesFromEvent"] = $f6d995b154f38e3a$export$bd1e92a09497f497;
module.exports["updateAnchorHref"] = $f6d995b154f38e3a$export$9853bee72613d48f;

});

parcelRegister("19KQj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6GOAK = parcelRequire("6GOAK");

function $dc3ded826fe771fd$export$ed70996d478e16d3() {
    /**
   * this utility maybe extended in the future to include
   * more contextual info about SLs
   */ const events = (0, $cozmU.useMemo)(()=>new (0, $6GOAK.SmartLinkEvents)(), []);
    return events;
}
function $dc3ded826fe771fd$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return ({ isAuxClick: isAuxClick = false, isContextMenu: isContextMenu = false } = {})=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier,
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}
module.exports["useSmartLinkEvents"] = $dc3ded826fe771fd$export$ed70996d478e16d3;
module.exports["useFire3PWorkflowsClickEvent"] = $dc3ded826fe771fd$export$e682245dc886cff2;

});

parcelRegister("1F2YI", function(module, exports) {
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $8Ik5z = parcelRequire("8Ik5z");

const $cac14fb220f34f8a$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($8Ik5z)))();
$cac14fb220f34f8a$var$linkify.add('sourcetree:', 'http:');
$cac14fb220f34f8a$var$linkify.add('jamfselfservice:', 'http:');
$cac14fb220f34f8a$var$linkify.add('notes:', 'http:');
const $cac14fb220f34f8a$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $cac14fb220f34f8a$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$cac14fb220f34f8a$var$tlds.push($cac14fb220f34f8a$var$tlds2Char);
$cac14fb220f34f8a$var$linkify.tlds($cac14fb220f34f8a$var$tlds, false);
const $cac14fb220f34f8a$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $cac14fb220f34f8a$var$normaliseLinkHref = (url)=>{
    const match = $cac14fb220f34f8a$var$getLinkMatch(url);
    return match && match.url || null;
};
const $cac14fb220f34f8a$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $cac14fb220f34f8a$export$6f7d7761b97f967(str);
    if (!match.length) match = $cac14fb220f34f8a$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $cac14fb220f34f8a$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $cac14fb220f34f8a$export$6f7d7761b97f967 = (text)=>{
    const matches = [];
    if (!$cac14fb220f34f8a$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($cac14fb220f34f8a$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($cac14fb220f34f8a$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
        } else break;
    }
    return matches;
};
const $cac14fb220f34f8a$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $cac14fb220f34f8a$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $cac14fb220f34f8a$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($cac14fb220f34f8a$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $cac14fb220f34f8a$var$normaliseLinkHref(urlWithoutNewlines);
}
module.exports["isSafeUrl"] = $cac14fb220f34f8a$export$c9f92f5469372e0f;
module.exports["normalizeUrl"] = $cac14fb220f34f8a$export$6535eb414fa2c8b6;

});

parcelRegister("6FNab", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $4XbfY = parcelRequire("4XbfY");


var $3xuv0 = parcelRequire("3xuv0");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7b8d87d6fc11c85e$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $7b8d87d6fc11c85e$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.encode = void 0;
        const transformer = createTransformerWithSchema((0, $4XbfY.defaultSchema));
        this.encode = $7b8d87d6fc11c85e$var$createEncoder(transformer, new (0, $3xuv0.JSONTransformer)());
    }
}
const $7b8d87d6fc11c85e$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $7b8d87d6fc11c85e$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $7b8d87d6fc11c85e$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $7b8d87d6fc11c85e$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}
module.exports["ADFEncoder"] = $7b8d87d6fc11c85e$export$bcf771b83128eae7;
module.exports["getText"] = $7b8d87d6fc11c85e$export$c72d34660a162238;
module.exports["getEventHandler"] = $7b8d87d6fc11c85e$export$eee20638634729b3;
module.exports["findInTree"] = $7b8d87d6fc11c85e$export$38b61ebf4950cd39;

});

parcelRegister("FCr1g", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $gTPfK = parcelRequire("gTPfK");





var $gBjHb = parcelRequire("gBjHb");

const $0dac8e28bd4768d5$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};






var $i1t43 = parcelRequire("i1t43");


var $l1f3f = parcelRequire("l1f3f");

const $e65fa6f33c1f6a41$var$Anchor = (0, $l1f3f.withLinkClickedEvent)('a');
const $e65fa6f33c1f6a41$export$8c0773eab230d49e = (0, $l1f3f.withLinkClickedEvent)((0, $i1t43.default));
const $e65fa6f33c1f6a41$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $e65fa6f33c1f6a41$export$8c0773eab230d49e : $e65fa6f33c1f6a41$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $e65fa6f33c1f6a41$export$2e2bcd8739ae039 = $e65fa6f33c1f6a41$var$Hyperlink;






var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $2Q7sv = parcelRequire("2Q7sv");





var $kHija = parcelRequire("kHija");


var $6Vsq4 = parcelRequire("6Vsq4");


var $98Qqv = parcelRequire("98Qqv");


var $iUTeb = parcelRequire("iUTeb");





var $9H66G = parcelRequire("9H66G");

/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 


const $20ef44f951ebdbd7$var$batchQueue = new Map();
const $20ef44f951ebdbd7$var$batchTimeouts = new Map();
const $20ef44f951ebdbd7$var$BATCH_DELAY = 250;
const $20ef44f951ebdbd7$var$executeBatch = (hostname)=>{
    const items = $20ef44f951ebdbd7$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $20ef44f951ebdbd7$var$batchQueue.delete(hostname);
    $20ef44f951ebdbd7$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $20ef44f951ebdbd7$var$addToBatch = (hostname, item)=>{
    if (!$20ef44f951ebdbd7$var$batchQueue.has(hostname)) $20ef44f951ebdbd7$var$batchQueue.set(hostname, []);
    $20ef44f951ebdbd7$var$batchQueue.get(hostname).push(item);
    if ($20ef44f951ebdbd7$var$batchTimeouts.has(hostname)) clearTimeout($20ef44f951ebdbd7$var$batchTimeouts.get(hostname));
    $20ef44f951ebdbd7$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $20ef44f951ebdbd7$var$executeBatch(hostname);
    }, $20ef44f951ebdbd7$var$BATCH_DELAY));
};
const $20ef44f951ebdbd7$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $cozmU.useRef)(false);
    const scheduledRegister = (0, $cozmU.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $20ef44f951ebdbd7$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};


const $050418cc7e2bcf13$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $cozmU.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kHija)))());
    const state = (0, $9H66G.useSmartCardState)(href);
    const definitionId = (0, $2Q7sv.getDefinitionId)(state.details);
    const extensionKey = (0, $2Q7sv.getExtensionKey)(state.details);
    const resourceType = (0, $2Q7sv.getResourceType)(state.details);
    const actions = (0, $iUTeb.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $20ef44f951ebdbd7$export$db80d61271e4d5af)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $cozmU.useEffect)(()=>{
        $98Qqv.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $98Qqv.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.hyperlink.resolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                duration: $98Qqv.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError' && state.error?.name !== 'InvalidUrlError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $050418cc7e2bcf13$export$2e2bcd8739ae039 = $050418cc7e2bcf13$var$useResolveHyperlink;






var $cMyWi = parcelRequire("cMyWi");

const $28358ca6314c1f35$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $28358ca6314c1f35$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $28358ca6314c1f35$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};
const $28358ca6314c1f35$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    return hasSmartCardProvider && $28358ca6314c1f35$export$aa45d36a96427452(href);
};
var $28358ca6314c1f35$export$2e2bcd8739ae039 = $28358ca6314c1f35$var$useResolveHyperlinkValidator;



var $1smAh = parcelRequire("1smAh");


var $5C2uB = parcelRequire("5C2uB");







/**
 * HOC to wrap component with IntlProvider if not available
 */ const $e4973c7a2a00742d$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props);
        return props?.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: "en"
        }, content);
    };
var $e4973c7a2a00742d$export$2e2bcd8739ae039 = $e4973c7a2a00742d$var$withIntlProvider;



var $19KQj = parcelRequire("19KQj");


const $8c346d0f6a4e60f0$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT = 'linking_platform_track_non_primary_3p_clicks';
const $8c346d0f6a4e60f0$var$HyperlinkFallbackComponent = ()=>null;
const $8c346d0f6a4e60f0$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $28358ca6314c1f35$export$2e2bcd8739ae039)(props?.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1smAh.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DefaultComponent, props);
    };
const $8c346d0f6a4e60f0$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { state: state } = (0, $050418cc7e2bcf13$export$2e2bcd8739ae039)({
        href: props.href || ''
    });
    const thirdPartyARI = (0, $2Q7sv.getThirdPartyARI)(state?.details);
    const firstPartyIdentifier = (0, $2Q7sv.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $iDrrr.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $19KQj.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    // Shared scope guard for all 3P-click handlers.
    const shouldFire3PClickEvent = state?.status === 'resolved' && fire3PClickEvent && (0, $iDrrr.fg)('platform_smartlink_3pclick_analytics');
    const onClick = (0, $cozmU.useCallback)((e)=>{
        // button === 0 is left-click, see
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        if (shouldFire3PClickEvent && e?.button === 0) fire3PClickEvent?.();
        onClickCallback?.(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    // Fire experiment exposure once per surface mount, not on every re-render.
    (0, $cozmU.useEffect)(()=>{
        if (shouldFire3PClickEvent) (0, $ieeJu.expValEquals)($8c346d0f6a4e60f0$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT, 'isEnabled', true);
    }, [
        shouldFire3PClickEvent
    ]);
    const onAuxClick = (0, $cozmU.useCallback)((e)=>{
        // isAuxClick guards against Windows right-clicks firing onAuxClick with button === 2.
        if ((0, $5C2uB.isAuxClick)(e) && shouldFire3PClickEvent && (0, $anBbz.expValEqualsNoExposure)($8c346d0f6a4e60f0$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT, 'isEnabled', true)) fire3PClickEvent?.({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    const onContextMenu = (0, $cozmU.useCallback)((_e)=>{
        if (shouldFire3PClickEvent && (0, $anBbz.expValEqualsNoExposure)($8c346d0f6a4e60f0$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT, 'isEnabled', true)) fire3PClickEvent?.({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e65fa6f33c1f6a41$export$2e2bcd8739ae039), {
        ...props,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    });
};
const $8c346d0f6a4e60f0$export$1fdb4f77fe528a52 = (0, $9EOlJ.withErrorBoundary)($8c346d0f6a4e60f0$var$withValidator((0, $kSwu1.injectIntl)((0, $e4973c7a2a00742d$export$2e2bcd8739ae039)($8c346d0f6a4e60f0$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $e65fa6f33c1f6a41$export$2e2bcd8739ae039)), {
    FallbackComponent: $8c346d0f6a4e60f0$var$HyperlinkFallbackComponent
});


/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $hekY6 = parcelRequire("hekY6");





var $7ZB0A = parcelRequire("7ZB0A");





var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $dM7c5 = parcelRequire("dM7c5");

const $9f95697db7fee4b3$var$breakWordsCss = null;
const $9f95697db7fee4b3$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).check_this_link))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).go_back)), /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.IntlProvider), {
        locale: "en"
    }, content);
};
const $9f95697db7fee4b3$var$_default_1 = (0, $kSwu1.injectIntl)($9f95697db7fee4b3$var$WarningModal, {
    enforceContext: false
});
var $9f95697db7fee4b3$export$2e2bcd8739ae039 = $9f95697db7fee4b3$var$_default_1;






var $9DHhW = parcelRequire("9DHhW");


var $1F2YI = parcelRequire("1F2YI");


var $6GOAK = parcelRequire("6GOAK");

const $3eb490168d2cba0d$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $3eb490168d2cba0d$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $cozmU.useState)(null);
    const [url, setUrl] = (0, $cozmU.useState)(null);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
    };
    /**
   * It checks and warns if a link text is a URL and different from an actual link destination
   */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $1F2YI.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $3eb490168d2cba0d$var$toUrl(href, window.location.origin);
        const linkTextUrl = $3eb490168d2cba0d$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};


const $7e29c9d08f4780f4$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $7e29c9d08f4780f4$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    (0, $6cFsl.di)((0, $3eb490168d2cba0d$export$32b76c003683c2ec));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $3eb490168d2cba0d$export$32b76c003683c2ec)();
    const Link = enableResolve ? (0, $8c346d0f6a4e60f0$export$1fdb4f77fe528a52) : (0, $e65fa6f33c1f6a41$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0dac8e28bd4768d5$export$9458cdec663b9ff1), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Link, {
        href: href,
        testId: testId,
        isLinkComponent: isLinkComponent,
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f95697db7fee4b3$export$2e2bcd8739ae039), linkWarningModalProps));
};
const $7e29c9d08f4780f4$var$_default_1 = (0, $gTPfK.default)($7e29c9d08f4780f4$var$PACKAGE_DATA)($7e29c9d08f4780f4$var$LinkUrl);
var $7e29c9d08f4780f4$export$2e2bcd8739ae039 = $7e29c9d08f4780f4$var$_default_1;
module.exports["default"] = $7e29c9d08f4780f4$export$2e2bcd8739ae039;

});

parcelRegister("gIMcb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");

const $ebe9a636d79d68b7$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $ebe9a636d79d68b7$export$5bff351c86f56d97 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, clientConfig: clientConfig } = t0;
    let t1;
    if ($[0] !== clientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(clientConfig);
        $[0] = clientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    let t2;
    if ($[2] !== children || $[3] !== mediaClient) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebe9a636d79d68b7$export$ba5d7212f2b4619f.Provider, {
            value: mediaClient
        }, children);
        $[2] = children;
        $[3] = mediaClient;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebe9a636d79d68b7$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};
module.exports["MediaClientContext"] = $ebe9a636d79d68b7$export$ba5d7212f2b4619f;
module.exports["MediaClientProvider"] = $ebe9a636d79d68b7$export$5bff351c86f56d97;

});

parcelRegister("6C5HF", function(module, exports) {
/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $44324582d2e92be4$export$42c8d07e41ed1e74 = 'media-viewer-popup';
module.exports["mediaViewerPopupClass"] = $44324582d2e92be4$export$42c8d07e41ed1e74;

});

parcelRegister("cOUnF", function(module, exports) {
const $cc00aa0e6eb20f41$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $cc00aa0e6eb20f41$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';
module.exports["fileCardImageViewSelector"] = $cc00aa0e6eb20f41$export$7a6526d4be3b7eb3;

});

parcelRegister("i1LnN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $fYRS9 = parcelRequire("fYRS9");


var $cOjjv = parcelRequire("cOjjv");

const $34611ea31c23d1b7$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
}; /**
    * __Code__
    *
    * Code highlights short strings of code snippets inline with body text.
    *
    * - [Examples](https://atlassian.design/components/code/examples)
    * - [Code](https://atlassian.design/components/code/code)
    * - [Usage](https://atlassian.design/components/code/usage)
    */ 
const $34611ea31c23d1b7$var$Code = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Code(t0, ref) {
    const $ = (0, $bDgLe.c)(22);
    let props;
    let testId;
    if ($[0] !== t0) {
        ({ testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = testId;
    } else {
        props = $[1];
        testId = $[2];
    }
    let children;
    let codeBidiWarningLabel;
    let hasBidiWarnings;
    let isBidiWarningTooltipEnabled;
    let otherProps;
    let t1;
    let t2;
    if ($[3] !== props) {
        ({ children: children, codeBidiWarnings: t1, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: t2, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props);
        $[3] = props;
        $[4] = children;
        $[5] = codeBidiWarningLabel;
        $[6] = hasBidiWarnings;
        $[7] = isBidiWarningTooltipEnabled;
        $[8] = otherProps;
        $[9] = t1;
        $[10] = t2;
    } else {
        children = $[4];
        codeBidiWarningLabel = $[5];
        hasBidiWarnings = $[6];
        isBidiWarningTooltipEnabled = $[7];
        otherProps = $[8];
        t1 = $[9];
        t2 = $[10];
    }
    const codeBidiWarnings = t1 === undefined ? true : t1;
    const codeBidiWarningTooltipEnabled = t2 === undefined ? true : t2;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    let t3;
    if ($[11] !== children || $[12] !== codeBidiWarningLabel || $[13] !== shouldEnableTooltip || $[14] !== shouldShowBidiWarnings) {
        t3 = shouldShowBidiWarnings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34611ea31c23d1b7$var$RenderCodeChildrenWithBidiWarnings, {
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: shouldEnableTooltip
        }, children) : children;
        $[11] = children;
        $[12] = codeBidiWarningLabel;
        $[13] = shouldEnableTooltip;
        $[14] = shouldShowBidiWarnings;
        $[15] = t3;
    } else t3 = $[15];
    const decoratedChildren = t3;
    let t4;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $34611ea31c23d1b7$var$styles.base
        ]);
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== decoratedChildren || $[18] !== otherProps || $[19] !== ref || $[20] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("code", {
            ref: ref,
            "data-testid": testId,
            ...otherProps,
            className: t4
        }, decoratedChildren);
        $[17] = decoratedChildren;
        $[18] = otherProps;
        $[19] = ref;
        $[20] = testId;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
} : function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props; // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34611ea31c23d1b7$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip
    }, children) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $hekY6.default)([
            $34611ea31c23d1b7$var$styles.base
        ])
    }, decoratedChildren);
}));
const $34611ea31c23d1b7$var$RenderCodeChildrenWithBidiWarnings = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RenderCodeChildrenWithBidiWarnings(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled } = t0;
    let t1;
    if ($[0] !== children || $[1] !== codeBidiWarningLabel || $[2] !== codeBidiWarningTooltipEnabled) {
        let t2;
        if ($[4] !== codeBidiWarningLabel || $[5] !== codeBidiWarningTooltipEnabled) {
            t2 = (childNode)=>{
                if (typeof childNode === "string") {
                    const decorated = (0, $cOjjv.default)(childNode, (t3)=>{
                        const { bidiCharacter: bidiCharacter, index: index } = t3;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fYRS9.default), {
                            bidiCharacter: bidiCharacter,
                            key: index,
                            label: codeBidiWarningLabel,
                            tooltipEnabled: codeBidiWarningTooltipEnabled
                        });
                    });
                    return decorated;
                }
                if ($34611ea31c23d1b7$var$isReactElement(childNode) && childNode.props.children) {
                    const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(childNode, {
                        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RenderCodeChildrenWithBidiWarnings, {
                            codeBidiWarningLabel: codeBidiWarningLabel,
                            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                        }, childNode.props.children)
                    });
                    return newChildNode;
                }
                return childNode;
            };
            $[4] = codeBidiWarningLabel;
            $[5] = codeBidiWarningTooltipEnabled;
            $[6] = t2;
        } else t2 = $[6];
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, t2);
        $[0] = children;
        $[1] = codeBidiWarningLabel;
        $[2] = codeBidiWarningTooltipEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const replacedChildren = t1;
    let t2;
    if ($[7] !== replacedChildren) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, replacedChildren);
        $[7] = replacedChildren;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $cOjjv.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fYRS9.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        if ($34611ea31c23d1b7$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, replacedChildren);
};
function $34611ea31c23d1b7$var$isReactElement(child) {
    return !!child.type;
}
$34611ea31c23d1b7$var$Code.displayName = 'Code';
var $34611ea31c23d1b7$export$2e2bcd8739ae039 = $34611ea31c23d1b7$var$Code;
module.exports["default"] = $34611ea31c23d1b7$export$2e2bcd8739ae039;

});

parcelRegister("4EPzQ", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

function $fad66bc63e25ea6c$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $jTt8P.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}
module.exports["reduce"] = $fad66bc63e25ea6c$export$533b26079ad0b4b;

});

parcelRegister("dj8DL", function(module, exports) {
const $5be3cab32e5f54a5$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $5be3cab32e5f54a5$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
module.exports["createPMNodeSpecFactory"] = $5be3cab32e5f54a5$export$bf0a80f00e2b8ff6;
module.exports["createPMMarkSpecFactory"] = $5be3cab32e5f54a5$export$cf5823ed4e9f4c6f;

});

parcelRegister("472n0", function(module, exports) {
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $dj8DL = parcelRequire("dj8DL");

const $86fc5d01d511e227$export$c4c2f833baaebdb8 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $86fc5d01d511e227$export$67dc04e652a298ca = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $86fc5d01d511e227$export$199922e5af8e9a6 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $86fc5d01d511e227$export$16018c61064a18df = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$27903d543b563e39 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $86fc5d01d511e227$export$e7320d153c538837 = (0, $dj8DL.createPMNodeSpecFactory)({
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $86fc5d01d511e227$export$e92c7e4302dd4371 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel | panel_c1 | rule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
const $86fc5d01d511e227$export$a140c94e5ea26bee = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$8e3c2dfdc4f0453d = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $86fc5d01d511e227$export$7bb0d5c671655cc4 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $86fc5d01d511e227$export$e4f1c66d84049f8b = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $86fc5d01d511e227$export$daf889beb5092f95 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$e6e4878f43c27cab = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$3e6d667072febc87 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$324d90190a8b822a = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$47988d68fe575725 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$6959e16eeff859b4 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $86fc5d01d511e227$export$62d45a65fb43d95e = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$2a111da947c407d2 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(block | codeBlock | panel | rule | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment breakout'
});
const $86fc5d01d511e227$export$be4283d9a1cb1ff6 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$a19185d1233fc4b2 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$f5574b5d45fc2112 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$9f77e0932fb78f72 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $86fc5d01d511e227$export$7e3788972005cc72 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $86fc5d01d511e227$export$1b45514b112dd749 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$a8baf338431a691 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$b555be60c7703afb = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $86fc5d01d511e227$export$371da9dd35aba193 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $86fc5d01d511e227$export$46e4a324ac90507f = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$1b0c1557b234fa00 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$85461f751c457cc2 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$2b380a0f7e250af1 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$5c452ff88e35e47d = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $86fc5d01d511e227$export$cbf8224b64e0d942 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $86fc5d01d511e227$export$2f4e72b9459914ad = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $86fc5d01d511e227$export$16b353b2649bd8d9 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$b3b1e36c2105006d = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$ab76e7c03cd6f650 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $86fc5d01d511e227$export$b3b6a70a7fa4a5be = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $86fc5d01d511e227$export$cdae19acb0a520fd = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $86fc5d01d511e227$export$206007566ca0aca5 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
const $86fc5d01d511e227$export$76c7e83ecc9cdf05 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$987d49ffe1b0900f = (0, $dj8DL.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$2855e964765eac9 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $86fc5d01d511e227$export$38bab695e3f720f1 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$969fe3781ca15058 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $86fc5d01d511e227$export$8d067f22dc2d1254 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$7e767666f2ce108a = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$4bd9a38995f6bf50 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$db83999c14438df4 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$46f790bd65f760d0 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$750e45819f66d9d0 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $86fc5d01d511e227$export$63cadbf5f4296627 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $86fc5d01d511e227$export$f03786aa6312d1e4 = (0, $dj8DL.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $86fc5d01d511e227$export$a5dc81035676e7a = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$21f42ab9b6679f44 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$63a5585d8a5426ad = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$7eb9416336a42c2b = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$9c206ddddb32a9b = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$4f98472e6dc14293 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$b0710a201beac6b2 = (0, $dj8DL.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$ea332b61641b0588 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$a1f41dc4901771f8 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$c7187bbd1a7a9244 = (0, $dj8DL.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$fbeb3a3956e8a3c7 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$1d53b70195c9c417 = (0, $dj8DL.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$471f7ae5c4103ae1 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$b6ce52be8d7a261 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$faab0ca9701d7048 = (0, $dj8DL.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$9852986a3ec5f6a0 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $86fc5d01d511e227$export$ce086a560a1d05f5 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $86fc5d01d511e227$export$e1e720e5f4603e6a = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $86fc5d01d511e227$export$abf39ca178940ff3 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $86fc5d01d511e227$export$48884d2a5190dc73 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $86fc5d01d511e227$export$2a5a518232fa1a97 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $86fc5d01d511e227$export$ce666bf02318c957 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $86fc5d01d511e227$export$7d657479499397 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $86fc5d01d511e227$export$6d8b0ef52e2e6390 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$375b6afcc5f4d291 = (0, $dj8DL.createPMNodeSpecFactory)({
    content: '(taskItem | taskList | unsupportedBlock | blockTaskItem)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$6f093cfa640b7166 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline'
});
const $86fc5d01d511e227$export$5ea06bc686c59dc2 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline'
});
const $86fc5d01d511e227$export$93256a4c17b33a82 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline'
});
const $86fc5d01d511e227$export$a12828d0f14a2762 = (0, $dj8DL.createPMNodeSpecFactory)({});
const $86fc5d01d511e227$export$44b79b0979d0f0f7 = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$310ebe0d80122e9b = (0, $dj8DL.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
module.exports["blockCard"] = $86fc5d01d511e227$export$c4c2f833baaebdb8;
module.exports["blockquote"] = $86fc5d01d511e227$export$67dc04e652a298ca;
module.exports["blockquoteLegacy"] = $86fc5d01d511e227$export$199922e5af8e9a6;
module.exports["blockTaskItem"] = $86fc5d01d511e227$export$16018c61064a18df;
module.exports["bodiedExtension"] = $86fc5d01d511e227$export$27903d543b563e39;
module.exports["bodiedSyncBlock"] = $86fc5d01d511e227$export$e92c7e4302dd4371;
module.exports["bulletList"] = $86fc5d01d511e227$export$a140c94e5ea26bee;
module.exports["caption"] = $86fc5d01d511e227$export$8e3c2dfdc4f0453d;
module.exports["codeBlock"] = $86fc5d01d511e227$export$7bb0d5c671655cc4;
module.exports["confluenceJiraIssue"] = $86fc5d01d511e227$export$daf889beb5092f95;
module.exports["confluenceUnsupportedBlock"] = $86fc5d01d511e227$export$e6e4878f43c27cab;
module.exports["confluenceUnsupportedInline"] = $86fc5d01d511e227$export$3e6d667072febc87;
module.exports["date"] = $86fc5d01d511e227$export$324d90190a8b822a;
module.exports["decisionItem"] = $86fc5d01d511e227$export$6959e16eeff859b4;
module.exports["decisionList"] = $86fc5d01d511e227$export$62d45a65fb43d95e;
module.exports["doc"] = $86fc5d01d511e227$export$2a111da947c407d2;
module.exports["embedCard"] = $86fc5d01d511e227$export$be4283d9a1cb1ff6;
module.exports["emoji"] = $86fc5d01d511e227$export$a19185d1233fc4b2;
module.exports["expand"] = $86fc5d01d511e227$export$9f77e0932fb78f72;
module.exports["extension"] = $86fc5d01d511e227$export$1b45514b112dd749;
module.exports["extensionFrameStage0"] = $86fc5d01d511e227$export$b555be60c7703afb;
module.exports["hardBreak"] = $86fc5d01d511e227$export$371da9dd35aba193;
module.exports["heading"] = $86fc5d01d511e227$export$46e4a324ac90507f;
module.exports["image"] = $86fc5d01d511e227$export$5c452ff88e35e47d;
module.exports["inlineCard"] = $86fc5d01d511e227$export$cbf8224b64e0d942;
module.exports["inlineExtensionWithMarks"] = $86fc5d01d511e227$export$b3b1e36c2105006d;
module.exports["layoutColumn"] = $86fc5d01d511e227$export$ab76e7c03cd6f650;
module.exports["layoutSection"] = $86fc5d01d511e227$export$b3b6a70a7fa4a5be;
module.exports["layoutSectionFull"] = $86fc5d01d511e227$export$cdae19acb0a520fd;
module.exports["layoutSectionWithSingleColumnStage0"] = $86fc5d01d511e227$export$206007566ca0aca5;
module.exports["listItem"] = $86fc5d01d511e227$export$76c7e83ecc9cdf05;
module.exports["media"] = $86fc5d01d511e227$export$987d49ffe1b0900f;
module.exports["mediaGroup"] = $86fc5d01d511e227$export$2855e964765eac9;
module.exports["mediaInline"] = $86fc5d01d511e227$export$38bab695e3f720f1;
module.exports["mediaSingle"] = $86fc5d01d511e227$export$969fe3781ca15058;
module.exports["mediaSingleCaption"] = $86fc5d01d511e227$export$8d067f22dc2d1254;
module.exports["mediaSingleFull"] = $86fc5d01d511e227$export$7e767666f2ce108a;
module.exports["mediaSingleWidthType"] = $86fc5d01d511e227$export$4bd9a38995f6bf50;
module.exports["mention"] = $86fc5d01d511e227$export$db83999c14438df4;
module.exports["multiBodiedExtensionStage0"] = $86fc5d01d511e227$export$750e45819f66d9d0;
module.exports["nestedExpand"] = $86fc5d01d511e227$export$63cadbf5f4296627;
module.exports["orderedList"] = $86fc5d01d511e227$export$a5dc81035676e7a;
module.exports["panel"] = $86fc5d01d511e227$export$21f42ab9b6679f44;
module.exports["panelC1"] = $86fc5d01d511e227$export$63a5585d8a5426ad;
module.exports["paragraph"] = $86fc5d01d511e227$export$9c206ddddb32a9b;
module.exports["placeholder"] = $86fc5d01d511e227$export$c7187bbd1a7a9244;
module.exports["rule"] = $86fc5d01d511e227$export$fbeb3a3956e8a3c7;
module.exports["status"] = $86fc5d01d511e227$export$471f7ae5c4103ae1;
module.exports["syncBlock"] = $86fc5d01d511e227$export$faab0ca9701d7048;
module.exports["table"] = $86fc5d01d511e227$export$9852986a3ec5f6a0;
module.exports["tableWithNestedTable"] = $86fc5d01d511e227$export$ce086a560a1d05f5;
module.exports["tableCell"] = $86fc5d01d511e227$export$e1e720e5f4603e6a;
module.exports["tableCellWithNestedTable"] = $86fc5d01d511e227$export$abf39ca178940ff3;
module.exports["tableHeader"] = $86fc5d01d511e227$export$48884d2a5190dc73;
module.exports["tableHeaderWithNestedTable"] = $86fc5d01d511e227$export$2a5a518232fa1a97;
module.exports["tableRow"] = $86fc5d01d511e227$export$ce666bf02318c957;
module.exports["tableRowWithNestedTable"] = $86fc5d01d511e227$export$7d657479499397;
module.exports["taskItem"] = $86fc5d01d511e227$export$6d8b0ef52e2e6390;
module.exports["taskList"] = $86fc5d01d511e227$export$375b6afcc5f4d291;
module.exports["text"] = $86fc5d01d511e227$export$6f093cfa640b7166;
module.exports["unsupportedBlock"] = $86fc5d01d511e227$export$44b79b0979d0f0f7;
module.exports["unsupportedInline"] = $86fc5d01d511e227$export$310ebe0d80122e9b;

});

parcelRegister("hFHBb", function(module, exports) {
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $dj8DL = parcelRequire("dj8DL");

const $7ef1b2cdfcc0b909$export$8e53000a4ec837 = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $7ef1b2cdfcc0b909$export$8512c9afa7b24c3b = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $7ef1b2cdfcc0b909$export$8c5a050822fd698c = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $7ef1b2cdfcc0b909$export$1edee58a52776cd9 = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $7ef1b2cdfcc0b909$export$89015c65f1c75e3f = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $7ef1b2cdfcc0b909$export$6565f9f03506010b = (0, $dj8DL.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $7ef1b2cdfcc0b909$export$f3b72f8fc4684ecd = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $7ef1b2cdfcc0b909$export$3024f02c495408d6 = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $7ef1b2cdfcc0b909$export$c63c6f932822f543 = (0, $dj8DL.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $7ef1b2cdfcc0b909$export$85e3c3ca0c6fb93 = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        fontSize: {}
    }
});
const $7ef1b2cdfcc0b909$export$f00aeb236b6f05af = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $7ef1b2cdfcc0b909$export$480c699bd4ec0d86 = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $7ef1b2cdfcc0b909$export$9c30223ca0a664fb = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $7ef1b2cdfcc0b909$export$4899a95d70ec5056 = (0, $dj8DL.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $7ef1b2cdfcc0b909$export$59ae2c325a998f89 = (0, $dj8DL.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $7ef1b2cdfcc0b909$export$b3401ee80eb31041 = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $7ef1b2cdfcc0b909$export$32f78bffcd82ff28 = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $7ef1b2cdfcc0b909$export$20af3dabbb5538df = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $7ef1b2cdfcc0b909$export$425327af25286e5e = (0, $dj8DL.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $7ef1b2cdfcc0b909$export$30d78d5eb6719bb8 = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $7ef1b2cdfcc0b909$export$a316dc07ff5182a2 = (0, $dj8DL.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});
module.exports["alignment"] = $7ef1b2cdfcc0b909$export$8e53000a4ec837;
module.exports["annotation"] = $7ef1b2cdfcc0b909$export$8512c9afa7b24c3b;
module.exports["backgroundColor"] = $7ef1b2cdfcc0b909$export$8c5a050822fd698c;
module.exports["border"] = $7ef1b2cdfcc0b909$export$1edee58a52776cd9;
module.exports["breakout"] = $7ef1b2cdfcc0b909$export$89015c65f1c75e3f;
module.exports["code"] = $7ef1b2cdfcc0b909$export$6565f9f03506010b;
module.exports["confluenceInlineComment"] = $7ef1b2cdfcc0b909$export$f3b72f8fc4684ecd;
module.exports["dataConsumer"] = $7ef1b2cdfcc0b909$export$3024f02c495408d6;
module.exports["em"] = $7ef1b2cdfcc0b909$export$c63c6f932822f543;
module.exports["fontSize"] = $7ef1b2cdfcc0b909$export$85e3c3ca0c6fb93;
module.exports["fragment"] = $7ef1b2cdfcc0b909$export$f00aeb236b6f05af;
module.exports["indentation"] = $7ef1b2cdfcc0b909$export$480c699bd4ec0d86;
module.exports["link"] = $7ef1b2cdfcc0b909$export$9c30223ca0a664fb;
module.exports["strike"] = $7ef1b2cdfcc0b909$export$4899a95d70ec5056;
module.exports["strong"] = $7ef1b2cdfcc0b909$export$59ae2c325a998f89;
module.exports["subsup"] = $7ef1b2cdfcc0b909$export$b3401ee80eb31041;
module.exports["textColor"] = $7ef1b2cdfcc0b909$export$32f78bffcd82ff28;
module.exports["typeAheadQuery"] = $7ef1b2cdfcc0b909$export$20af3dabbb5538df;
module.exports["underline"] = $7ef1b2cdfcc0b909$export$425327af25286e5e;
module.exports["unsupportedMark"] = $7ef1b2cdfcc0b909$export$30d78d5eb6719bb8;
module.exports["unsupportedNodeAttribute"] = $7ef1b2cdfcc0b909$export$a316dc07ff5182a2;

});

parcelRegister("kaBfx", function(module, exports) {
const $7ac981e68e99ad7b$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
module.exports["isDOMElement"] = $7ac981e68e99ad7b$export$c296e2d4365c37a5;

});

parcelRegister("4jl6R", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");

function $d046b5e050a6be1d$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $d046b5e050a6be1d$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $d046b5e050a6be1d$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $d046b5e050a6be1d$export$9c2f408d391feb93(hexColor) {
    const normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return normalizedHexColor ? $d046b5e050a6be1d$export$57fa5089caad992[normalizedHexColor] : undefined;
}
const $d046b5e050a6be1d$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)',
    /** lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** lime - medium */ '#6A9A23': 'var(--ds-icon-accent-lime, #6A9A23)',
    /** lime - strong */ '#4C6B1F': 'var(--ds-text-accent-lime, #4C6B1F)',
    /** orange - light */ '#FCE4A6': 'var(--ds-background-accent-orange-subtler, #FCE4A6)',
    /** orange - medium */ '#E06C00': 'var(--ds-icon-accent-orange, #E06C00)',
    /** orange - strong */ '#9E4C00': 'var(--ds-text-accent-orange, #9E4C00)',
    /** magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** magenta - medium */ '#CD519D': 'var(--ds-icon-accent-magenta, #CD519D)',
    /** magenta - strong */ '#943D73': 'var(--ds-text-accent-magenta, #943D73)',
    /** yellow - medium */ get ['#B38600'] () {
        return (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') ? 'var(--ds-border-accent-yellow, #B38600)' : 'var(--ds-icon-accent-yellow, #B38600)';
    },
    /** yellow - strong */ '#7F5F01': 'var(--ds-text-accent-yellow, #7F5F01)'
};
function $d046b5e050a6be1d$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $d046b5e050a6be1d$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $d046b5e050a6be1d$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Red - light */ '#FFD5D2': 'var(--ds-background-accent-red-subtler, #FFD5D2)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)',
    /** Blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** Green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)'
};
function $d046b5e050a6be1d$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = hexColor ? $d046b5e050a6be1d$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $d046b5e050a6be1d$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};
module.exports["hexToEditorBorderPaletteColor"] = $d046b5e050a6be1d$export$bad3c41dd33cb4bc;
module.exports["hexToEditorTextPaletteColor"] = $d046b5e050a6be1d$export$9c2f408d391feb93;
module.exports["hexToEditorTextBackgroundPaletteColor"] = $d046b5e050a6be1d$export$8b58ff1b36bb75e0;
module.exports["hexToEditorBackgroundPaletteRawValue"] = $d046b5e050a6be1d$export$a270511a0e7fd61a;

});

parcelRegister("4qeZw", function(module, exports) {
const $ab7879bf35bbacc9$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $ab7879bf35bbacc9$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $ab7879bf35bbacc9$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};
module.exports["getExtensionAttrs"] = $ab7879bf35bbacc9$export$1765e2758fc47004;

});

parcelRegister("mrh47", function(module, exports) {
const $d968219d294f7bd4$export$80408efb85c33a7a = (raw)=>{
    switch(raw){
        case 'top':
        case 'middle':
        case 'bottom':
            return raw;
        default:
            return undefined;
    }
};
module.exports["parseValign"] = $d968219d294f7bd4$export$80408efb85c33a7a;

});

parcelRegister("id6XS", function(module, exports) {
const $ee2ba9e96e536e80$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
module.exports["bidiCharacterRegex"] = $ee2ba9e96e536e80$export$ecb256e6a1f5ee7e;

});


$parcel$global.rlb("fGW6H")
//# sourceMappingURL=custom-theme.6c641492.js.map
